{
    "loading": "Wird geladen...",
    "yes": "Ja",
    "no": "Nein",
    "cancel": "Abbrechen",
    "validate": "Bestätigen",
    "edit": "Bearbeiten",
    "close": "Schließen",
    "retry": "Erneut versuchen",
    "details": "Details",
    "total": "Total",
    "hours": "Stunden",
    "minutes": "Minuten",
    "home": "Startseite",
    "next": "Weiter",
    "save": "Speichern",
    "know_more": "Mehr erfahren",
    "interval": "Vom %{from} bis %{to}",
    "absences": "Abwesenheiten",
    "no_network": "Verbindung unterbrochen",
    "network_will_reconnect": "Ihre Internetverbindung wurde unterbrochen.\n\nDie App stellt die Verbindung automatisch wieder her, sobald sie verfügbar ist.",
    "heure": {
        "zero": "Keine Stunde",
        "one": "1 Stunde",
        "other": "{{count}} Stunden"
    },
    "education_level": {
        "uni_epf": "Universität oder ETH",
        "hes_hep": "Fachhochschule (FH)",
        "high_school": "Höhere Berufsbildung",
        "teaching_certificate": "Lehrdiplom",
        "baccalaureate": "Eidgenössische Maturität",
        "cfc": "Abgeschlossene Berufslehre (EFZ)",
        "in_company": "Betriebsinterne Ausbildung",
        "without": "Ohne abgeschlossene Berufsausbildung"
    },
    "work_permit": {
        "permit_b": "Aufenthaltsbewilligung B",
        "permit_c": "Niederlassungsbewilligung C",
        "permit_g": "Grenzgängerbewilligung G",
        "permit_l": "Kurzaufenthaltsbewilligung L",
        "permit_n": "Ausweis N (Asylsuchende)",
        "permit_s": "Ausweis S (Schutzstatus)",
        "permit_other": "Andere Bewilligung",
        "in_process": "In Bearbeitung",
        "permit_f": "Ausweis F (vorläufig aufgenommene Ausländer)",
        "permit_ci": "Ausweis Ci (Familienangehörige von Mitarbeitenden internationaler Organisationen)"
    },
    "documentType": {
        "companyPolicy": "Betriebsreglement",
        "experience": "Diplom oder Zertifikat",
        "profilePicture": "Profilbild",
        "workPermit": "Aufenthaltsbewilligung"
    },
    "civility": {
        "female": "Frau",
        "male": "Herr"
    },
    "errors": {
        "unknown_error": "Ein unbekannter Fehler ist aufgetreten. Unser Team wird den Vorfall prüfen.",
        "mission_not_found": "Der Arbeitsvertrag existiert nicht!",
        "asset_error": "Bei der Erstellung des Inhalts ist ein Fehler aufgetreten.",
        "save_failed": "Speichern fehlgeschlagen.",
        "field_name": {
            "email": "Diese E-Mail-Adresse ist ungültig.",
            "phoneNumber": "Diese Telefonnummer ist ungültig.",
            "avs_number": "AHV-Nummer (bereits verwendet)"
        },
        "avs_number": "Die AHV-Nummer ist ungültig.",
        "pagination_error": "Fehler beim Laden der Daten",
        "geolocation_denied": "Der Zugriff auf den Standort wurde blockiert. Sie können ihn jederzeit in den Einstellungen aktivieren.",
        "saving": "Beim Speichern der Daten ist ein Fehler aufgetreten.",
        "numberMin": "Muss größer oder gleich {{min}} sein",
        "numberMax": "Muss kleiner oder gleich {{max}} sein"
    },
    "mesoneer": {
        "status_info": {
            "confirmed": "Ihre Identität ist bereits bestätigt.\n[Zurück zur Startseite](Home)",
            "pending": "Ihre Identität wurde noch nicht bestätigt, bitte haben Sie noch etwas Geduld.",
            "rejected": "Ihre Identitätsprüfung wurde nicht akzeptiert. Bitte kontaktieren Sie uns für weitere Informationen.",
            "failed": "Die Identitätsprüfung ist fehlgeschlagen. Bitte kontaktieren Sie uns für weitere Informationen.",
            "timeout": "Ihre Identität wurde nicht innerhalb der vorgesehenen Frist bestätigt. Bitte kontaktieren Sie uns für weitere Informationen.",
            "not_required": "Die Identitätsprüfung ist nicht erforderlich.",
            "deleted": "Ihre Identität wurde gelöscht. Bitte kontaktieren Sie uns für weitere Informationen.",
            "corrupted": "Die Daten Ihrer Identitätsprüfung sind beschädigt. Bitte kontaktieren Sie uns, damit wir Ihnen helfen können.",
            "success": "Ihre Identität wurde bereits bestätigt.\n[Zurück zur Startseite](Home)",
            "unknown": "Ein Problem ist aufgetreten. Bitte kontaktieren Sie uns, damit wir es gemeinsam lösen können."
        }
    },
    "user": {
        "email": "E-Mail",
        "first_name": "Vorname",
        "last_name": "Nachname",
        "address": "Adresse",
        "birthdate": "Geburtsdatum",
        "phone": "Telefon",
        "gender": "Anrede",
        "gender_male": "Mann",
        "gender_female": "Frau",
        "gender_unknown": "Unbekannt",
        "marital_status": "Zivilstand",
        "single": "Ledig",
        "married": "Verheiratet",
        "divorced": "Geschieden",
        "widowed": "Verwitwet",
        "separated": "Getrennt",
        "registered_partnership": "Eingetragene Partnerschaft",
        "marital_status_from": "Seit dem",
        "need_email_validation": "Ihre E-Mail-Adresse wurde noch nicht bestätigt.",
        "errors": {
            "first_name": "Der Vorname ist erforderlich.",
            "last_name": "Der Nachname ist erforderlich.",
            "email": "Die E-Mail-Adresse ist erforderlich.",
            "birthdate": "Das Geburtsdatum ist ungültig.",
            "address": "Die Adresse ist erforderlich.",
            "save": "Beim Speichern Ihrer Angaben ist ein Fehler aufgetreten.",
            "birthdate_18yo": "Das Mindestalter beträgt 18 Jahre.",
            "not_permit_c": "Eine Niederlassungsbewilligung C oder ein Schweizer Pass ist erforderlich.",
            "name_missing": "Der Name ist erforderlich.",
            "name_too_short": "Der Name ist zu kurz.",
            "name_too_long": "Der Name ist zu lang.",
            "name_bad_character": "Der Name enthält ungültige Zeichen."
        },
        "actions": {
            "edit_user": "Mein Profil bearbeiten",
            "lpp_to_complete": "Vorsorgeplan (auszufüllen)",
            "lpp": "Vorsorgeplan"
        },
        "residential_address": "Wohnadresse",
        "gender_kid_male": "Junge",
        "gender_kid_female": "Mädchen",
        "married_with_x_revenues": {
            "zero": "",
            "one": "Verheiratet, mit 1 Einkommen",
            "other": "Verheiratet, mit %{count} Einkommen"
        },
        "business_email_info": "Ihre geschäftliche E-Mail-Adresse",
        "business_email_need_validation": "Ihre E-Mail-Adresse wurde noch nicht bestätigt.",
        "birth_year": "Geburtsjahr",
        "business_email_verification_banner": "Wir haben Ihnen eine E-Mail zur Bestätigung Ihrer E-Mail-Adresse gesendet. Klicken Sie auf die Schaltfläche in der Nachricht, um Ihre Adresse zu bestätigen."
    },
    "profile": {
        "personal_info": "Persönliche Informationen",
        "change_profile_picture": "Foto ändern",
        "client_list": "Meine Arbeitgeber",
        "edit": "Bearbeiten",
        "user_account": "Konto",
        "logout": "Abmelden",
        "logout_title": "Abmeldung",
        "logout_description": "Sind Sie sicher, dass Sie sich abmelden möchten?",
        "logout_confirm": "Abmelden",
        "do_not_click": "Nicht klicken",
        "civil_state": "%{state} seit dem %{date}",
        "civil_state_simple": "%{state}",
        "lpp_title": "Berufliche Vorsorge",
        "contact_support": "Support kontaktieren",
        "work_permit_label": "Aufenthaltsbewilligung",
        "work_permit_to_complete": "Aufenthaltsbewilligung (auszufüllen)",
        "missing_avs_number": "AHV-Nummer fehlt",
        "missing_bank_account": "Bankangaben fehlen",
        "upload_document": "Dokument hinzufügen",
        "nationality": "Staatsangehörigkeit",
        "save_logo_error": "Beim Speichern des Logos ist ein Fehler aufgetreten.",
        "save_avatar_error": "Beim Speichern des Profilbilds ist ein Fehler aufgetreten.",
        "save_worker_error": "Beim Speichern des Profils ist ein Fehler aufgetreten.",
        "title": {
            "male": "Herr %{firstName} %{lastName}",
            "female": "Frau %{firstName} %{lastName}",
            "unknown": "%{firstName} %{lastName}"
        },
        "deleteAccount": "Mein Lift-Konto löschen",
        "delete_account_title": "Mein Konto löschen",
        "delete_account_description": "Ihre Daten werden gelöscht und können nicht wiederhergestellt werden.",
        "delete_account_confirm": "Löschen",
        "delete_account_success": "Konto gelöscht",
        "delete_account_error": "Löschung abgebrochen",
        "delete_account_error_description": "Sie können Ihr Konto nicht löschen, wenn ein Arbeitsvertrag läuft, auf eine Unterschrift wartet oder kurz vor Beginn steht.",
        "sample_skribble": "TEST-Signatur",
        "avs_number": "AHV-Nummer",
        "contact_us_for_change": "Für Änderungen kontaktieren Sie bitte den Support.",
        "avs_number_optional": "AHV-Nummer (optional)",
        "change_profile": "Profil wechseln",
        "pending_creation": "Profil wird erstellt",
        "pending_validation": "Profil wird geprüft",
        "rejected_validation": "Prüfung fehlgeschlagen",
        "worker": "Mitarbeiter",
        "client": "Arbeitgeber",
        "add_talent_profile": "Mitarbeiterprofil hinzufügen",
        "add_client_profile": "Unternehmens-Arbeitgeberprofil hinzufügen",
        "add_talent_profile_error": "Beim Speichern des Logos ist ein Fehler aufgetreten.",
        "delete": {
            "worker": {
                "profile": "Mitarbeiterprofil löschen",
                "title": "Mein Mitarbeiterprofil löschen",
                "description": "Die Daten Ihres Mitarbeiterprofils werden gelöscht und können nicht wiederhergestellt werden.",
                "confirm": "Ja, mein Mitarbeiterprofil löschen",
                "success": "Mitarbeiterprofil gelöscht",
                "error_description": "Sie können Ihr Mitarbeiterprofil nicht löschen, wenn ein Arbeitsvertrag läuft, auf eine Unterschrift wartet oder kurz vor Beginn steht."
            },
            "client": {
                "profile": "Arbeitgeberprofil löschen",
                "title": "Mein Arbeitgeberprofil löschen",
                "description": "Die Daten Ihres Arbeitgeberprofils werden gelöscht und können nicht wiederhergestellt werden.",
                "confirm": "Ja, mein Arbeitgeberprofil löschen",
                "success": "Arbeitgeberprofil gelöscht",
                "error_description": "Sie können Ihr Arbeitgeberprofil nicht löschen, wenn ein Arbeitsvertrag läuft, auf eine Unterschrift wartet oder kurz vor Beginn steht."
            },
            "private_client": {
                "profile": "Privatarbeitgeberprofil löschen",
                "title": "Mein Privatarbeitgeberprofil löschen",
                "description": "Die Daten Ihres Arbeitgeberprofils Haushalt werden gelöscht und können nicht wiederhergestellt werden.",
                "confirm": "Ja, mein Privatarbeitgeberprofil löschen",
                "success": "Privatarbeitgeberprofil gelöscht",
                "error_description": "Sie können Ihr Privatarbeitgeberprofil nicht löschen, wenn ein Arbeitsvertrag läuft, zur Unterschrift aussteht oder kurz vor dem Beginn steht."
            }
        },
        "my_activity_log": "Mein Tätigkeitsjournal",
        "ijm_document": "Krankentaggeld (KTG)",
        "private_client": "Privater Arbeitgeber",
        "add_private_client_profile": "Profil privater Arbeitgeber hinzufügen",
        "my_invoices": "Rechnungen",
        "my_colleagues": "Kollegen",
        "logout_cancel": "Nein, abbrechen",
        "framework_contract": "Einfacher Gesellschaftsvertrag",
        "awaiting": "Ausstehend",
        "signed": "Unterzeichnet",
        "rejected": "Abgelehnt",
        "rejected_framework_contract": "**Vertrag abgelehnt von {{rejectedBy}}:**\n{{reason}}",
        "warnings": {
            "kyc_required": "Ihre Identität wurde noch nicht überprüft. Starten Sie die Überprüfung, um alle Funktionen freizuschalten.",
            "client_not_verified": "Wir überprüfen derzeit die Angaben Ihres Unternehmens (dieser Vorgang kann bis zu 72 Stunden dauern).\nSie erhalten eine Benachrichtigung, sobald die Prüfung abgeschlossen ist.",
            "client_not_verified_no_lse": "Sie haben den Co-Anstellungsvertrag mit Lift noch nicht unterzeichnet.\nBitte unterzeichnen Sie ihn, um Ihr Konto zu aktivieren.",
            "client_refused": "Die Überprüfung Ihres Unternehmens wurde nicht akzeptiert.\nGrund: %{rejectedReason}\nKontaktieren Sie uns für weitere Informationen.",
            "client_reject": "Der einfache Gesellschaftsvertrag wurde von einem Mitglied Ihres Unternehmens abgelehnt. Die für Arbeitsverträge geltenden Regeln sind nicht definiert.\nGrund: %{rejectedReason}\nKontaktieren Sie uns für weitere Informationen.",
            "launch_kyc": "Überprüfung starten",
            "show_client_contract": "Vertrag anzeigen",
            "contact_support": "Support kontaktieren",
            "client_handwritten_in_process": "Ihre Co-Arbeitsvereinbarung wurde Ihnen per Post zugeschickt. Bitte unterzeichnen Sie sie und senden Sie sie an uns zurück, damit Ihr Arbeitsvertrag erstellt werden kann."
        }
    },
    "client": {
        "name": "Firmenname",
        "address": "Firmenadresse"
    },
    "documents": {
        "permission_denied": "Berechtigung verweigert. Öffnen Sie die Einstellungen Ihres Geräts.",
        "upload_error": "Beim Hochladen des Dokuments ist ein Fehler aufgetreten.",
        "select_error": "Fehler beim Auswählen des Dokuments.",
        "camera_permission_previously_denied": "Kamerazugriff nicht erlaubt",
        "library_permission_previously_denied": "Zugriff auf Fotos nicht erlaubt",
        "enable_permission_in_settings": "Aktivieren Sie dies in den Telefoneinstellungen",
        "settings": "Einstellungen",
        "invalid_file_type": "Dieser Dateityp wird nicht unterstützt. Bitte wählen Sie ein Bild aus."
    },
    "lpp": {
        "plan_name": {
            "defaultPlan": "Standard-Vorsorgeplan"
        },
        "editor": {
            "title": "Berufliche Vorsorge (BVG)",
            "no_lpp": "Keine BVG-Beiträge",
            "description_lse": "Sie können zwischen verschiedenen BVG-Beitragsoptionen unseres Vorsorgepartners wählen.\n\nIm Personalverleih werden BVG-Beiträge ab dem ersten Franken Lohn erhoben.",
            "description_no_lse": "Sie können zwischen verschiedenen BVG-Beitragsoptionen unseres Vorsorgepartners wählen.\n\nJe nach Alter und Lohn kann es sein, dass gewisse Mitarbeiter von der BVG-Beitragspflicht befreit sind."
        }
    },
    "phone_contact": {
        "search": "Kontakt suchen",
        "no_contact": "Kein Kontakt gefunden",
        "contact_error": "Fehler beim Laden der Kontakte.",
        "permission_denied": "Sie haben der App keinen Zugriff auf Ihre Kontakte gewährt. Sie können dies in den Einstellungen Ihres Telefons ändern."
    },
    "worker_profile": {
        "avs_number": "AHV-Nummer",
        "bank_info": "Bankangaben",
        "bank_iban": "IBAN",
        "bank_name": "Name der Bank",
        "update_success": "Profil aktualisiert",
        "certifications": "Diplome und Zertifikate",
        "education_level": "Ausbildungsniveau",
        "missing_education_level": "Ausbildungsniveau fehlt",
        "years_of_experience": "Berufserfahrung in Jahren",
        "missing_years_of_experience": "Berufserfahrung fehlt",
        "framework_contract": "Details zum Rahmenvertrag",
        "mission_contract": "Details zum Arbeitsvertrag",
        "errors": {
            "email": "Die E-Mail-Adresse ist erforderlich.",
            "avs_number": "Die AHV-Nummer ist nicht korrekt.",
            "birthdate": "Das Geburtsdatum ist ungültig.",
            "address": "Die Adresse ist erforderlich.",
            "education_level": "Ausbildungsniveau fehlt",
            "years_of_experience": "Berufserfahrung fehlt",
            "iban_number": "Ungültige IBAN",
            "iban_bank_name": "Ungültiger Bankname",
            "save": "Beim Speichern Ihrer Informationen ist ein Fehler aufgetreten.",
            "bic_number": "Ungültiger BIC"
        },
        "trainings_and_experiences": "Ausbildung und Berufserfahrung",
        "bank_bic": "BIC",
        "custom_beneficiary": "Benutzerdefinierter Zahlungsempfänger",
        "bank_beneficiary": "Zahlungsempfänger",
        "is_revolut_account": "Ist es ein REVOLUT-Konto?",
        "revolut_account_forbidden": "Ein Lohn kann nicht auf ein REVOLUT-Konto überwiesen werden."
    },
    "worker_details": {
        "title": "Mitarbeiter",
        "documents_title": "Dokumente",
        "mission_count": {
            "zero": "Derzeit kein Arbeitsvertrag",
            "one": "1 Arbeitsvertrag",
            "other": "%{count} Arbeitsverträge"
        },
        "years_of_experience": {
            "zero": "Keine Erfahrung",
            "one": "1 Jahr",
            "other": "%{count} Jahre"
        },
        "create_mission_action": "Arbeitsvertrag mit %{name} erstellen",
        "list_missions_action": "Liste der Arbeitsverträge",
        "list_timesheet_action": "Liste der Stundenerfassungen",
        "list_invoices_action": "Liste der Rechnungen",
        "remove_talent": "Aus meinem Verzeichnis löschen",
        "remove_worker_action": "Aus meinem Mitarbeiterverzeichnis entfernen",
        "remove_worker_title": "Mitarbeiter löschen",
        "remove_worker_description": "Sind Sie sicher, dass Sie diesen Mitarbeiter aus Ihrem Verzeichnis entfernen möchten?",
        "remove_confirm": "Ja, löschen.",
        "remove_cancel": "Nein, abbrechen.",
        "remove_worker_done": "Der Mitarbeiter wurde aus Ihrem Verzeichnis entfernt.",
        "curriculum_vitae_pdf": "Lebenslauf (PDF)",
        "without_qualifications": "Ohne Qualifikationen",
        "qualifications": "Qualifikationen",
        "trainings": "Ausbildung",
        "experiences": "Berufserfahrung",
        "none": "Keine",
        "no_trainings": "Für diesen Mitarbeiter wurde noch keine Ausbildung angegeben.",
        "no_experiences": "Es wurde noch keine Berufserfahrung angegeben."
    },
    "client_profile": {
        "title": "Arbeitgeberprofil",
        "client_name": "Name",
        "client_address": "Adresse",
        "change_client_logo": "Unternehmenslogo ändern",
        "client_info": "Unternehmen",
        "framework_contract": "Details zum Rahmenvertrag",
        "mission_contract": "Details zum Personalverleihvertrag",
        "client_info_data": "Unternehmensdaten",
        "client_title": "Unternehmen",
        "contact_info": "Kontaktdaten"
    },
    "client_worker_cell": {
        "invitation": "Einladung ausstehend",
        "mission_count": {
            "zero": "Keine Arbeitsverträge",
            "one": "1 Arbeitsvertrag",
            "other": "%{count} Arbeitsverträge"
        },
        "cannot_sign_contracts": "ist nicht berechtigt, Verträge zu unterzeichnen",
        "incomplete_profile": "Mitarbeiterprofil wird erstellt"
    },
    "mission_onboarding": {
        "contact_name": "Kontaktperson",
        "contact_phone": "Kontakttelefon",
        "contact_email": "Kontakt-E-Mail",
        "meeting_address": "Treffpunktadresse",
        "meeting_address_placeholder": "Treffpunktadresse eingeben",
        "meeting_date": "Termindatum",
        "meeting_time": "Terminzeit",
        "instructions": "Anweisungen",
        "instructions_placeholder": "Kleiderordnung, Ausweis, Führerschein, spezielle Ausrüstung usw.",
        "instructions_ok": "Bestätigen"
    },
    "invitation": {
        "from": "Einladung von:",
        "to": "an: %{phoneNumber} (%{firstName} %{lastName})",
        "description": "%{senderName} möchte mit Ihnen zusammenarbeiten.\n\n<br><br>\n\nIndem Sie zustimmen, autorisieren Sie %{senderName}, Ihnen Arbeitsverträge anzubieten und auf Ihr Profil (Lebenslauf, Diplome, Studienbescheinigungen) zuzugreifen.",
        "invitation_not_found": "Die Einladung existiert nicht mehr!",
        "action": {
            "accept": "Akzeptieren",
            "reject": "Ablehnen",
            "cancel": "Einladung löschen",
            "close": "Schließen",
            "success": "Einladung angenommen",
            "create_profile": "Mitarbeiterprofil erstellen",
            "switch_profile": "Profil wechseln"
        },
        "send": {
            "errors": {
                "selfInviteError": "Nein, nein! Sie können sich nicht selbst einladen!",
                "workerExistsError": "Diese Telefonnummer gehört bereits zu einem Ihrer Mitarbeiter.",
                "sendError": "Beim Senden der Einladung ist ein Fehler aufgetreten.",
                "isClientPhoneNumberError": "Sie können keine Einladung an diese Telefonnummer senden, da sie einem Arbeitgeber gehört.",
                "alreadyInvitedByOtherProfile": "An diese Telefonnummer wurde bereits eine Einladung für dieses Unternehmen gesendet."
            },
            "phoneNumber": "Telefonnummer",
            "my_contacts": "Einen Kontakt aus meinem Adressbuch auswählen",
            "sendButton": "Einladen",
            "resendButton": "Einladung erneut senden",
            "firstName": "Vorname",
            "lastName": "Nachname",
            "client_not_verified": "Wir überprüfen derzeit die Angaben Ihres Unternehmens (dieser Vorgang kann bis zu 72 Stunden dauern).\nNach Abschluss der Prüfung können Sie Ihre Mitarbeiter einladen.",
            "launch_kyc": "Überprüfung starten",
            "worker": {
                "title": "Mitarbeiter einladen",
                "explaination": "Der Mitarbeiter erscheint in Ihrer Liste, sobald er Ihre Einladung angenommen hat. Anschließend können Sie mit ihm einen Arbeitsvertrag abschließen.",
                "kyc_required": "Sie können keinen Mitarbeiter einladen, solange Ihre Identität nicht überprüft wurde."
            },
            "client": {
                "title": "Einen Kollegen einladen",
                "explaination": "Ihr Kollege erscheint in Ihrer Liste, sobald er Ihre Einladung angenommen hat. Anschließend kann er Verträge für {{clientName}} erstellen und unterzeichnen.",
                "kyc_required": "Sie können keinen Kollegen einladen, solange Ihre Identität nicht überprüft wurde."
            },
            "client_refused": "Die Verifizierung Ihres Unternehmens wurde nicht akzeptiert.\nGrund: %{rejectedReason}\nKontaktieren Sie uns für weitere Informationen.",
            "contact_support": "Support kontaktieren",
            "client_not_verified_no_lse": "Sie haben Ihre Co-Arbeitsvereinbarung mit Lift noch nicht unterzeichnet.\nUnterzeichnen Sie sie, damit Sie Ihre Mitarbeitenden einladen können.",
            "client_reject": "Die Co-Arbeitsvereinbarung wurde von einem Mitglied Ihres Unternehmens abgelehnt. Die Voraussetzungen für die Erstellung der Arbeitsverträge sind daher nicht festgelegt und Sie können derzeit keine Mitarbeitenden einladen.\nGrund: %{rejectedReason}\nKontaktieren Sie uns für weitere Informationen.",
            "show_client_contract": "Vertrag anzeigen",
            "client_handwritten_in_process": "Ihre Co-Arbeitsvereinbarung wurde Ihnen per Post zugeschickt. Bitte unterzeichnen Sie sie und senden Sie sie an uns zurück, damit Ihr Arbeitsvertrag erstellt werden kann."
        },
        "action_result": {
            "accept": {
                "success": "Einladung angenommen",
                "error": "Beim Akzeptieren der Einladung ist ein Fehler aufgetreten."
            },
            "reject": {
                "success": "Einladung abgelehnt",
                "error": "Beim Ablehnen der Einladung ist ein Fehler aufgetreten."
            },
            "cancel": {
                "success": "Einladung gelöscht",
                "error": "Beim Abbrechen der Einladung ist ein Fehler aufgetreten."
            },
            "sent": {
                "success": "Einladung gesendet",
                "error": "Beim Senden der Einladung ist ein Fehler aufgetreten."
            },
            "resend": {
                "success": "Die Einladung wurde erneut gesendet.",
                "error": "Beim Senden der Einladung ist ein Fehler aufgetreten."
            },
            "default": {
                "success": "Aktion ausgeführt",
                "error": "Ein unerwarteter Fehler ist aufgetreten. Unser Team wird das überprüfen."
            }
        },
        "details": {
            "title": "Einen Mitarbeiter einladen",
            "worker_title": "Einladung erhalten",
            "description": "Lift steht derzeit Personen mit Wohnsitz in der Schweiz, Schweizer Staatsbürgern und Inhabern eines B-, C-, G-, L- oder S-Ausweises zur Verfügung."
        },
        "error_bad_recipient": "Entschuldigung, Sie haben diese Einladung versehentlich erhalten. Sie sollten als Arbeitgeber keine Einladung erhalten.",
        "description_create": "%{senderName} möchte mit Ihnen zusammenarbeiten!\n\n<br><br>\n\nUm mit %{senderName} zusammenzuarbeiten, erstellen Sie bitte zunächst ein Mitarbeiterprofil. Sie können dieses neue Profil in Ihrem bestehenden Konto erstellen.",
        "description_switch": "%{senderName} möchte mit Ihnen zusammenarbeiten!\n\n<br><br>\n\nBitte wechseln Sie das Profil, um die Einladung von %{senderName} zu sehen."
    },
    "fees": {
        "repetition": {
            "day": "pro Tag",
            "worked_day": "pro Tag",
            "month": "pro Monat",
            "worked_month": "pro Monat",
            "total": "für den gesamten Vertrag",
            "count": "pro Vorkommen",
            "count_km": "pro km"
        },
        "cct": {
            "hotel_apron_title": "Service-Schürzen",
            "hotel_apron_description": "%{amount} pro Monat",
            "hotel_clothes_title": "Arbeitskleidung für Köche und Konditoren, Jacken für Servicepersonal oder spezielle Uniformen",
            "hotel_clothes_description": "%{amount} pro Monat",
            "hotel_description": "–",
            "hotel_apron_description_2": "%{amount} %{repetition}",
            "hotel_clothes_description_2": "%{amount} %{repetition}",
            "repetition": {
                "month": "pro Monat",
                "total": "für den gesamten Vertrag"
            }
        },
        "type": {
            "private_transport": {
                "title": "Private Transportkosten",
                "description": "Kosten im Zusammenhang mit beruflichen Fahrten zu einem anderen Ziel als dem üblichen Arbeitsort (z. B. Fahrt zu einem Kunden mit dem Privatfahrzeug)."
            },
            "food": {
                "title": "Verpflegungskosten",
                "description": "Kosten im Zusammenhang mit Mahlzeiten während der Pausen an Arbeitstagen am Einsatzort."
            },
            "public_transport": {
                "title": "Öffentliche Verkehrskosten",
                "description": "Kosten im Zusammenhang mit beruflichen Fahrten zu einem anderen Ziel als dem üblichen Arbeitsort (z. B. Fahrt zu einem Kunden mit öffentlichen Verkehrsmitteln)."
            },
            "phone": {
                "title": "Telefonkosten"
            },
            "remote_work": {
                "title": "Kosten für Homeoffice"
            },
            "other": {
                "title": "Sonstige Kosten"
            },
            "otherText": {
                "title": "Kosten \"%{text}\""
            }
        },
        "min_amount": "min. %{amount} %{repetition}",
        "count_unit": {
            "km": "km"
        }
    },
    "invoice": {
        "nav_title": "Rechnungen"
    },
    "contract": {
        "nav_title": "Vertragsübersicht",
        "cancel_contract": "Vertrag stornieren",
        "will_be_signed_with_mission": "Der Vertrag wird zu Beginn Ihrer nächsten Tätigkeit unterzeichnet.",
        "signing_status": {
            "canceled_by_lse": "Von Lift storniert",
            "canceled_by_other": "Von der anderen Partei storniert",
            "canceled_by_self": "Von Ihnen storniert",
            "failed": "Die Unterzeichnung des Vertrags ist leider fehlgeschlagen. Bitte kontaktieren Sie den Support, damit wir Ihnen helfen können.",
            "need_self_sign": "Zu überprüfen und zu unterzeichnen",
            "need_other_sign": "Von der anderen Partei zu unterzeichnen",
            "need_sign": "Unterschrift ausstehend",
            "need_seal": "Wartet auf Überprüfung durch Lift",
            "success": "Von allen Parteien unterzeichnet",
            "waiting_contract": "Warten auf Vertragserstellung",
            "waiting_self_sign": "Warten auf Überprüfung Ihrer Identität",
            "aborted": "Vertrag storniert",
            "signed": "Unterzeichnet",
            "waiting_contract_asset": "Warten auf Fertigstellung der Verträge",
            "unknown": "Unbekannter Status"
        },
        "pdf_prefix": {
            "worker": "Arbeitsvertrag",
            "client": "Personalverleihvertrag",
            "client_employment": "Arbeitsvertrag"
        },
        "terminate_contract": "Kündigungsantrag"
    },
    "mission": {
        "id": "ID",
        "start_date": "Beginn",
        "end_date": "Ende",
        "activity_name": "Tätigkeit",
        "job_title": "Titel",
        "address": "Ort",
        "contract": "Vertrag",
        "earning_type": "Vertragstyp",
        "client": "Arbeitgeber",
        "documents": "Dokumente",
        "worker": "Mitarbeiter",
        "working_percentage": "Prozentsatz",
        "monthly": "Monatlich",
        "hourly": "Stündlich",
        "working_percentage_format": "%{percent}%",
        "no_end_date": "–",
        "working_time": "Arbeitszeit",
        "working_time_info": "Details zu den Arbeitszeiten",
        "classic": "Normale Arbeitszeit",
        "specific": "Spezifische Daten",
        "schedule": "Spezifische Woche",
        "invoiced": "Fakturierter Lohn",
        "gross_salary": "Bruttolohn",
        "salary_hourly": "%{value}/Stunde",
        "salary_monthly": "%{value}/Monat",
        "salary_weekly": "%{value}/Woche",
        "not_defined": "Nicht definiert",
        "needAcceptation": "Zu unterzeichnen",
        "waitingAcceptation": "Unterschrift ausstehend",
        "nav_title": "Arbeitsvertrag",
        "duration_with_end": "Vom %{start} bis %{end}",
        "duration_without_end": "Ab dem %{start} (unbefristet)",
        "details": {
            "draft_description": "Dies ist ein Vertragsentwurf.\n\nÜberprüfen Sie die unten stehenden Informationen, bevor Sie den Vertrag übermitteln.",
            "pendingAcceptation_title": "Zum Lesen und Unterzeichnen",
            "pendingAcceptation_description_need_accept": "Überprüfen Sie die unten stehenden Informationen, bevor Sie den Vorschlag bestätigen.",
            "pendingAcceptation_description_waiting": "Dieser Arbeitsvertrag wurde übermittelt.\n\nWir warten darauf, dass er akzeptiert wird.",
            "will_start_at": "Beginnt am %{date}",
            "accepted_description": "Dieser Arbeitsvertrag wurde akzeptiert. Er läuft bereits oder beginnt in Kürze.",
            "pause_title": "Arbeitsvertrag pausiert",
            "pause_description": "Dieser Arbeitsvertrag ist pausiert.",
            "cancelled_description": "Dieser Vertrag wurde storniert.",
            "terminated_description": "Dieser Vertrag wurde gekündigt.",
            "ended_description": "Dieser Vertrag ist beendet.",
            "onboarding": "Vorbereitung",
            "show_onboarding": "Anzeigen",
            "contract_asset_not_ready": "Ihr Arbeitsvertrag ist noch nicht bereit, bitte haben Sie noch einen Moment Geduld.",
            "framework_asset_not_ready": "Ihr Rahmenvertrag ist noch nicht bereit, bitte haben Sie noch einen Moment Geduld.",
            "contract_asset": "Vertrag",
            "show_contract": "Anzeigen",
            "contract_asset_title": "Arbeitsvertrag",
            "contract_filename": "Vertrag-%{contract_id}",
            "show_time_sheets": "Stundenerfassung anzeigen",
            "cct": "Gesamtarbeitsvertrag (GAV)",
            "client_fees": "Kosten des Arbeitgebers",
            "mission_deductions": "Abzüge",
            "show_payroll_breakdown": "Abrechnungen",
            "mission_details": "Informationen",
            "list_timesheet_action": "Liste der Stundenerfassungen",
            "holiday_balance": "Feriensaldo",
            "overtime_balance": "Stundensaldo",
            "balance_date": "verbucht am %{date}",
            "owner": "Verantwortliche Person",
            "mission_owner": "Vertragsverantwortlicher",
            "name_owner_description": "#### Bestimmen Sie einen Vertragsverantwortlichen\nJede Person im Unternehmen kann für diese Rolle bestimmt werden. Die Unterzeichnung des Vertrags ist jedoch den zeichnungsberechtigten Personen vorbehalten.",
            "new_owner_selected": "Neuer Verantwortlicher zugewiesen",
            "mission_history": "Vertragshistorie",
            "cancelled_by_self": "Sie haben diesen Arbeitsvertrag storniert",
            "cancelled_by_other": "Der Arbeitsvertrag wurde von {{personName}} storniert",
            "cancelled_by_lse": "Der Arbeitsvertrag wurde von Lift storniert",
            "change_owner": "Verantwortliche Person wechseln",
            "signer": "Unterzeichner",
            "change_signer": "Unterzeichner wechseln",
            "confirm_read_annexes": "Ich bestätige, die dem Arbeitsvertrag beigefügten Anhänge gelesen zu haben",
            "draft_title": "Vertragsentwurf",
            "accepted_title": "Laufender Arbeitsvertrag",
            "cancelled_title": "Vertrag storniert",
            "terminated_title": "Vertrag gekündigt",
            "ended_title": "Vertrag beendet",
            "accepted": "Laufender Arbeitsvertrag",
            "label": {
                "default": {
                    "draft": "Vertragsentwurf",
                    "pendingAcceptation": "Vertrag zur Unterzeichnung",
                    "accepted": "Laufender Vertrag",
                    "cancelled": "Vertrag storniert",
                    "terminated": "Laufender Vertrag",
                    "ended": "Vertrag beendet",
                    "canceled": "Vertrag storniert"
                },
                "short": {
                    "draft": "Entwurf",
                    "pendingAcceptation": "Zu unterzeichnen",
                    "accepted": "Laufend",
                    "cancelled": "Storniert",
                    "terminated": "Laufend",
                    "ended": "Beendet",
                    "rejected": "Abgelehnt",
                    "accepted_amendment": "Angenommen",
                    "canceled": "Storniert",
                    "applied": "In Bearbeitung"
                },
                "unknown": "Unbekannter Status"
            },
            "amendment": {
                "title": "Zusatzvereinbarung vom {{creationDate}}",
                "grossSalary": "Lohn: {{salaryAmount}}",
                "endDate": "Verlängerung: {{contractEndDate}}",
                "verify_and_sign": "Zusatzvereinbarung prüfen und unterzeichnen",
                "refused_amendment": "Zusatzvereinbarung abgelehnt:\n\"{{reason}}\"",
                "see_more": "Weitere Zusatzvereinbarungen anzeigen",
                "canceled_amendment": "**Zusatzvereinbarung storniert:**\n\"{{reason}}\"",
                "label": {
                    "short": {
                        "draft": "Entwurf",
                        "pendingAcceptation": "Zur Unterzeichnung",
                        "accepted": "Unterzeichnet",
                        "applied": "In Bearbeitung",
                        "rejected": "Abgelehnt",
                        "canceled": "Storniert"
                    },
                    "unknown": "Unbekannter Status"
                }
            }
        },
        "sign_contract": "Vertrag unterzeichnen",
        "see_contract": "Vertrag ansehen",
        "cancel_mission": "Arbeitsvertrag stornieren",
        "add_to_calendar": "Zum Kalender hinzufügen",
        "reject_contract": "Vertrag ablehnen",
        "cancel_contract": "Vertrag stornieren",
        "confirm_delete_title": "Arbeitsvertrag löschen",
        "confirm_delete_description": "Sind Sie sicher, dass Sie diesen Arbeitsvertrag löschen möchten?",
        "salary_projections": "Prognosen",
        "total_invoiced": "Total fakturiert",
        "net_salary": "Nettolohn für den Mitarbeiter",
        "error_forecast": "Fehler",
        "contact_other": "%{name} kontaktieren",
        "vacationDays": "Ferientage",
        "vacationDaysValue": "%{days} Tage/Jahr (100%)",
        "terminationDate": "Beendet am %{date}",
        "period": "Zeitraum",
        "description": "Beschreibung",
        "contract_names": {
            "client": "Personalverleihvertrag",
            "worker": "Arbeitsvertrag",
            "client_employment": "Arbeitsvertrag"
        },
        "invoiced_info": "Dieser Betrag kann je nach Bedingungen variieren.",
        "payrollSource": "Quelle für die Stundenerfassung",
        "name": "Name des Arbeitsvertrags",
        "edit_name": "Name bearbeiten",
        "edit_name_description": "Dies dient dazu, Verträge zu unterscheiden oder buchhalterische Informationen hinzuzufügen.",
        "update_error": "Beim Aktualisieren des Arbeitsvertrags ist ein Fehler aufgetreten.",
        "salary_daily": "%{value}/Tag",
        "salary_package": "%{value}",
        "history": {
            "title": "Historie",
            "empty": "Derzeit keine Historie"
        },
        "legal_employer": "Rechtlicher Arbeitgeber",
        "legal_employer_name": "Lift",
        "good_to_know": "Gut zu wissen",
        "how_mission_work_for_clients": "Wie läuft ein Arbeitsvertrag für einen Arbeitgeber ab?",
        "how_payroll_breakdown_works": "Wie erfolgt die Abrechnung der Arbeitsstunden?",
        "how_talent_salary_is_paid": "Wie wird der Lohn des Mitarbeiters ausgezahlt?",
        "what_employee_do_if_absent": "Was muss der Mitarbeiter im Falle einer Abwesenheit tun?",
        "terminate_mission": "Den Arbeitsvertrag kündigen",
        "annexes": "Anhänge",
        "annexesTitle": "Anhänge (%{count})",
        "important_informations": "Wichtige Informationen",
        "informations": {
            "essential_informations": {
                "title": "Wesentliche Informationen",
                "description": "Lift ist Ihr administrativer Partner. \nSie schliessen einen Vertrag mit {{legalEmployerName}} ab, das als formeller Arbeitgeber fungiert, während Sie die tägliche Tätigkeit Ihrer Mitarbeitenden selbstständig organisieren. \nKonkret bestätigen Sie die geleisteten Arbeitsstunden und begleichen die Rechnung von Lift – wir kümmern uns um den Rest, bis hin zur Lohnauszahlung. \nIhre Mitarbeitenden profitieren dabei von einem umfassenden Versicherungsschutz: Krankentaggeld- und Unfallversicherung sowie berufliche Vorsorge."
            },
            "payment_deadline": {
                "title": "Zahlungsfrist",
                "description": "Mitte des Monats bitten wir Sie, die Abrechnung der geleisteten Arbeitsstunden auszufüllen und zu bestätigen. Anschließend erhalten Sie unsere Rechnung. Sobald diese beglichen ist, zahlen wir den Lohn an Ihren Mitarbeiter aus. Um einen reibungslosen Ablauf zu gewährleisten, können bei verspäteter Zahlung Gebühren anfallen."
            },
            "fees": {
                "title": "Gebühren",
                "description": "19.– pro Lohnabrechnung und Monat, zu Lasten des Arbeitgebers (exkl. MwSt.)."
            }
        },
        "i_agree": "Ich bestätige, die wichtigen Informationen gelesen und den Inhalt dieser Seite überprüft zu haben",
        "annexesTag": {
            "zero": "Keine Anhänge vorhanden",
            "one": "Ihr Arbeitgeber hat {{count}} Anhang hinzugefügt",
            "other": "Ihr Arbeitgeber hat {{count}} Anhänge hinzugefügt"
        },
        "existing_avenant": {
            "title": "Bestehende Zusatzvereinbarung",
            "description": "Sie können eine Zusatzvereinbarung, die sich in Bearbeitung befindet, nicht ändern, ohne sie zuvor zu stornieren."
        },
        "edit": {
            "title": "Vertragsänderung",
            "salary": {
                "title": "Lohnänderung",
                "description": "Bruttolohn: {{oldGrossSalary}}\nIn Rechnung gestellter Betrag: {{oldInvoiceSalary}}",
                "application_date": "Gültigkeitsdatum",
                "min_salary_info": "Der minimale Bruttostundenlohn beträgt {{amount}}.",
                "same_salary_error": "Der eingegebene Betrag entspricht dem aktuellen Vertragsbetrag.",
                "select_apply_date": "Bitte wählen Sie das Datum, ab dem die Lohnänderung in Kraft tritt.",
                "invalid_date": {
                    "title": "Ungültiges Datum",
                    "description": "Die Änderung kann nicht in Kraft treten, da der Vertrag am {{endDate}} endet."
                }
            },
            "duration": {
                "title": "Vertragsverlängerung",
                "initialEndDateDescription": "Ursprüngliches Vertragsende: {{initialEndDate}}",
                "description": "Die Änderung tritt in Kraft, sobald die drei Parteien die Zusatzvereinbarung unterzeichnet haben.",
                "newEndDate": "Neues Enddatum"
            },
            "description": "Bitte geben Sie die gewünschten Änderungen am Vertrag an.",
            "sign": "Zusatzvereinbarung unterzeichnen"
        },
        "mission_edit": "Vertrag ändern",
        "edit_blocked": "Änderung gesperrt",
        "edit_blocked_description": "Der Vertrag hat bereits begonnen und wurde noch nicht vom Mitarbeiter unterzeichnet. Änderungen sind daher nicht möglich. ",
        "mission_duplicate": "Vertrag auf dieser Grundlage erstellen",
        "amendment": {
            "title": "Zusatzvereinbarung zum bestehenden Vertrag",
            "awaiting_application_title": "Zusatzvereinbarung wartet auf Umsetzung",
            "awaiting_application_description": "Für diesen Vertrag wurde bereits eine Zusatzvereinbarung angenommen und wird am {{applyDate}} angewendet. Änderungen am Vertrag sind daher bis zu diesem Datum nicht möglich."
        }
    },
    "time_sheet": {
        "hours_review": "Stundenübersicht",
        "absences": "Abwesenheiten",
        "title_same_year": "Woche #%{week}",
        "title_other_year": "Woche #%{week} %{year}",
        "nav_title": "Stundenerfassung",
        "hours_completed": {
            "zero": "Keine Stunden erfasst",
            "one": "1 Stunde abgeschlossen",
            "other": "%{hours} abgeschlossen"
        },
        "percent_hours": "Stunden zu %{percent}%",
        "non_payed_hours": "Nicht vergütet",
        "total_hours": "Gesamtstunden",
        "total_working": "Gesamt gearbeitet",
        "total_absence": "Total Abwesenheiten",
        "overtime_info": "Es gibt insgesamt %{overtime} mehr im Vergleich zur im Arbeitsvertrag festgelegten Arbeitszeit.",
        "submitted_info": "Gesendet am %{when}",
        "accepted_info": "Akzeptiert am %{when}",
        "rejected_info": "Abgelehnt am %{when}",
        "snackbar": {
            "reject": "Stundenerfassung beanstandet",
            "accept": "Stundenerfassung akzeptiert"
        },
        "empty": "Sobald Sie einen Arbeitsvertrag beginnen, für die Sie Ihre Arbeitsstunden erfassen müssen, können Sie diese hier eintragen.",
        "declared_inactive": "Als inaktiv deklariert",
        "complete_timesheet_request": "Stundenerfassung ausfüllen",
        "change_timesheet_request": "Stundenerfassung ändern",
        "undertime_info": "Sie haben %{overtime} weniger als die im Arbeitsvertrag festgelegte Arbeitszeit.",
        "nav_sub_title": "Woche #%{week} (%{range})",
        "vacation_available": "Verfügbare Ferientage: {{value}}",
        "no_vacation_available": "Keine Ferientage verfügbar",
        "empty_external_ts": "Für Ihre Arbeitsverträge erfolgt die Arbeitszeiterfassung ausserhalb von Lift. Deshalb sind in der App keine Arbeitszeitblätter verfügbar."
    },
    "timesheet_list": {
        "title": "Stundenerfassung",
        "empty": "Sie haben noch keine Stundenerfassung."
    },
    "camera": "Kamera",
    "library": "Mediathek",
    "storage": "Dateien",
    "components": {
        "address": {
            "close": "Abbrechen"
        },
        "select_input": {
            "close": "Abbrechen"
        },
        "document": {
            "title_label": "Name des Dokuments",
            "title_placeholder": "Dokument benennen",
            "remove": "Löschen",
            "share": "Teilen",
            "remove_document_title": "Dokument löschen",
            "remove_document_description": "Sind Sie sicher, dass Sie dieses Dokument löschen möchten?",
            "remove_document_confirm": "Ja, löschen",
            "remove_document_cancel": "Nein, abbrechen",
            "view_inline_content": "Notiz hinzufügen",
            "inline_content_label": "Notiz",
            "preview_unavailable": "Vorschau nicht verfügbar"
        }
    },
    "createMissionManager": {
        "create_mission_failed": "Beim Erstellen des Arbeitsvertrags ist ein Fehler aufgetreten. Wenn das Problem weiterhin besteht, kontaktieren Sie den Support.",
        "update_mission_failed": "Beim Aktualisieren des Arbeitsvertrags ist ein Fehler aufgetreten. Wenn das Problem weiterhin besteht, kontaktieren Sie den Support.",
        "close_alert_title": "Arbeitsvertrag löschen",
        "close_alert_description": "Die Vertragsdaten gehen verloren. Sind Sie sicher, dass Sie fortfahren möchten?",
        "close_alert_cancel": "Abbrechen",
        "close_alert_confirm": "Arbeitsvertrag löschen",
        "close_alert_title_test_worker": "Simulation löschen",
        "close_alert_description_test_worker": "Möchten Sie wirklich fortfahren?",
        "close_alert_confirm_test_worker": "Simulation entfernen",
        "close_alert_title_update": "Änderungen am Vertrag verwerfen",
        "close_alert_description_update": "Sind Sie sicher, dass Sie die vorgenommenen Änderungen verwerfen möchten? Die neuen Vertragsdaten gehen verloren.",
        "close_alert_confirm_update": "Änderungen verwerfen"
    },
    "utils": {
        "mon": "Montag",
        "tue": "Dienstag",
        "wed": "Mittwoch",
        "thu": "Donnerstag",
        "fri": "Freitag",
        "sat": "Samstag",
        "sun": "Sonntag",
        "period": "%{fromDate} bis %{toDate}",
        "duration": "Dauer",
        "documents": "Dokumente",
        "upload_document": "Dokument hinzufügen",
        "working_time": {
            "invalid": "Ungültige Zeiten",
            "per_week_value": "{{hours}} pro Woche",
            "classic": {
                "title": "Arbeitszeit",
                "modes": {
                    "timePerWeek": "Dauer",
                    "percent": "Prozentsatz"
                },
                "nb_hours": {
                    "zero": "Keine Stunde",
                    "one": "{{count}} Stunde",
                    "other": "{{count}} Stunden"
                },
                "nb_days": {
                    "zero": "Keine Tage",
                    "one": "{{count}} Tag",
                    "other": "{{count}} Tage"
                },
                "nb_weeks": {
                    "zero": "Keine Tage",
                    "one": "{{count}} Tag",
                    "other": "{{count}} Tage"
                },
                "repeat_days": {
                    "zero": "Tag",
                    "one": "jeden Tag",
                    "other": "alle {{count}} Tage"
                },
                "repeat_week": {
                    "zero": "Woche",
                    "one": "pro Woche",
                    "other": "alle {{count}} Wochen"
                },
                "repeat_month": {
                    "zero": "Monat",
                    "one": "pro Monat",
                    "other": "alle {{count}} Monate"
                },
                "error": {
                    "unit_count_not_set": "Bitte definieren Sie eine Arbeitszeit.",
                    "unit_count_too_high": "Die Arbeitszeit darf {{count}} Stunden nicht überschreiten.",
                    "repetition_not_set": "Bitte legen Sie die Häufigkeit fest.",
                    "daily_hours_not_set": "Bitte legen Sie die Anzahl der Stunden pro Tag fest.",
                    "daily_unit_count_too_high": "Die max. Anzahl an Tagen beträgt {{count}} Tage.",
                    "daily_hours_too_high": "Die max. Anzahl an Stunden pro Tag beträgt {{count}} Stunden.",
                    "days_unit_count_too_high": "Die maximale Anzahl Tage beträgt {{count}} Tage.",
                    "hours_unit_count_too_high": "Die Arbeitszeit darf {{count}} Stunden nicht überschreiten."
                },
                "repeat_none": "insgesamt"
            },
            "specific": {
                "title": "{\"one\":\"Gearbeiteter Tag\",\"other\":\"Gearbeitete Tage\"}",
                "info": {
                    "zero": "Kein Datum",
                    "one": "{{date}}",
                    "other": "{{count}} Daten"
                }
            },
            "schedule": {
                "title": "{\"one\":\"Gearbeiteter Tag\",\"other\":\"Gearbeitete Tage\"}",
                "modes": {
                    "free": "Dauer",
                    "fixed": "Zeitfenster"
                },
                "duration_per_week": "%{duration} pro Woche",
                "no_day_selected": "Bitte wählen Sie mindestens einen Tag aus.",
                "free_duration_error": "Die Dauer darf nicht weniger als eine Stunde betragen."
            },
            "repetition_info": "Legen Sie die Arbeitshäufigkeit fest",
            "hours_info": "Geben Sie die Anzahl der Stunden an",
            "hours_label": "Anzahl der Stunden",
            "repetition": {
                "week": "Wöchentlich",
                "month": "Monatlich",
                "week2": "Alle 2 Wochen",
                "week3": "Alle 3 Wochen",
                "week4": "Alle 4 Wochen"
            },
            "percent_label": "Beschäftigungsgrad",
            "units": "Einheit",
            "repetition_for_hourly": {
                "week": "Jede Woche",
                "month": "Jeden Monat",
                "week2": "Alle 2 Wochen",
                "week3": "Alle 3 Wochen",
                "week4": "Alle 4 Wochen",
                "none": "Gesamtstundenzahl"
            },
            "repetition_for_daily": {
                "week": "Jede Woche",
                "month": "Jeden Monat",
                "week2": "Alle 2 Wochen",
                "week3": "Alle 3 Wochen",
                "week4": "Alle 4 Wochen",
                "none": "Gesamtzahl Tage"
            },
            "daily_hours": "{{count}} Stunden pro Tag",
            "daily_hours_question": "Wie viele Stunden entsprechen einem Arbeitstag?",
            "repetition_label": "Häufigkeit",
            "days_label": "Anzahl der Tage",
            "daily_hours_label": "Stunden pro Tag",
            "repetition_info_daily": "Definieren Sie die Arbeitshäufigkeit",
            "repetition_info_hourly": "Definieren Sie die Arbeitshäufigkeit",
            "repetition_label_daily": "Häufigkeit",
            "repetition_label_hourly": "Häufigkeit",
            "recurrent": "Wiederkehrend",
            "punctual": "Einmalig",
            "on_demand": {
                "option": "Auf Abruf",
                "info": "Unechte Arbeit auf Abruf: Es wird kein Arbeitsvolumen garantiert; die arbeitnehmende Person ist frei, jeden angebotenen Einsatz anzunehmen oder abzulehnen.",
                "summary": "Auf Abruf – kein garantiertes Arbeitsvolumen"
            },
            "days_info": {
                "none": "Geben Sie die Anzahl der Arbeitstage an",
                "week": "Geben Sie die Anzahl der Arbeitstage pro Woche an",
                "week2": "Geben Sie die Anzahl der Arbeitstage alle 2 Wochen an",
                "week3": "Geben Sie die Anzahl der Arbeitstage alle 3 Wochen an",
                "week4": "Geben Sie die Anzahl der Arbeitstage alle 4 Wochen an",
                "month": "Geben Sie die Anzahl der Arbeitstage pro Monat an"
            },
            "monthly_hours_or_percent": "Geben Sie den Beschäftigungsgrad oder die Anzahl der Stunden an"
        },
        "on": "am",
        "from": "vom"
    },
    "workingTime": {
        "addScheduleSlot": "Zeitfenster hinzufügen",
        "removeScheduleSlot": "Entfernen",
        "addDate": "Ein Datum hinzufügen",
        "removeDate": "Dieses Datum entfernen",
        "cloneDate": "Zeitfenster dieses Datums duplizieren",
        "genericError": "Ein Fehler ist aufgetreten.",
        "overlapError": "Die Zeitfenster überschneiden sich.",
        "invalidTime": "Die Zeitfenster sind ungültig.",
        "emptyDuration": "Die Dauer darf nicht leer sein.",
        "emptyTimes": "Die Zeitfenster dürfen nicht leer sein.",
        "repetition": {
            "day": "Jeden Tag",
            "week": "Jede Woche",
            "month": "Jeden Monat",
            "week2": "Alle 2 Wochen",
            "week3": "Alle 3 Wochen",
            "week4": "Alle 4 Wochen"
        },
        "unit": {
            "days": "Tag(e)",
            "weeks": "Woche(n)",
            "hours": "Stunde(n)"
        },
        "type": {
            "work": "Arbeit",
            "public_holiday": "Feiertag",
            "vacation": "Ferien",
            "military": "Militärdienst",
            "sickness": "Krankheit",
            "accident": "Unfall",
            "maternity": "Mutterschaft/Vaterschaft",
            "trainee": "Ausbildung",
            "sickness_close_relative": "Krankheit eines Angehörigen",
            "death_close_relative": "Tod eines Angehörigen",
            "marriage": "Heirat",
            "moving": "Umzug",
            "other": "Sonstiges"
        },
        "date_already_added": "Dieses Datum wurde bereits hinzugefügt.",
        "hours_by_week": "Stunden/Woche",
        "tooLowDuration": "Die Dauer darf nicht weniger als eine Minute betragen.",
        "dropdown_show_intercom": "Mehr über Abwesenheitsarten erfahren",
        "insufficient_vacation": "Unzureichendes Ferienguthaben",
        "insufficient_vacation_info": "Unzureichendes Ferienguthaben. {{value}} Ferientag(e) zu viel übertragen."
    },
    "screens": {
        "contract_signing": {
            "title": "Vertragsunterzeichnung",
            "start": "Prozess starten",
            "back": "Zurück",
            "go_home": "Zurück zur Startseite",
            "server_error": "Die Identitätsprüfung ist leider fehlgeschlagen.\n\nWenn das Problem weiterhin besteht, kontaktieren Sie den Support.",
            "description": "Wir begleiten Sie durch den gesamten elektronischen Signaturprozess Ihres Arbeitsvertrags.\n\nDer erste Schritt umfasst eine Identitätsprüfung. Dafür benötigen Sie Ihren Pass oder Ihren Schweizer Personalausweis. Dieser Schritt wird sicher und vertraulich durchgeführt.",
            "browser_closed": "Der Browser wurde geschlossen. Sie können den Prozess fortsetzen, indem Sie auf die Schaltfläche unten klicken.",
            "contact_support": "Support kontaktieren",
            "reset_signing": "Erneut versuchen",
            "reset_error": "Beim Zurücksetzen des Signaturprozesses ist ein Fehler aufgetreten. Wenn das Problem weiterhin besteht, kontaktieren Sie den Support.",
            "state_message": {
                "ident_processing": "Die Überprüfung Ihrer Identität ist im Gange, Sie werden informiert, sobald sie abgeschlossen ist.",
                "ident_failed": "Die Identitätsprüfung ist fehlgeschlagen oder der Prozess wurde unterbrochen. Können Sie es bitte erneut versuchen?\n\nWenn das Problem weiterhin besteht, kontaktieren Sie bitte den Support.",
                "sign_processing": "Die Vertragsunterzeichnung läuft, Sie werden benachrichtigt, sobald sie abgeschlossen ist.",
                "sign_failed": "Die Vertragsunterzeichnung ist fehlgeschlagen, bitte kontaktieren Sie den Support.",
                "sign_rejected": "Leider wurde die Vertragsunterzeichnung abgelehnt und der Vertrag wurde daher annulliert.",
                "sign_success": "Der Vertrag wurde erfolgreich unterzeichnet.",
                "email_sent": "Eine E-Mail mit dem Unterzeichnungsverfahren wurde an %{email} gesendet.",
                "sign_declined": "Die Vertragsunterzeichnung wurde abgelehnt.",
                "sign_withdrawn": "Die Vertragsunterzeichnung wurde storniert.",
                "sign_canceled": "Sind Sie sicher, dass Sie die Vertragsunterzeichnung abbrechen möchten?"
            },
            "congratulations": "Herzlichen Glückwunsch!",
            "back_to_mission": "Zurück zum Arbeitsvertrag",
            "sign_location_contract": "unterzeichnet den Verleihvertrag",
            "sign_work_contract": "unterzeichnet den Arbeitsvertrag",
            "validate_signed_contracts": "validiert die unterzeichneten Verträge",
            "loading": "Vorbereitung des Dokuments für die elektronische Signatur. Bitte haben Sie einen Moment Geduld.",
            "retry_signing": "Zurück zur Unterzeichnung",
            "postpone_signing": "Später unterzeichnen",
            "signing_error": "Beim Unterzeichnen des Vertrags ist ein Fehler aufgetreten.",
            "you_signed_the_contract_client": "Sie haben den Personalverleihvertrag unterzeichnet und das Angebot für einen Arbeitsvertrag wurde an %{name} gesendet.\n\nSobald der Mitarbeiter ebenfalls unterzeichnet hat, wird Lift die Verträge beider Parteien validieren.",
            "you_signed_the_contract_worker": "Sie haben den Arbeitsvertrag erfolgreich unterzeichnet.\n\nNun ist Lift an der Reihe, den Vertrag zu unterzeichnen, damit er gültig wird.",
            "signing_success_client": "Vertrag unterzeichnet!\nDie Verträge werden nun von Lift geprüft.",
            "signing_success_worker": "Vertrag unterzeichnet!",
            "amendment_signing_success_client": "Vielen Dank für die Unterzeichnung der Zusatzvereinbarung.\nNun ist der Mitarbeiter an der Reihe, sie zu unterzeichnen.",
            "amendment_signing_success_worker": "Zusatzvereinbarung unterzeichnet!\nDie Zusatzvereinbarung wird nun von Lift geprüft.",
            "signature_status_update": {
                "contract": {
                    "client": {
                        "success": "Vertrag unterzeichnet!\nDie Verträge werden nun von Lift geprüft.",
                        "decline": "Der Vertrag wurde abgelehnt."
                    },
                    "worker": {
                        "success": "Vertrag unterzeichnet!",
                        "decline": "Der Vertrag wurde abgelehnt."
                    }
                },
                "amendment": {
                    "client": {
                        "success": "Vielen Dank für die Unterzeichnung der Zusatzvereinbarung.\nNun ist der Mitarbeiter an der Reihe, ihn zu unterzeichnen.",
                        "decline": "Die Zusatzvereinbarung wurde abgelehnt"
                    },
                    "worker": {
                        "success": "Zusatzvereinbarung unterzeichnet!\nDie Zusatzvereinbarung wird nun von Lift geprüft.",
                        "decline": "Die Zusatzvereinbarung wurde abgelehnt"
                    }
                },
                "client_framework": {
                    "client": {
                        "success": "Der einfache Gesellschaftsvertrag wurde unterzeichnet. Sie können nun Arbeitsverträge unterzeichnen.",
                        "decline": "Der einfache Gesellschaftsvertrag wurde abgelehnt. Unser Team wird Sie in Kürze kontaktieren."
                    }
                }
            },
            "finalizing": "Die Unterzeichnung wird abgeschlossen.",
            "finalization_pending": "Der Vertragsabschluss wird noch bearbeitet. Sie können die App weiterhin nutzen.",
            "session_creation_error": "Ein Fehler ist aufgetreten, da der Server nicht antwortet. Bitte versuchen Sie es erneut.",
            "retry": "Erneut versuchen"
        },
        "client_list": {
            "title": "Meine Arbeitgeber"
        },
        "auth": {
            "welcome": {
                "subTitle": "Ihr beruflicher Begleiter",
                "what_is_basquiat": "Was ist Lift?",
                "intro_title": "Die neue Arbeitswelt",
                "intro_text": "Lift ermöglicht es jedem, Mitarbeiter einzustellen, ohne sich um die administrativen Aufwände der Anstellung kümmern zu müssen.\n\nDarüber hinaus ermöglicht Lift jedem Mitarbeiter einen individuellen Schutz, garantiert einen Mindestlohn und bietet ein Tool zur Verwaltung mehrerer Einkommensquellen.\n\nVereinfachen Sie Ihre Abläufe, maximieren Sie Ihre Chancen!",
                "basquiat_for_a": "Lift für einen ",
                "client_intro_text": "Wir stellen den Mitarbeiter ganz einfach in Ihrem Namen ein, deklarieren und entlohnen ihn.",
                "client_check_item_1": "Schneller und einfacher Einstellungsprozess",
                "client_check_item_2": "Übernahme der Prozesse im Zusammenhang mit der Personalverwaltung",
                "client_check_item_3": "Reduzierung der Risiken von Nichtkonformität",
                "client_check_item_4": "Mehr Flexibilität und Reaktionsfähigkeit",
                "client_check_item_5": "Schon ab einem einstündigen Vertrag",
                "worker_intro_text": "Lift ermöglicht es Mitarbeitern, ihre Einnahmen besser zu kontrollieren und ihren sozialen Schutz sowie ihre Vorsorge zu verbessern.",
                "worker_check_item_1": "Garantierte pünktliche Lohnzahlung",
                "worker_check_item_2": "Zentrale Verwaltung mehrerer Einkommensquellen",
                "worker_check_item_3": "Erhalt von Lohnabrechnungen und Zugang zur Arbeitslosenversicherung",
                "worker_check_item_4": "Verbesserter sozialer Schutz und vereinfachte Planung Ihrer Altersvorsorge (2026)",
                "worker_check_item_5": "Schon ab einem einstündigen Vertrag",
                "worker": "Mitarbeiter",
                "client": "Arbeitgeber",
                "start": "starten",
                "intro_lift_employee": "Lift-Mitarbeiter, Dienstleister",
                "intro_portage_company": "Personalverleihunternehmen",
                "intro_lift_company": "Lift-Kunde, Einsatzbetrieb",
                "company": "Unternehmen",
                "scan_qr_code": "Scannen Sie den QR-Code, um zur mobilen App für **Apple** oder **Android** zu gelangen",
                "start_new_adventure": "Starten Sie Ihr neues Abenteuer hier!",
                "download_app": "Laden Sie die App für eine bessere Erfahrung herunter",
                "our_partners": "Wir gehen voran mit",
                "login": "Anmelden",
                "signup": "Registrieren",
                "connect": "Anmelden",
                "a_personn": "Eine Person",
                "invite": "{{invitedBy}} lädt Sie ein, Lift beizutreten."
            },
            "screen_card": {
                "validation_button_title": "Bestätigung"
            },
            "phone_number": {
                "title": "Aktivierungscode",
                "description": "Bitte geben Sie Ihre Telefonnummer ein.\n\nWir senden Ihnen dann einen Bestätigungscode, mit dem Sie auf Ihr Konto zugreifen können.",
                "phone_label": "Telefon",
                "phone_placeholder": "Telefonnummer",
                "invalid_number": "Diese Telefonnummer ist ungültig.",
                "next_button_title": "Weiter",
                "missing_phone_number": "Bitte geben Sie Ihre Telefonnummer ein.",
                "quota_exceeded": "Der SMS-Dienst ist derzeit ausgelastet. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support, falls das Problem weiterhin besteht.",
                "too_many_requests": "Es wurde eine ungewöhnliche Aktivität festgestellt, die auf einen möglichen Missbrauch oder eine nicht konforme Nutzung des Dienstes hinweist. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support, falls das Problem weiterhin besteht.",
                "user_disabled": "Diese Nummer wurde von Lift deaktiviert und kann daher nicht mehr verwendet werden.",
                "operation_not_allowed": "Anmeldung vorübergehend nicht verfügbar. Wir arbeiten an der Behebung des Problems. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support, falls erforderlich.",
                "description_signup": "Bitte geben Sie Ihre Telefonnummer ein. Diese dient als Ihr Benutzername.\n\nWir senden Ihnen einen Aktivierungscode, um sicherzustellen, dass nur Sie Zugriff auf Ihr Konto haben.",
                "description_web": "Geben Sie Ihre Telefonnummer ein, um die Registrierung zu starten.\n\nSie erhalten anschließend einen Bestätigungscode zur Verifizierung Ihrer Nummer."
            },
            "confirmation_code": {
                "title": "Geben Sie den Bestätigungscode ein",
                "description": "Bitte geben Sie den Code ein, den wir an {{phoneNumber}} gesendet haben.",
                "wrong_code": "Der Code ist ungültig"
            },
            "select_role": {
                "title": "Ihre Rolle",
                "description": "Welches Profil möchten Sie erstellen?",
                "client": "Unternehmens-Arbeitgeber",
                "worker": "Mitarbeiter",
                "private_client": "Privater Arbeitgeber",
                "no_account": "Kein Konto ist mit dieser Nummer verknüpft.\nBitte erstellen Sie eines, um zu beginnen."
            },
            "invitation_code": {
                "title": "Einladungscode",
                "description": "Sie haben eine Einladung per E-Mail erhalten? Geben Sie den darin enthaltenen Code ein.",
                "placeholder": "z. B. K7P2-XQ9M",
                "submit": "Weiter",
                "skip": "Ich habe keinen Code",
                "errors": {
                    "invitation_code_not_found": "Zu diesem Code gibt es keine Einladung. Bitte überprüfen Sie ihn und versuchen Sie es erneut.",
                    "invitation_code_already_used": "Diese Einladung wurde bereits verwendet.",
                    "invitation_code_expired": "Diese Einladung ist abgelaufen. Bitten Sie die Person, die Sie eingeladen hat, Ihnen eine neue zu senden.",
                    "already_member": "Sie gehören diesem Unternehmen bereits an.",
                    "account_required": "Erstellen Sie zuerst Ihr Konto: Der Code wird während der Registrierung abgefragt.",
                    "generic": "Der Code konnte nicht überprüft werden. Bitte versuchen Sie es erneut."
                }
            },
            "password": {
                "title": "E-Mail und Passwort eingeben",
                "description": "Damit können Sie auf Ihr Konto zugreifen und wichtige Aktionen bestätigen.",
                "email_label": "E-Mail",
                "email_password": "Passwort"
            },
            "smile": {
                "title": "Lächeln Sie!",
                "description": "Senden Sie uns ein Foto von sich",
                "upload_button": "Auswählen"
            },
            "notifications": {
                "title": "Benachrichtigungen",
                "sub_title": "Bleiben Sie informiert!",
                "description": "Stellen Sie sicher, dass Sie Benachrichtigungen akzeptieren, um wichtige Informationen zu Ihren Stundenerfassungen oder beispielsweise zu neuen Vertragsangeboten nicht zu verpassen.",
                "access_app_settings": "Zu den Einstellungen",
                "permission_rejected": "Erlaubnis verweigert",
                "permission_authorized": "Benachrichtigungen aktiviert"
            },
            "upgrade_worker": {
                "title": "Hoppla! Wir müssen Ihr Konto migrieren.",
                "upgrade_button": "Mein Konto migrieren"
            },
            "identity": {
                "title": "Identität",
                "description": "Bitte fotografieren Sie eines der folgenden Dokumente zur Identitätsprüfung:",
                "swiss_id_card": "Schweizer Identitätskarte",
                "swiss_passport": "Schweizer Pass",
                "valid_work_permit": "Arbeitsbewilligung C, B, G, L"
            },
            "scanId": {
                "front": "Vorderseite",
                "back": "Rückseite",
                "capture_face_with_photo": "Scannen Sie die Vorderseite Ihres Dokuments.",
                "capture_back_of_document": "Scannen Sie die Rückseite Ihres Dokuments.",
                "capture_page_with_photo": "Scannen Sie die Seite mit Ihrem Foto.",
                "unknown_error": "Serverfehler. Bitte versuchen Sie es erneut."
            },
            "usageAndPrivacy": {
                "title": "Nutzung und Datenschutz",
                "retake_photos": "Fotos neu aufnehmen",
                "accept_terms_of_use": "Ich habe die [Nutzungsbedingungen von Lift](intercom://8895605) gelesen und akzeptiere sie.",
                "accept_privacy_policy": "Ich habe die [Datenschutzrichtlinie von Lift](intercom://8460851) gelesen und akzeptiere sie.",
                "next": "Weiter"
            },
            "signup": {
                "incomplete_data": "Die Registrierung ist nicht möglich, da einige Angaben unvollständig sind.",
                "unknown_error": "Fehler bei der Registrierung",
                "data_sent": "Informationen gesendet"
            },
            "idVerificationPending": {
                "asClient": "als Arbeitgeber",
                "asTalent": "als Mitarbeiter",
                "description": "Wir prüfen Ihre Registrierungsanfrage. Dies kann bis zu 1 Minute dauern.",
                "soon": "Wir freuen uns, Sie bei Lift willkommen zu heißen!",
                "title": "Identitätsprüfung läuft"
            },
            "idVerificationRetry": {
                "description": "Leider ist die Identitätsprüfung aus folgendem Grund fehlgeschlagen:",
                "nextButton": "Neu beginnen",
                "title": "Identitätsprüfung fehlgeschlagen",
                "veriffCodes": {
                    "101": "Physisches Dokument nicht erkannt",
                    "102": "Verdacht auf Dokumentenfälschung",
                    "103": "Unstimmigkeit zwischen Person und Dokumentfoto",
                    "105": "Verdächtiges Verhalten",
                    "106": "Betrug festgestellt",
                    "108": "Verdächtige Aktivität für diesen Benutzer erkannt",
                    "109": "Verdächtige Aktivität von diesem Gerät erkannt",
                    "110": "Verdächtige Aktivität im Zusammenhang mit diesem Ausweisdokument erkannt",
                    "112": "Anmeldung von einem nicht autorisierten Standort",
                    "113": "Verdächtige Aktivität: möglicher Identitätsmissbrauch",
                    "120": "Das Foto stimmt nicht mit dem Referenzbild überein",
                    "121": "Benutzer-ID fehlt",
                    "122": "Keine Referenzdaten gefunden",
                    "123": "Die Angaben konnten nicht mit offiziellen Registern abgeglichen werden",
                    "126": "Mögliche Übereinstimmung mit einer politisch exponierten Person (PEP)",
                    "127": "Übereinstimmung mit einer Sperrliste (Gesichtsabgleich)",
                    "502": "Mehrere Personen in der Sitzung erkannt",
                    "503": "Möglicher Betrugsversuch erkannt",
                    "504": "Dokumente, die von einem Bildschirm aufgenommen wurden, werden nicht akzeptiert",
                    "505": "Möglicher Betrugsversuch – gedrucktes Dokument erkannt",
                    "507": "Möglicherweise gefälschtes Dokument – Unstimmigkeiten erkannt",
                    "508": "Möglicherweise gefälschtes Dokument – Übereinstimmung mit bekanntem Muster",
                    "509": "Die Person stimmt nicht mit dem Dokumentfoto überein",
                    "510": "Dokumenttyp nicht erkannt",
                    "511": "Dokument ist abgelaufen",
                    "515": "Möglicher Betrugsversuch – Bild stammt von einem Bildschirm",
                    "526": "Möglicher Betrugsversuch – wiederverwendetes Bild erkannt",
                    "527": "Wohnsitznachweis konnte nicht gelesen werden",
                    "528": "Wohnsitznachweis ist abgelaufen",
                    "530": "Mindestalter nicht erreicht (unter 13 Jahre)",
                    "531": "Mindestalter nicht erreicht (unter 14 Jahre)",
                    "532": "Mindestalter nicht erreicht (unter 16 Jahre)",
                    "533": "Mindestalter nicht erreicht (unter 18 Jahre)",
                    "534": "Mindestalter nicht erreicht (unter 20 Jahre)",
                    "535": "Mindestalter nicht erreicht (unter 21 Jahre)",
                    "536": "Mindestalter nicht erreicht (unter 25 Jahre)",
                    "537": "Fehler beim Zuschneiden des Dokumentfotos",
                    "539": "Maximale Anzahl von Versuchen erreicht",
                    "540": "Sitzung nicht vertrauenswürdig genug"
                }
            },
            "verificationFailed": {
                "description": "Leider ist die Identitätsprüfung fehlgeschlagen.\n\nIhre Anfrage erfüllt nicht die [Voraussetzungen für die Nutzung unserer Dienste](intercom://8895605). Kontaktieren Sie uns über die Schaltfläche unten, damit wir Ihnen helfen können.",
                "delete_profile": "Dieses Profil löschen",
                "delete_account": "Mein Konto löschen",
                "title": "Identitätsprüfung fehlgeschlagen"
            },
            "check_client_info": {
                "title": "Arbeitgeberprofil",
                "intro": "Der Arbeitgeber muss im Besitz eines Schweizer Passes/einer Schweizer Identitätskarte oder einer gültigen Schweizer Arbeitsbewilligung (C, B, G, L, S) sein.",
                "civility_placeholder": "Anrede",
                "email_label": "Geschäftliche E-Mail",
                "import_company_logo": "Unternehmenslogo importieren",
                "company_name_label": "Name des Unternehmens",
                "company_address_label": "Adresse des Unternehmens",
                "allowed_to_hire": "Ich bin berechtigt, Mitarbeiter für mich selbst oder im Namen des Unternehmens einzustellen.",
                "terms_text": "1. Einführung\nDiese Nutzungsbedingungen („Bedingungen“) regeln die Nutzung der mobilen Anwendung („Anwendung“), die von Basquiat SA („Wir“, „Unser“ oder „Uns“) entwickelt wurde. Durch den Zugriff auf die Anwendung oder deren Nutzung bestätigen Sie, dass Sie diese Bedingungen gelesen haben und ihnen vorbehaltlos zustimmen.\n\n2. Nutzung der Anwendung\nSie verpflichten sich, die Anwendung ausschließlich zu rechtmäßigen Zwecken und gemäß diesen Bedingungen zu nutzen.\nEs ist strengstens untersagt, die Anwendung zu verwenden:\na. in einer Weise, die gegen geltende Gesetze und Vorschriften verstößt;\nb. in einer Weise, die die Rechte, Interessen oder den Ruf unseres Unternehmens oder Dritter beeinträchtigen könnte;\nc. in einer Weise, die den Zugang, die Nutzung oder die ordnungsgemäße Funktion der Anwendung stören, behindern oder gefährden könnte.\n\n3. Externe Dienste\nDie Anwendung greift auf externe Dienste von Drittanbietern zurück, um alle Funktionen bereitzustellen. Durch die Nutzung der Anwendung erkennen Sie die Nutzung dieser Dienste an und stimmen zu, dass die von Ihnen bereitgestellten Daten gemäß deren Datenschutzrichtlinien verarbeitet werden.\n\n4. DSGVO\nWir verpflichten uns, Ihre personenbezogenen Daten gemäß der Datenschutz-Grundverordnung (DSGVO) zu schützen. Durch die Nutzung der Anwendung erkennen Sie an und stimmen zu, dass wir Ihre Daten gemäß unserer Datenschutzrichtlinie erheben, speichern und verarbeiten.\n\n5. Verwendung von Cookies\nDie Anwendung verwendet Cookies, um Ihre Benutzererfahrung zu verbessern und Informationen über Ihre Nutzung zu sammeln. Durch die Nutzung der Anwendung stimmen Sie der Verwendung von Cookies gemäß unserer Cookie-Richtlinie zu.",
                "fill_all_fields": "Bitte füllen Sie alle Felder aus.",
                "accept_terms_of_use": "Ich akzeptiere die [Nutzungsbedingungen](intercom://8895605) und die [Datenschutzrichtlinie](intercom://8460851) von Lift.",
                "error": "Beim Speichern der Daten ist ein Fehler aufgetreten.",
                "first_name_label": "Vorname",
                "last_name_label": "Nachname",
                "can_sign_contracts_label": "Sind Sie berechtigt, im Namen des Unternehmens Arbeitsverträge zu unterzeichnen?"
            },
            "check_worker_info": {
                "title": "Registrierung",
                "intro": "Der Mitarbeiter muss das 18. Lebensjahr vollendet haben und im Besitz eines Schweizer oder EU-Ausweises oder einer gültigen Schweizer Arbeitsbewilligung (C, B, G, L oder S) sein.",
                "residential_address": "Wohnadresse",
                "accept_terms_of_use": "Ich akzeptiere die [Nutzungsbedingungen](intercom://8895605) und die [Datenschutzrichtlinie](intercom://8460851) von Lift.",
                "has_permit": "Sind Sie Schweizer(in) oder besitzen Sie eine gültige Schweizer Arbeitsbewilligung?"
            },
            "preIdVerification": {
                "title": "Identitätsprüfung",
                "description": "Dieser Schritt ist entscheidend, um Ihr Konto zu sichern und Ihnen zu ermöglichen, Verträge vertraulich zu unterzeichnen.",
                "nextButton": "Los geht's!",
                "description_swiss_or_permit": "Dieser Schritt ist entscheidend, um Ihr Konto zu sichern und Ihnen zu ermöglichen, Verträge vertraulich zu unterzeichnen.\n\nBitte halten Sie Ihren Schweizer Pass/Personalausweis oder eine gültige Schweizer Bewilligung (C, B, G, L oder S) bereit.",
                "description_no_permit": "Dieser Schritt ist entscheidend, um Ihr Konto zu sichern und Ihnen zu ermöglichen, Verträge vertraulich zu unterzeichnen.\n\nBitte halten Sie Ihren EU/EFTA-Ausweis für die Verifizierung bereit.",
                "description_client": "Dieser Schritt ist entscheidend, um Ihr Konto zu sichern und Ihnen zu ermöglichen, Verträge vertraulich zu unterzeichnen.\n\nBitte halten Sie eines der folgenden Dokumente bereit:\n- Schweizer oder EU/EFTA-Pass\n- Schweizer oder EU/EFTA-Ausweis\n- Schweizer Aufenthaltsbewilligung (C, B, G, L oder S)",
                "skipButton": "Später"
            },
            "signupFinished": {
                "title": "Willkommen {{name}}!",
                "sub_title": "Die Welt von Lift öffnet Ihnen ihre Türen!",
                "description_client": "Sie können ab sofort Arbeitsverträge erstellen und Mitarbeiter einstellen. ",
                "description_worker": "Sobald ein Arbeitgeber Ihnen ein Angebot gesendet hat, können Sie Ihren Vertrag unterschreiben und die zahlreichen Vorteile von Lift nutzen.",
                "nextButton": "Los geht's!"
            },
            "postOnboarding": {
                "title": "Herzlichen Glückwunsch!",
                "sub_title": "Ihre Identität wurde bestätigt",
                "description": "Bitte vervollständigen Sie Ihr Profil, um Arbeitsverträge erstellen zu können.",
                "nextButton": "Auf geht's!"
            },
            "clientVerificationPending": {
                "description": "Wir haben Ihre Registrierungsanfrage erhalten und informieren Sie, sobald Ihr Konto verifiziert wurde (max. 72h).",
                "title": "Überprüfung Ihres Unternehmens läuft",
                "in_the_meantime_check_articles": "In der Zwischenzeit finden Sie hier einige hilfreiche Artikel.",
                "how_to_create_mission": "Wie erstellt man einen Arbeitsvertrag?",
                "how_mission_work_for_clients": "Wie läuft ein Arbeitsvertrag für einen Arbeitgeber ab?",
                "can_transfer_current_employees": "Kann ich meine bestehenden Mitarbeiter zu Lift übertragen?",
                "how_payroll_breakdown_works": "Wie erfolgt die Abrechnung der Arbeitsstunden?",
                "how_talent_salary_is_paid": "Wie wird der Lohn des Mitarbeiters bezahlt?"
            },
            "check_private_client_info": {
                "title": "Registrierung",
                "intro": "Der Privatarbeitgeber muss das 18. Lebensjahr vollendet haben und über einen Schweizer oder EU-Ausweis oder eine gültige Schweizer Arbeitsbewilligung (C, B, G, L, S) verfügen.",
                "residential_address": "Wohnadresse",
                "accept_terms_of_use": "Ich akzeptiere die [Nutzungsbedingungen](intercom://8895605) und die [Datenschutzrichtlinie](intercom://8460851) von Lift.",
                "error": "Beim Speichern der Daten ist ein Fehler aufgetreten."
            },
            "privateClientVerificationPending": {
                "title": "Überprüfung läuft",
                "description": "Wir schließen die Überprüfung Ihres neuen Profils ab. Dies kann bis zu 72 Stunden dauern."
            },
            "idVerificationFailed": {
                "title": "Identitätsprüfung fehlgeschlagen",
                "description": "Argh! Ihre Identifikationsanfrage ist fehlgeschlagen: Sie erfüllt nicht die Voraussetzungen für die Nutzung unserer Dienstleistungen. Bitte kontaktieren Sie den Support, damit wir Ihnen helfen können.",
                "nextButton": "Support"
            },
            "clientVerificationFailed": {
                "title": "Die Verifizierung Ihres Unternehmens ist fehlgeschlagen",
                "description": "Ihr Unternehmen wurde leider nicht akzeptiert: Es erfüllt nicht die Voraussetzungen für die Nutzung unserer Dienstleistungen. Bitte kontaktieren Sie den Support, damit wir Sie bei Ihren Schritten unterstützen können.",
                "delete_profile": "Dieses Profil löschen",
                "delete_account": "Mein Konto löschen"
            },
            "privateClientVerificationFailed": {
                "title": "Prüfung fehlgeschlagen",
                "description": "Leider wurde Ihre Identifikationsanfrage abgelehnt, da sie die Voraussetzungen für die Nutzung unserer Dienstleistungen nicht erfüllt.",
                "delete_profile": "Dieses Profil löschen",
                "delete_account": "Mein Konto löschen"
            },
            "presentation_carousel": {
                "your_professional_companion": "Ihr professioneller Partner",
                "companion_text": "**Lift ist eine Einstellungslösung**, die alle Aspekte rund um Löhne, Versicherungen und Sozialabgaben verwaltet.",
                "transparent_relationship": "Eine transparente und nachhaltige Beziehung",
                "transparent_text": "Durch die Vereinfachung der Beziehung zwischen Arbeitgeber und Mitarbeiter ermöglicht Ihnen Lift, sich auf das Wesentliche zu konzentrieren: **die Arbeitsbeziehung**.",
                "simple_as_hello": "Kinderleicht",
                "simple_text": "Arbeitgeber und Mitarbeiter gewinnen an **Flexibilität** und stärken gleichzeitig ihren **sozialen Schutz**.\n\nSie arbeiten zusammen, **Lift kümmert sich um den Rest**.",
                "our_partners": "Wir gehen voran mit",
                "our_partners_text": "Wir bemühen uns, zuverlässige und starke Partnerschaften aufzubauen, um **nachhaltige Ergebnisse** zu erzielen.",
                "create_my_account": "Mein Konto erstellen",
                "step_0": {
                    "title": "Die neue Art zu arbeiten"
                },
                "step_1": {
                    "title": "# Unterzeichnen Sie einen Arbeitsvertrag in wenigen Minuten.\n\n<br><br>\n\n# Lift übernimmt Anstellung und Lohnabrechnung."
                },
                "step_2": {
                    "title": "## Lift kümmert sich um alle administrativen und rechtlichen Aspekte",
                    "detail_1": "Verträge in wenigen Klicks erstellen und unterzeichnen",
                    "detail_2": "Vollständige Verwaltung von Löhnen und Abwesenheiten",
                    "detail_3": "Rechtliche Sicherheit und Sozialschutz garantiert"
                },
                "step_3": {
                    "title": "## Eine innovative und für alle zugängliche Plattform",
                    "clients": "Arbeitgeber",
                    "clients_description": "Lift übernimmt alle administrativen und rechtlichen Aufgaben für nur 19.– CHF pro Lohnabrechnung.",
                    "workers": "Mitarbeiter",
                    "workers_description": "Lift sorgt ab der ersten Arbeitsstunde für Ihren Sozialschutz: Arbeitslosenversicherung, 2. Säule und mehr."
                },
                "step_4": {
                    "title": "## Ein einfaches und sicheres Dreiparteienmodell",
                    "detail_1": "**Der Arbeitgeber** konzentriert sich auf das Arbeitsverhältnis",
                    "detail_2": "**Der Mitarbeiter** arbeitet wie gewohnt, mit Lift als rechtlichem Arbeitgeber.",
                    "detail_3": "**Lift** stellt dem Arbeitgeber den Lohn in Rechnung und zahlt ihn dem Mitarbeiter aus."
                },
                "step_5": {
                    "title": "Lift jetzt entdecken"
                },
                "already_have_account": "Bereits registriert? Anmelden",
                "no_account": "Noch kein Lift-Konto? Registrieren",
                "go_back": "Zurück"
            },
            "postOnboarding_more": {
                "title": "Zusätzliche Informationen",
                "description": "Bitte geben Sie die erforderlichen Angaben ein, um Lift weiterhin nutzen zu können:\n\n{{informations}}"
            },
            "email_verified": {
                "open_app": "App öffnen",
                "success": {
                    "title": "E-Mail erfolgreich verifiziert",
                    "description": "Ihre E-Mail-Adresse wurde erfolgreich verifiziert. Sie können jetzt auf Ihr Konto zugreifen."
                },
                "error": {
                    "title": "Verifizierungsfehler",
                    "description": "Bei der Verifizierung Ihrer E-Mail-Adresse ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support."
                }
            }
        },
        "post_onboarding_client_working_time": {
            "title": "Arbeitszeit",
            "intro": "Bevor Sie neue Arbeitsverträge erstellen können, benötigen wir einige Informationen zur wöchentlichen Arbeitszeit im Unternehmen.",
            "description_1": "Zur Information: In der Personalverleihbranche (LSE) beträgt die wöchentliche Arbeitszeit 42 Stunden.",
            "description_2": "Die Dauer beträgt in der Regel 40 bis 45 Stunden.",
            "description_3": "Diese Information wird bei der Erstellung von Arbeitsverträgen verwendet, um die Arbeitszeit bei 100 % festzulegen.",
            "invite_workers_description": "Sie müssen mit mindestens einem Mitarbeiter verbunden sein, um die App nutzen zu können."
        },
        "post_onboarding_experience": {
            "title": "Erfahrung",
            "intro": "Um den Lohn möglichst genau zu berechnen, benötigen wir einige Informationen zu Ihrem Werdegang:",
            "education_label": "Ausbildung",
            "years_of_experience": "Erfahrung",
            "years": {
                "zero": "Keine Jahre",
                "one": "{{count}} Jahr",
                "other": "{{count}} Jahre"
            },
            "worker_category": "Personalkategorie",
            "join_certificates": "Bitte laden Sie Ihre Arbeitszeugnisse und Bestätigungen hoch, um Ihre Berufserfahrung zu belegen, sowie Ihre Diplome, um Ihre Qualifikationen nachzuweisen."
        },
        "client_profile": {
            "tabs": {
                "missions": {
                    "title": "Verträge"
                },
                "employees": {
                    "title": "Mitarbeiter",
                    "no_workers": "Ihre Mitarbeiter werden hier angezeigt.\nLaden Sie sie ein, um ihnen Arbeitsverträge anzubieten.",
                    "invite_talent": "Einen Mitarbeiter einladen",
                    "employee": "Mitarbeiter",
                    "no_clients": "Ihre Arbeitgeber erscheinen hier.\nLaden Sie sie ein, Sie anzustellen!",
                    "private_client": "Privater Arbeitgeber",
                    "cannot_load_workers": "Entschuldigung, beim Laden ist ein Fehler aufgetreten."
                },
                "invoices": {
                    "title": "Rechnungen",
                    "no_invoices": "Alle Ihre Rechnungen sind hier sichtbar."
                },
                "invitations": {
                    "title": "Einladungen"
                },
                "activities": {
                    "title": "Tätigkeiten"
                },
                "help": {
                    "title": "Hilfe"
                },
                "profile": {
                    "title": "Profil"
                }
            }
        },
        "user": {
            "tabs": {
                "missions": "Verträge",
                "life": "Leben",
                "salaries": "Entgelt",
                "invitations": "Einladungen",
                "activities": "Tätigkeiten",
                "time_sheets": "Stunden",
                "todos": "Meine Aufgaben",
                "invoices": "Rechnungen"
            },
            "activities": {
                "no_activity": "Alle Aktionen, die Sie ausführen müssen, erscheinen hier.",
                "activity": "Historie",
                "logs": "Protokoll",
                "todos": "Aufgaben"
            },
            "profile": {
                "title": "Mein Profil",
                "header_support": "Support"
            },
            "missions": {
                "create_mission": "Arbeitsvertrag erstellen",
                "first_mission_label": "Erstellen wir gemeinsam Ihren ersten Arbeitsvertrag!",
                "no_invites": "Die eingereichten Arbeitsverträge werden hier aufgelistet.\n\nStärken Sie Ihren Sozialschutz, indem Sie Ihre Arbeitgeber einladen, Sie über Lift anzustellen!",
                "no_talents": "Die Arbeitsverträge werden hier angezeigt. Um einen zu erstellen, laden Sie zuerst einen Mitarbeiter über die Navigationsleiste ein.",
                "create_mission_now": "Die Arbeitsverträge, die Sie erstellen, erscheinen hier.",
                "cannot_load_missions": "Entschuldigung, beim Laden ist ein Fehler aufgetreten.",
                "actions_to_do": "Sie haben mehrere Aktionen auszuführen:",
                "enter_your_worktime": "Ihre Stunden erfassen",
                "validate_worktime": "Stunden validieren",
                "validate_contract": "Einen Vertrag validieren",
                "actions_to_do_end": "\n[Die vollständige Liste ansehen](Notifications)",
                "need_email_validation": "Ihre E-Mail-Adresse wurde noch nicht bestätigt. Bitte überprüfen Sie Ihren Posteingang.\n\n[E-Mail erneut senden](#send)",
                "email_validation_sent": "Wir haben Ihnen eine E-Mail an %{email} gesendet. Wenn die Nachricht nicht in Ihrem Posteingang erscheint, überprüfen Sie bitte Ihre anderen Ordner (insbesondere Ihren Spam-Ordner).",
                "read_and_sign_contract": "Prüfen und unterschreiben",
                "has_invites": "Die eingereichten Arbeitsverträge werden hier angezeigt.\n\nIhr Arbeitgeber wurde über Ihre Registrierung informiert und kann Ihnen in Kürze einen Vertrag senden.",
                "create_new_mission": "Neuen Arbeitsvertrag erstellen",
                "invite_client": "Einen Arbeitgeber einladen",
                "invite_client_short": "Einladen",
                "sharing_not_available": "Teilen ist nicht verfügbar",
                "client_empty_generic_text": "Die von Ihnen erstellten Arbeitsverträge erscheinen hier.",
                "select_ijm": "Meinen KTG-Plan wählen",
                "empty_no_ijm": "Wählen Sie anschliessend einen KTG-Plan.",
                "empty_no_talent": "Beginnen Sie, indem Sie einen Mitarbeiter über die untenstehende Werkzeugleiste einladen.",
                "no_talents_left": "Die von Ihnen erstellten Arbeitsverträge erscheinen hier. Um einen neuen zu erstellen, laden Sie zunächst einen Mitarbeiter über die Werkzeugleiste links ein.",
                "know_more_about_missions": "Mehr über den Ablauf eines Arbeitsvertrags erfahren",
                "filters": {
                    "accepted": "Laufend und unterzeichnet",
                    "cancelled": "Annulliert",
                    "draft": "Entwürfe",
                    "ended": "Abgeschlossen",
                    "pendingAcceptation": "Ausstehend",
                    "terminated": "Gekündigt"
                },
                "multi_sign_title": "Mehrere Verträge unterzeichnen",
                "multi_sign_description": "Wählen Sie die Verträge aus, die auf Ihre Unterschrift warten, und unterzeichnen Sie sie alle auf einmal.",
                "filters_intro": "Zeigen Sie nur die Verträge an, die Sie sehen möchten.",
                "selection_title": {
                    "zero": "0 ausgewählt",
                    "one": "%{count} ausgewählt",
                    "other": "%{count} ausgewählt"
                },
                "selection_banner": "Wählen Sie die Verträge aus, die auf Ihre Unterschrift warten.",
                "multi_sign_intro": {
                    "zero": "Leer",
                    "one": "Sie unterzeichnen diesen Vertrag. Der Mitarbeiter wird benachrichtigt und erhält seinen unterzeichneten Vertrag.",
                    "other": "Sie unterzeichnen diese %{count} Verträge auf einmal. Die Mitarbeitenden werden benachrichtigt und erhalten ihre unterzeichneten Verträge."
                },
                "multi_sign_section": "Zu unterzeichnende Verträge",
                "multi_sign_progress_title": "Unterzeichnung läuft ...",
                "multi_sign_progress_description": "Ihre Verträge werden gerade unterzeichnet. Dieser Vorgang kann einige Minuten dauern.",
                "multi_sign_progress_count": "von %{total} unterzeichnet",
                "multi_sign_progress_signed": "Unterzeichnet",
                "multi_sign_progress_see_more": "Mehr anzeigen",
                "multi_sign_progress_background": "**Sie können fortfahren**\n\nSie können dieses Fenster jederzeit schliessen. Der Vorgang wird im Hintergrund fortgesetzt und Sie werden benachrichtigt, sobald er abgeschlossen ist.",
                "multi_sign_progress_error": "Die Unterzeichnung konnte nicht gestartet werden. Bitte versuchen Sie es später erneut.",
                "sign_selected": {
                    "zero": "%{count} Vertrag unterzeichnen",
                    "one": "%{count} Vertrag unterzeichnen",
                    "other": "%{count} Verträge unterzeichnen"
                },
                "multi_sign_progress_done_title": "Unterzeichnete Verträge",
                "multi_sign_progress_done_description": "Die Mitarbeitenden werden benachrichtigt und erhalten ihren Vertrag zur Unterzeichnung, sobald Lift ihn geprüft und unterzeichnet hat.",
                "multi_sign_progress_done_close": "Zurück zu meinen Verträgen"
            },
            "mission_onboarding": {
                "title": "Vorbereitung auf die Tätigkeit",
                "submit": "Einreichen",
                "edit": "Bearbeiten",
                "success": "Anweisungen gesendet",
                "next_button_worker": "Ich nehme dies zur Kenntnis.",
                "header_client": "Bitte senden Sie %{name} vor Beginn des Arbeitsvertrags die erforderlichen Informationen.",
                "header_worker": "Der Arbeitsvertrag von %{name} wird in Kürze beginnen. Bitte nehmen Sie die folgenden Informationen zur Kenntnis:",
                "footer": "Dieser Arbeitsvertrag unterliegt dem GAV Personalverleih. \n\n [GAV lesen](https://www.tempservice.ch/de/tempdata/detail.php?cid=815001&vid=9&eid=12469#documents)",
                "documents": "Wenn Ihr Unternehmen spezifische Sicherheitsregeln oder Dokumente hat, können Sie diese hier hinzufügen."
            },
            "mission_details_accept": {
                "title_worker": "Unterzeichnen Sie den Arbeitsvertrag.",
                "title_client": "Unterzeichnen Sie den Personalverleihvertrag."
            },
            "salaries": {
                "my_salaries": "Meine Löhne",
                "total_for_month": "Gesamt für den Monat **{{yearMonth}}**:&NewLine;&NewLine;**Nettolohn von {{netSalary}}** auf Ihr Konto überwiesen.",
                "salary_sheet": "Lohnabrechnung",
                "filename_salary": "lohn-{{month}}-{{year}}",
                "wait_salary_asset": "Wir laden gerade Ihre Lohnabrechnung. Bitte warten Sie einen Moment…",
                "no_salary": "Ihre Lohnabrechnungen werden auf dieser Seite verfügbar sein.\nDie Lohnzahlung erfolgt jeweils am 25. des Monats, spätestens jedoch am 5. des Folgemonats.",
                "cannot_load_salaries": "Entschuldigung, beim Laden ist ein Fehler aufgetreten.",
                "payslip_sheet": "Entgeltabrechnung",
                "filename_payslip": "Entgeltabrechnung-{{mission}}-{{month}}-{{year}}",
                "payslip_count": {
                    "zero": "Keine Entgeltabrechnung",
                    "one": "Eine Entgeltabrechnung",
                    "other": "{{count}} Entgeltabrechnungen"
                },
                "salaries_number": {
                    "zero": "Kein Lohn",
                    "one": "{{count}} Lohn",
                    "other": "{{count}} Löhne"
                }
            },
            "invoices": {
                "to_pay": "Zu zahlen",
                "paid": "Bereits bezahlt",
                "paid_status": "Bezahlt",
                "to_pay_cta": "Rechnung bezahlen",
                "everything_have_been_paid": "Herzlichen Glückwunsch, alles wurde bezahlt!",
                "invoice": "Rechnung",
                "invoice_token": "Rechnung %{token}",
                "invoices_number": {
                    "zero": "Keine Rechnung",
                    "one": "{{count}} Rechnung",
                    "other": "{{count}} Rechnungen"
                },
                "total_for_month": "**{{yearMonth}}**:&NewLine;&NewLine;**{{invoiceNb}}** für insgesamt **{{netSalary}}**",
                "worker": "Mitarbeiter",
                "invoice_details": "Rechnungsdetails",
                "worked_hours_in_this_invoice": "Tatsächliche Stunden",
                "issued_at": "Ausgestellt am",
                "paid_at": "Bezahlt am",
                "amount": "Betrag",
                "see_invoice": "Rechnung anzeigen",
                "filename_invoice": "rechnung-{{month}}-{{year}}-{{workerName}}",
                "related_activity": "Zugehörige Tätigkeit",
                "period": "Zeitraum",
                "refunded_status": "Erstattet",
                "final_settlement": "Rechnung",
                "down_payment": "Vorschuss",
                "correction": "Korrektur",
                "cannot_load_invoices": "Entschuldigung, beim Laden ist ein Fehler aufgetreten.",
                "wait_invoice_asset": "Ihre Rechnung wird heruntergeladen. Bitte warten Sie einen Moment…"
            },
            "notifications": {
                "title": "Benachrichtigungen",
                "have_actions_to_do": "Sie haben mehrere Aktionen auszuführen:",
                "to_process_now": "Sofort zu bearbeiten",
                "enter_timesheet": "Stunden erfassen",
                "validate_timesheet": "Stunden bestätigen",
                "timesheetNotificationTitle": "Stempeln",
                "timesheetNotificationBody": "Vergessen Sie nicht, Ihre Arbeitsstunden zu notieren."
            },
            "timesheet_review": {
                "worked_hours_recap": "Zusammenfassung der tatsächlichen Stunden",
                "worked_hours_period": "Geleistete Stunden für den Zeitraum von:",
                "send_for_review": "Senden",
                "hours_breakdown": "Details",
                "save": "Speichern und beenden",
                "hours_at": "Stunden zu",
                "contest": "Anfechten",
                "contested": "Abgelehnt",
                "reject": "Stundenerfassung ablehnen",
                "approve": "Stunden bestätigen",
                "rejected_hours": "Abgelehhnte Stunden",
                "submitted_info": "Die Stundenerfassung wurde gesendet.",
                "auto_submit_info": "Die Stundenerfassung wird am %{time} automatisch akzeptiert.",
                "mission_start": "Beginn des Arbeitsvertrags",
                "mission_ending": "Ende des Arbeitsvertrags",
                "client_status": {
                    "open": "Warten auf die Stundenerfassung des Mitarbeiters",
                    "submitted": "Validieren Sie den Zettel, indem Sie die monatliche Abrechnung einreichen.",
                    "accepted": "Diese Stundenerfassung wurde am {{date}} akzeptiert.",
                    "rejected": "Abgelehnt am {{date}}."
                },
                "worker_status": {
                    "open": "Die Stundenerfassung wurde noch nicht zur Validierung gesendet.",
                    "submitted": "Ihre Stundenerfassung wartet auf Validierung.",
                    "accepted": "Akzeptiert am {{date}}",
                    "rejected": "Abgelehnt am {{date}}"
                },
                "reject_alert": {
                    "title": "Stunden anfechten",
                    "description": "Sind Sie sicher, dass Sie die Stunden dieser Stundenerfassung anfechten möchten?",
                    "confirm": "Ja, anfechten",
                    "cancel": "Nein, abbrechen"
                },
                "declare_inactive": "Als inaktiv deklarieren",
                "locked": "Diese Stundenerfassung kann nicht mehr geändert werden, da sie bereits bestätigt wurde.",
                "too_early": "Sie können diese Stundenerfassung noch nicht zur Validierung senden.",
                "validate_title": "Stundenerfassung",
                "reject_description": "Wenn Ihnen die Abrechnung fehlerhaft erscheint, können Sie diese anfechten, damit sie überprüft und korrigiert wird.",
                "accepted_locked": "Diese Stundenerfassung kann nicht mehr geändert werden, da er bereits akzeptiert wurde.",
                "submitted_locked": "Diese Stundenerfassung wartet auf die Validierung durch den Arbeitgeber. Wenn Sie Änderungen daran vornehmen möchten, bitten Sie ihn, diesen Zettel abzulehnen."
            },
            "life": {
                "setupText": "{{firstName}}, Lift ermöglicht es Ihnen, Ihre Altersvorsorge zu planen, um besser auf Lebensrisiken vorbereitet zu sein."
            },
            "create_mission_intro": {
                "title": "Ablauf des Arbeitsvertrags",
                "description": "Wie erstelle ich einen Arbeitsvertrag (Beschreibung) <br>"
            },
            "create_mission_job_title": {
                "title": "Geben Sie die Art der Position an",
                "job": "Tätigkeitstyp",
                "job_title": "Stellenbezeichnung (optional)",
                "description": "Aufgabenbeschreibung (optional)",
                "default_cct": "GAV – Personalverleih",
                "default_cct_description": "Der Gesamtarbeitsvertrag (GAV) für den Personalverleih (PVA) gilt standardmäßig, solange Sie Lift nutzen.",
                "cct_details": "GAV-Details",
                "description_top": "Die folgenden Informationen sind erforderlich, um den Mindestlohn des entsprechenden Tätigkeitsbereichs festzulegen.",
                "missionAnnexQuestion": "Möchten Sie zusätzliche Dokumente hinzufügen?",
                "missionAnnexInfo": "Wenn Sie möchten, können Sie ein bereits unterzeichnetes Pflichtenheft, ein Reglement oder besondere Vereinbarungen beifügen. Diese Dokumente werden lediglich zu Informationszwecken übermittelt. Bei abweichender Auslegung gelten die Bestimmungen des mit {{legalEmployerName}} abgeschlossenen Vertrags.",
                "missionAnnexUpload": "Dokument hochladen",
                "missionAnnexAddInLine": "Notiz hinzufügen",
                "office_job": "Ist das eine Bürotätigkeit?",
                "yes": "Ja",
                "no": "Nein",
                "description_allowances": "Die Art der Tätigkeit ermöglicht uns, den Unternehmensbereich für die Unfallversicherung zu bestimmen."
            },
            "create_mission_salary": {
                "salaryType": {
                    "gross": "Brutto",
                    "net": "Netto",
                    "invoice": "Fakturiert",
                    "base": "Basis",
                    "base_13x": "Basis (13x)"
                },
                "help": "Weitere Informationen",
                "invoice_month_label": "Dem Arbeitgeber in Rechnung gestellt/Monat",
                "invoice_hour_label": "Dem Arbeitgeber in Rechnung gestellt/Stunde",
                "gross_month_label": "Bruttolohn/Monat",
                "gross_hour_label": "Bruttolohn/Stunde",
                "net_month_label": "Nettolohn/Monat",
                "net_hour_label": "Nettolohn/Stunde",
                "show_details": "Detaillierte Abrechnung anzeigen",
                "detailed_working_time": {
                    "salary": "Entgelt",
                    "pricing": "Preisgestaltung",
                    "description_1": "Im Rahmen des Personalverleihs gibt es verschiedene Vergütungsarten je nach Tag und Uhrzeit der geleisteten Arbeit:",
                    "description_2": "Die auf dem Bildschirm angezeigten Werte basieren auf einem 100 %-Pensum.\n\nDer effektive Lohn wird auf Basis der tatsächlich geleisteten Stunden berechnet (Zeiterfassung).",
                    "officeWorkHours": "Bürozeiten",
                    "officeWorkHours_1": "von Montag bis Freitag",
                    "officeWorkHours_2": "beginnt nicht vor 6 Uhr",
                    "officeWorkHours_3": "endet nicht nach 22 Uhr",
                    "nightHours": "Nachtstunden/Samstag",
                    "nightHours_1": "Samstag, oder",
                    "nightHours_2": "Uhrzeit zwischen 22 und 6 Uhr",
                    "nightHours_3": "Tägliche Arbeitszeit über 9,5 Stunden",
                    "sundayHours": "Sonntagsarbeit",
                    "sundayHours_1": "Sonntag"
                },
                "calculationsExplained": "Diese Berechnungen beinhalten:",
                "weeksOfHolidays": "{{weeksOfHolidays}} Wochen Ferien",
                "days": "{{days}} Tage",
                "lpp": "einen Vorsorgeplan 2. Säule (BVG)",
                "withoutTaxes": "Arbeitgeberbeiträge inklusive (ohne MwSt.)",
                "informations": "Informationen",
                "vacation_days_format": "{{days}} Tage",
                "vacation_days_full_week_format": "{{days}} Tage ({{nbWeeks}} Wochen)",
                "base_hour_label": "Grundlohn/Stunde",
                "base_month_label": "Grundlohn/Monat",
                "vacationExplained": "Anzahl der Ferientage pro Jahr (basierend auf 100%)",
                "13th_salary_included": "Der 13. Monatslohn ist im Monatslohn enthalten.",
                "corresponding_paid_salary": "Der ausgezahlte Lohn beträgt {{paidSalary}}",
                "corresponding_base_salary": "Entsprechender Grundlohn: {{baseSalary}}",
                "net_salary_info": "Der Nettolohn ist indikativ und wird ohne Quellensteuer berechnet.",
                "invoice_day_label": "Dem Arbeitgeber in Rechnung gestellt/Tag",
                "gross_day_label": "Bruttolohn/Tag",
                "net_day_label": "Nettolohn/Tag",
                "base_day_label": "Grundlohn/Tag",
                "invoice_package_label": "Dem Arbeitgeber in Rechnung gestellt",
                "gross_package_label": "Bruttolohn",
                "net_package_label": "Nettolohn",
                "base_package_label": "Grundlohn",
                "invoice_label": "Dem Arbeitgeber in Rechnung gestellt",
                "gross_label": "Bruttolohn",
                "net_label": "Nettolohn",
                "vacation_percentage": "%{count} Ferientage (Beschäftigungsgrad von %{percent}%)",
                "ijmExplained": "Lohnfortzahlung bei Krankheit",
                "setIjmAction": "Krankentagegeld-Cover auswählen",
                "setVacationDays": "Anzahl Tage auswählen",
                "salary_breakdown": "Zusammenfassung",
                "compute_salary_missing_data": "Für die Berechnung des Lohns fehlen noch einige Angaben.\nBitte gehen Sie zu den vorherigen Schritten zurück, wählen Sie den GAV erneut aus und starten Sie die Berechnung erneut.",
                "lppExplained": "Berufliche Vorsorge (BVG)",
                "workerGroupExplained": "Arbeitnehmergruppe",
                "setWorkerGroup": "Gruppe auswählen",
                "ijmInfoTitle": "Krankentaggeldversicherung (KTG)",
                "lppInfoTitle": "Berufliche Vorsorge (BVG)",
                "socialChargesTitle": "Sozialabgaben",
                "forceAvsAction": "AHV-Beiträge entrichten",
                "forceAvsLegend": "Arbeitnehmer und Arbeitgeber können gemeinsam entscheiden, ob AHV-Beiträge entrichtet werden.",
                "onDemandAvsLegend": "Arbeit auf Abruf: Da kein Arbeitsvolumen garantiert ist, wird die AHV-Pflicht hier festgelegt.",
                "onDemandLppAction": "BVG-Beiträge entrichten",
                "onDemandLppLegend": "Setzt die AHV voraus. Ohne Anschluss gilt die BVG trotzdem, wenn der Plan keine Eintrittsschwelle hat.",
                "lppLegend": "Die BVG ist die 2. Säule, also die Altersvorsorge.",
                "ijmLegend": "Die KTG ist eine Entschädigung im Krankheitsfall, mit der der Arbeitnehmer bezahlt werden kann.",
                "vacationAndCagnotageTitle": "Anzahl der Ferientage und Ferienkasse",
                "vacationEditorTitle": "Wählen Sie die Anzahl der Ferientage (basierend auf 100%)",
                "cagnotteVacationsTitle": "Ferienkasse",
                "cagnotteVacationsAction": "Ferien in der Ferienkasse ansparen",
                "cagnotteVacationsLegend": "Die Entschädigung wird im Laufe der gearbeiteten Tage angespart und dem Mitarbeitenden ausbezahlt, sobald er seine Ferien tatsächlich bezieht. Lift verwaltet dies als Rückstellung.",
                "cagnotteVacationsObligatoireLegend": "Das Ansparen der Ferien in der Ferienkasse ist obligatorisch, wenn ein GAV es vorschreibt, wenn der Beschäftigungsgrad 100% beträgt oder wenn der Mitarbeitende im Stundenlohn regelmässig genau gemäss den im Vertrag vorgesehenen Arbeitszeiten arbeitet.",
                "cagnotteVacationsNonTrackedLegend": "Bei dieser Art von Einsatz werden die Ferien nicht erfasst: Die Ferienentschädigung wird immer mit dem Lohn ausbezahlt. Die Ferienkasse kann daher nicht aktiviert werden.",
                "cagnotageObligatoire": "Ferienkasse obligatorisch",
                "cagnotageApplique": "Ferienkasse aktiviert",
                "cagnotageNonApplique": "Ferienkasse nicht aktiviert",
                "setLppAction": "Plan auswählen",
                "13th_salary_paid_separately": "13. Monatslohn separat ausbezahlt",
                "thirteenth_salary_presence_question": "Möchten Sie einen 13. Monatslohn hinzufügen?",
                "thirteenth_salary_regime_question": "Möchten Sie den 13. Monatslohn in 12 oder 13 Zahlungen pro Jahr auszahlen?",
                "thirteenth_salary_mandatory_note": "Der gewählte GAV schreibt die Auszahlung des 13. Monatslohns vor.",
                "thirteenth_salary_12x_option": "12x",
                "thirteenth_salary_13x_option": "13x"
            },
            "create_mission_salary_monthly": {
                "title": "Monatslohn",
                "requested_salary_label": "Monatslohn",
                "min_salary_info": "Der minimale Bruttomonatslohn bei {{percentage}}% beträgt {{percentageAmount}}.",
                "counting_details": "[Detaillierte monatliche Abrechnung](SalaryCountingDetails)",
                "working_percentage_info": "Wöchentliche Arbeitszeit: {{duration}} ({{percentage}}%)",
                "min_salary_info_plus": "Der monatliche Mindestlohn {{salaryType}} bei {{percentage}}% beträgt {{percentageAmount}}."
            },
            "create_mission_salary_hourly": {
                "title": "Stundenlohn",
                "requested_salary_label": "Stundenlohn",
                "min_salary_info": "Der minimale Bruttostundenlohn beträgt {{amount}}.",
                "counting_details": "[Detaillierte stündliche Abrechnung](SalaryCountingDetails)",
                "min_salary_info_plus": "Der minimale Stundenlohn {{salaryType}} beträgt {{amount}}."
            },
            "salary_counting_details": {
                "title": "Hier ist die detaillierte Abrechnung von Lohn und Abzügen",
                "close": "Schließen",
                "description": "Der Mitarbeiterstatus bietet zahlreiche Leistungen, die vom Lohn abgezogen werden und den Schutz des Mitarbeiters gewährleisten.",
                "client_deductions": "Arbeitgeberbeiträge",
                "worker_deductions": "Sozialabzüge",
                "show_details": "Details",
                "hide_details": "Details ausblenden",
                "invoiced_to_client": "Dem Arbeitgeber in Rechnung gestellt",
                "gross_salary": "Bruttolohn",
                "base_salary": "Grundlohn",
                "net_salary": "Nettolohn",
                "holiday_13th_compensations": "Ferienentschädigung, Feiertage und 13. Monatslohn",
                "paid_to_your_account": "Auf das Konto überwiesen",
                "client_salary_title": "Arbeitgeberanteil",
                "worker_salary_title": "Arbeitnehmeranteil",
                "13th_compensations": "13. Monatslohn",
                "total_with_client_deductions": "Lohn mit Abgaben",
                "paid_salary": "An den Mitarbeiter ausbezahlter Lohn",
                "vacancy_indemnity": "Ferienrückstellungen",
                "invoiced_salary": "Fakturierter Lohn",
                "taxes": "MwSt. ({{percent}}%)",
                "basquiat_margin": "Servicegebühren ({{percent}}%)",
                "lse_fees": "Servicegebühren",
                "screen_title": "Detaillierte Abrechnung",
                "avs": "AHV/IV/EO ({{percent}}%)",
                "ac": "ALV ({{percent}}%)",
                "pc_fam": "LPC Familie ({{percent}} %)",
                "alloc_fam": "Familienzulagen ({{percent}}%)",
                "laap": "BU ({{percent}}%)",
                "laanp": "NBU ({{percent}}%)",
                "ijm": "KTG ({{percent}}%)",
                "fcfp": "BBF ({{percent}}%)",
                "management_fees": "Verwaltungsgebühren ({{percent}} %)",
                "training_costs": "Ausbildung ({{percent}}%)",
                "lpp": "BVG ({{percent}}%)",
                "thirteen_month_compensation": "Anteil 13. Monatslohn",
                "public_holidays_compensation": "Feiertagsentschädigung",
                "vacations_compensation": "Ferienentschädigung",
                "SECOND_OEUVRE_ROMAND_LPP_PRE": "Übergangsrente FAR ({{percent}}%)",
                "SECOND_OEUVRE_ROMAND_CSP": "Berufliche Solidarität ({{percent}}%)",
                "SECOND_OEUVRE_ROMAND_CRP": "Arbeitgeberbeitrag Nachwuchs ({{percent}} %)",
                "SECOND_OEUVRE_ROMAND_APG_PLUS": "Zusatzbeiträge EO ({{percent}} %)",
                "PEINTURE_PLATRERIE_LPP_PRE": "Übergangsrente VRM ({{percent}}%)",
                "ALLOC_FAM_VD": "Familienzulagen-Beitrag VD ({{percent}}%)",
                "PC_FAM_VD": "LPCFam-Beitrag VD ({{percent}}%)",
                "ALLOC_FAM_GE": "Familienzulagen-Beitrag GE ({{percent}}%)",
                "MAT_GE": "Mutterschaftsbeitrag GE ({{percent}}%)",
                "ALLOC_FAM_VS": "Familienzulagen-Beitrag VS ({{percent}}%)",
                "PC_FAM_VS": "LPCFam-Beitrag VS ({{percent}}%)",
                "ALLOC_FAM_AG": "Familienzulagen-Beitrag AG ({{percent}}%)",
                "ALLOC_FAM_ZH": "Familienzulagen-Beitrag ZH ({{percent}}%)",
                "ALLOC_FAM_BE": "Familienzulagen-Beitrag BE ({{percent}}%)",
                "ALLOC_FAM_LU": "Familienzulagen-Beitrag LU ({{percent}}%)",
                "ALLOC_FAM_UR": "Familienzulagen-Beitrag UR ({{percent}}%)",
                "ALLOC_FAM_SZ": "Familienzulagen-Beitrag SZ ({{percent}}%)",
                "ALLOC_FAM_OW": "Familienzulagen-Beitrag OW ({{percent}}%)",
                "ALLOC_FAM_NW": "Familienzulagen-Beitrag NW ({{percent}}%)",
                "ALLOC_FAM_GL": "Familienzulagen-Beitrag GL ({{percent}}%)",
                "ALLOC_FAM_ZG": "Familienzulagen-Beitrag ZG ({{percent}}%)",
                "ALLOC_FAM_FR": "Familienzulagen-Beitrag FR ({{percent}}%)",
                "ALLOC_FAM_SO": "Familienzulagen-Beitrag SO ({{percent}}%)",
                "ALLOC_FAM_BS": "Familienzulagen-Beitrag BS ({{percent}}%)",
                "ALLOC_FAM_BL": "Familienzulagen-Beitrag BL ({{percent}}%)",
                "ALLOC_FAM_SH": "Familienzulagen-Beitrag SH ({{percent}}%)",
                "ALLOC_FAM_AR": "Familienzulagen-Beitrag AR ({{percent}}%)",
                "ALLOC_FAM_AI": "Familienzulagen-Beitrag AI ({{percent}}%)",
                "ALLOC_FAM_SG": "Familienzulagen-Beitrag SG ({{percent}}%)",
                "ALLOC_FAM_GR": "Familienzulagen-Beitrag GR ({{percent}}%)",
                "ALLOC_FAM_TG": "Familienzulagen-Beitrag TG ({{percent}}%)",
                "ALLOC_FAM_TI": "Familienzulagen-Beitrag TI ({{percent}}%)",
                "ALLOC_FAM_NE": "Familienzulagen-Beitrag NE ({{percent}}%)",
                "ALLOC_FAM_JU": "Familienzulagen-Beitrag JU ({{percent}}%)",
                "info_fee": "Zuzüglich Lift-Gebühren von CHF 19.– pro Monat und Mitarbeiter",
                "worker_monthly_deductions_info": "Diese Abgaben werden monatlich vom Lohn abgezogen:",
                "client_monthly_deductions_info": "Diese Abgaben werden monatlich zum in Rechnung gestellten Betrag hinzugefügt:",
                "lift_monthly_fee": "Lift-Gebühr, einmal pro Monat und pro Mitarbeiter",
                "employer_period_total": {
                    "hourly": "Vom Arbeitgeber bezahlter Betrag pro Stunde",
                    "daily": "Vom Arbeitgeber bezahlter Betrag pro Tag",
                    "monthly": "Vom Arbeitgeber bezahlter Betrag pro Monat",
                    "package": "Vom Arbeitgeber für den Vertrag bezahlter Betrag"
                },
                "employer_vacation_note": "Dieser Betrag muss auch während der Ferien des Mitarbeiters ausbezahlt werden, wenn die Ferienentschädigung ausbezahlt wird.",
                "worker_vacation_note": "Dieser Lohn wird auch während der Ferien aus den dafür gebildeten Rückstellungen ausbezahlt.",
                "thirteenth_provision": "Rückstellung 13. Monatslohn",
                "worker_13th_note": "Der 13. Monatslohn wird im Dezember, am Vertragsende oder auf Anfrage ausbezahlt.",
                "employer_13th_note": "Der 13. Monatslohn wird bei seiner Auszahlung bezahlt, im Dezember, am Vertragsende oder auf Anfrage."
            },
            "create_mission_fees": {
                "title": "Pauschalspesen",
                "description": "Im Rahmen dieses Arbeitsvertrags geben Sie bitte an, ob Sie Berufskosten übernehmen. Dabei handelt es sich um laufende Ausgaben des Mitarbeiters, die ihm erstattet werden.",
                "fees_type": "Art der Spesen",
                "next_title": "Weiter",
                "total_with_charge": "{{amount}} inkl. Sozialabgaben",
                "add_other_fees": "Weitere Kosten hinzufügen",
                "delete_other_fees": "Spesen löschen",
                "remove_title": "Kosten entfernen",
                "remove_info": "Möchten Sie diese Kosten wirklich entfernen?",
                "do_remove": "Ja, löschen",
                "cct_nettyoyage_romand_food": "Der GAV für die Reinigungsbranche legt die Verpflegungsentschädigung auf CHF 18.50 fest.",
                "cct_fixed_fee": "Diese Vergütung wird durch den GAV festgelegt."
            },
            "create_mission_activity_type": {
                "title": "Tätigkeitstyp",
                "label": "Tätigkeit",
                "search": "Suchen...",
                "description_top": "Wählen Sie die Kategorie, die am besten zur Tätigkeit passt.",
                "type_to_search": "Geben Sie die ersten drei Buchstaben ein, um Ihre Suche zu starten.",
                "no_result": "Leider entspricht keine Tätigkeit Ihrer Suche."
            },
            "create_mission_client": {
                "title": "Der Arbeitgeber",
                "description_top": "Wählen Sie einen bestehenden Arbeitgeber oder suchen Sie nach einem neuen Arbeitgeber und fügen Sie ihn hinzu.",
                "placeholder": "Suchen (nach Telefonnummer oder E-Mail)",
                "add_label": "Neuen Arbeitgeber hinzufügen",
                "client_card_description": {
                    "zero": "",
                    "one": "1 Arbeitsvertrag",
                    "other": ""
                },
                "enter_client_email": "Geben Sie die E-Mail-Adresse Ihres Arbeitgeberkontakts ein.",
                "no_client_found": "In unseren Unterlagen wurde kein bestehender Kontakt gefunden.\n\nBitte bitten Sie Ihren Kontakt, ein Lift-Konto zu erstellen.",
                "invite_button": "Eine Einladung senden",
                "i_have_understood": "Ich habe verstanden.",
                "my_clients": "oder wählen Sie einen bestehenden Arbeitgeber aus"
            },
            "create_mission_worker": {
                "title": "Wählen Sie einen Mitarbeiter für diesen Arbeitsvertrag aus",
                "add_label": "Neuen Mitarbeiter einladen",
                "worker_card_description": {
                    "zero": "",
                    "one": "Insgesamt 1 Arbeitsvertrag",
                    "other": "Insgesamt {{count}} Arbeitsverträge"
                },
                "is_invitation": "Einladung ausstehend",
                "no_permit": "Keine Arbeitsbewilligung",
                "permit_in_process": "Bewilligung beantragt",
                "test_worker": "Testmitarbeiter",
                "test_worker_description": "Verwenden Sie diesen Mitarbeiter, um den Ablauf und die Lohnberechnung zu simulieren",
                "invite_worker": "Mitarbeiter einladen",
                "incomplete_profile": "Mitarbeiterprofil wird erstellt",
                "cannot_change_employee": {
                    "title": "Mitarbeiter wechseln",
                    "description": "Um den Mitarbeiter zu wechseln, stornieren Sie den Einsatz auf der Vertragsseite, indem Sie \"Arbeitsvertrag stornieren\" auswählen."
                }
            },
            "create_mission_working_address": {
                "title": "Geben Sie den Ort der Tätigkeit an",
                "description_top": "Bitte geben Sie an, wo die Tätigkeit stattfinden wird. Wenn der Mitarbeiter an mehreren Orten oder im Homeoffice arbeitet, ist die Adresse des Unternehmenssitzes maßgeblich.",
                "client_address_title": "Identisch mit der Unternehmensadresse",
                "other_address_title": "Andere Adresse wählen",
                "add_address": "Andere Adresse",
                "other_address": "Andere Adresse",
                "tip": "Diese Information dient nur dazu, eventuelle Gesamtarbeitsverträge (GAV) zu bestimmen, die je nach Stadt oder Kanton, in dem die Tätigkeit stattfindet, gelten könnten.",
                "private_client_address_title": "Adresse",
                "private_client_description_top": "Bitte geben Sie die Wohnadresse an, an der die Tätigkeit stattfindet. Falls der Mitarbeiter in mehreren Bereichen des Haushalts tätig ist, geben Sie bitte die Hauptadresse an.",
                "incomplete_address": "Die Adresse ist unvollständig. Bitte ergänzen Sie sie."
            },
            "create_mission_cct": {
                "title": "Sind Sie einem GAV unterstellt?",
                "description_top": "Wenn Sie einem Gesamtarbeitsvertrag (GAV) unterstellt sind, geben Sie dies bitte unten an.",
                "cannot_load": "Hoppla! Beim Laden dieser Seite ist ein Fehler aufgetreten. Können Sie es in einem Moment noch einmal versuchen?",
                "unsupported_cct": "Entschuldigung, dieser GAV wird von der App noch nicht unterstützt, aber wir arbeiten daran!\n\nBitte kontaktieren Sie den [Support](intercom://) für weitere Informationen.",
                "default_cct_description": "Der GAV Personalverleih wird standardmäßig angewendet.",
                "get_worker_infos": "Informationen zur Ausbildung und Erfahrung von {{name}} finden Sie unten.\n\n[Weitere Informationen]()",
                "modal_title_prefix": "Informationen über",
                "modal_intro": "Hier finden Sie die wichtigsten Punkte zu {{name}}:",
                "age": "Alter",
                "training": "Ausbildung",
                "years_experiences": "Berufserfahrung in Jahren",
                "age_value": "{{age}} Jahre",
                "years_experiences_value": "{{yearsExperiences}} Jahre",
                "no_years_experiences": "Keine Erfahrung",
                "document": "Dokument {{index}}",
                "cct_details_link": "Ausgewählten GAV lesen",
                "no_cct": "Kein GAV",
                "other_cct": "Einem anderen GAV unterstellt",
                "dont_know": "Ich weiß nicht...",
                "lse_cct": "Personalverleih",
                "need_help": "Wenn Sie nicht wissen, welchem GAV Sie unterstellt sind, wenden Sie sich bitte an unseren Support, und wir werden Sie informieren.\n\nDanach können Sie den Prozess zur Erstellung des Arbeitsvertrags fortsetzen.",
                "show_help": "Support kontaktieren",
                "other_cct_tip": "Wenn Ihr GAV nicht in der untenstehenden Liste aufgeführt ist, wählen Sie bitte den GAV \"Personalverleih\".",
                "no_cct_select": "Wenn Sie Zweifel haben oder einem anderen GAV unterstellt sind, [kontaktieren Sie bitte den Support.](intercom://)",
                "private_client_title": "Zusätzliche Informationen",
                "private_description_top": "Die folgenden Informationen sind erforderlich, um den Mindestlohn des entsprechenden Tätigkeitsbereichs festzulegen.",
                "no-cct-info": "In Ermangelung eines GAV gelten das Arbeitsgesetz und das Obligationenrecht.",
                "default_lse": "Der GAV Personalverleih wird standardmässig angewendet.",
                "select_cct": "Wählen Sie den anzuwendenden GAV",
                "hours_adjusted_title": "Arbeitszeit aktualisiert",
                "hours_adjusted_message": "Die wöchentliche Arbeitszeit wurde von {{oldHours}} Stunden auf {{newHours}} Stunden pro Woche angepasst, um dem ausgewählten GAV zu entsprechen.",
                "hours_adjusted_message_default_cct": "Die maximale wöchentliche Arbeitszeit wurde von {{oldHours}} Stunden auf {{newHours}} Stunden pro Woche angepasst, um der GAV Personalverleih zu entsprechen."
            },
            "create_mission_cct_details": {
                "title": "Details zum GAV",
                "description_top_extra": "Sie haben den GAV \"{{cctName}}\" ausgewählt.\n\nUm den Regeln dieses GAV zu entsprechen, benötigen wir die folgenden Informationen zu diesem Arbeitsvertrag:",
                "description_top_no_extra": "Sie haben den GAV \"{{cctName}}\" ausgewählt. Dieser GAV enthält keine Besonderheiten.",
                "error_loading_fields": "Hoppla! Ein Fehler ist aufgetreten. Können Sie es in einem Moment noch einmal versuchen?",
                "show_help": "Allgemeine Informationen zum obigen Formular",
                "region_description": "Geben Sie die Region an, in der die Tätigkeit ausgeübt wird",
                "contact_assistance": "Bei Unsicherheiten bei der Auswahl des GAV (Gesamtarbeitsvertrag) können Sie den Support kontaktieren.",
                "personnel_categery": "Wählen Sie die Kategorie entsprechend den Qualifikationen des Mitarbeiters.",
                "region_help": "Wenn der Mitarbeiter an mehreren Orten oder im Homeoffice arbeitet, gilt die Adresse des Firmensitzes.",
                "introduction_period": "Wird der Vertrag während oder nach der Einführungsphase abgeschlossen?",
                "business_type": "Welche Beschreibung trifft am besten auf Ihren Betrieb zu?",
                "experience_level": "Geben Sie die Erfahrung des Mitarbeiters im mit dem Vertrag verbundenen Bereich an.",
                "default_title": "Wählen Sie eine Option"
            },
            "create_mission_duration": {
                "title": "Arbeitszeitraum",
                "cdi_label": "Unbefristet",
                "cdd_label": "Befristet",
                "add_start_date": "Ein Datum auswählen",
                "start_date_label": "Beginn des Arbeitsvertrags",
                "end_date_label": "Ende des Arbeitsvertrags",
                "invalid_start_date": "Bitte wählen Sie ein gültiges Startdatum für den Vertrag.",
                "indeterminate": "Unbefristet",
                "review_description_daily": "Der Mitarbeiter wird {{workingTime}} im oben definierten Zeitraum.",
                "review_description_hourly": "Der Mitarbeiter wird {{workingTime}} im oben definierten Zeitraum."
            },
            "create_mission_earning_type": {
                "title": "Vertragstyp",
                "description_top": "Der Lohn wird pauschal berechnet.",
                "monthly": {
                    "label": "Monatlich",
                    "description": "Der Lohn wird auf monatlicher Basis berechnet."
                },
                "hourly": {
                    "label": "Stündlich",
                    "description": "Der Lohn wird auf stündlicher Basis berechnet."
                },
                "working_percent_format": "{{hours}} Stunden/Woche = 100%",
                "select_working_percentage": "Wählen Sie einen Beschäftigungsgrad aus",
                "hours_per_week": "Um die Vergütung korrekt zu berechnen, geben Sie bitte an, wie viele Stunden pro Woche der Mitarbeiter bei einer Vollzeitstelle (100 %) arbeiten würde.",
                "time_sheets": "Die vom Mitarbeiter ausgefüllte Stundenerfassung ist verbindlich, sobald sie vom Arbeitgeber bestätigt wurde.",
                "hours_per_week_placeholder": "Auswählen",
                "oneShot": {
                    "label": "Punktuell",
                    "description": "Der Mitarbeiter arbeitet an bestimmten Tagen, mit einem auf Stundenbasis berechneten Lohn."
                },
                "daily": {
                    "label": "Täglich",
                    "description": "Der Lohn wird auf Tagesbasis berechnet."
                },
                "package": {
                    "label": "Pauschale",
                    "description": "Der Lohn besteht aus einem im Voraus vereinbarten festen Betrag."
                },
                "default_value": "Standardmäßig"
            },
            "create_mission_working_time": {
                "title": "Arbeitszeiten",
                "classic": {
                    "label": "Normale wöchentliche Arbeitszeit",
                    "description": "- von Montag bis Freitag\n- beginnt nicht vor 6 Uhr\n- endet nicht nach 22 Uhr"
                },
                "schedule": {
                    "label": "Spezifische wöchentliche Arbeitszeit",
                    "description": "- feste wöchentliche Tage/Stunden (z. B. 7 - 14 Uhr)\n- Sonntags-/Feiertagsarbeit\n- Nachtarbeit"
                },
                "specific": {
                    "label": "Spezifisches Datum/Uhrzeit",
                    "description": "- spezifischer Tag/Uhrzeit"
                },
                "use_company_policy": "Verwenden Sie das Unternehmensreglement, um die Arbeitszeiten festzulegen."
            },
            "create_mission_working_time_more": {
                "title": "Arbeitszeit",
                "minimum_duration_error": "Die wöchentliche Dauer muss mehr als eine Stunde betragen."
            },
            "create_mission_summary": {
                "title": "Zusammenfassung",
                "description": "Überprüfen Sie die folgenden Informationen, bevor Sie zur Vertragsunterzeichnung übergehen.",
                "next_title": "Vertrag erstellen",
                "save_contract": "Vertrag speichern"
            },
            "create_mission_finish": {
                "title": "Der Vorschlag wurde gesendet!",
                "description": "Beschreibung hinzufügen",
                "next_title": "Zu meinem Dashboard"
            },
            "accept_worker_contract": {
                "title": "Unterzeichnen Sie den Rahmenvertrag",
                "next_title": "Unterzeichnen",
                "wait_asset_contract": "Ihr Vertrag wird vorbereitet. Bitte haben Sie einen Moment Geduld..."
            },
            "accept_client_contract": {
                "title": "Allgemeine Bedingungen des Personalverleihs unterzeichnen",
                "next_title": "Unterzeichnen",
                "wait_asset_contract": "Ihr Vertrag wird gerade vorbereitet. Bitte warten Sie einen Moment…"
            },
            "mission_accept_mission_contract": {
                "title_worker": "Unterzeichnen Sie den Arbeitsvertrag",
                "title_client": "Unterzeichnen Sie den Personalverleihvertrag",
                "next_title": "Unterzeichnen",
                "wait_asset_contract": "Ihr Vertrag wird gerade vorbereitet. Bitte warten Sie einen Moment…"
            },
            "done_message": {
                "next_title": "Zu meinem Dashboard",
                "worker_accepted_waiting": {
                    "title": "Der Vorschlag wurde gesendet!",
                    "description": "Der Vertragsvorschlag wurde Lift zur Validierung vorgelegt."
                },
                "worker_accepted_full": {
                    "title": "Der Vertrag ist validiert!",
                    "description": "Wir freuen uns auf Ihre Zusammenarbeit mit {{clientName}}. Die Anweisungen von {{clientName}} werden Ihnen demnächst zugesandt."
                },
                "client_accepted_waiting": {
                    "title": "Vorschlag gesendet!",
                    "description": "Der Vertragsvorschlag wurde Lift zur Validierung vorgelegt."
                },
                "client_accepted_full": {
                    "title": "Vertrag validiert!",
                    "description": "Wir freuen uns auf Ihre Zusammenarbeit mit {{workerName}}. Vergessen Sie nicht, Ihre Anweisungen vor Beginn des Arbeitsvertrags bereitzustellen."
                }
            },
            "contract_details": {
                "cannot_load": "Ladefehler!",
                "awaiting_talent_signature": "Warten auf die Unterschrift des Mitarbeiters",
                "awaiting_client_signature": "Unterschrift der verantwortlichen Person ausstehend",
                "awaiting_your_signature": "Warten auf Ihre Unterschrift",
                "awaiting_lift_signature": "Warten auf die Unterschrift von Lift",
                "job_title": "Tätigkeit",
                "start_date": "Beginn des Arbeitsvertrags",
                "check_other_mission": "Achten Sie darauf, dass Sie keinen anderen laufenden Arbeitsvertrag haben.",
                "end_date": "Ende des Arbeitsvertrags",
                "no_end_date": "Unbefristet",
                "work_percent": "Beschäftigungsgrad",
                "signing_state": "Status der Unterzeichnung",
                "signing": "Unterzeichnung",
                "address": "Ort",
                "work_time": "Arbeitszeit",
                "talent": "Mitarbeiter",
                "contract_pdf": "Arbeitsvertrag (PDF)",
                "rejected_reason": "Grund: {{reason}}. (Vertragsende: {{terminationDate}})",
                "contract_rejected": "Vertrag storniert",
                "contract_terminated": "Vertrag gekündigt",
                "cct": "GAV",
                "signing_failed": "Die Unterzeichnung ist leider fehlgeschlagen.\n\nBitte kontaktieren Sie den [Support](intercom://) für weitere Informationen.",
                "processing_contracts": "Die Verträge werden vorbereitet...",
                "signature_success": "Verträge erfolgreich unterzeichnet",
                "signature_failed": "Die Unterzeichnung ist fehlgeschlagen.",
                "signature_cancelled_by_self": "Sie haben die Unterzeichnung abgebrochen.",
                "signature_canceled_by_client": "Die Unterzeichnung wurde vom Arbeitgeber abgebrochen.",
                "signature_canceled_by_worker": "Die Unterzeichnung wurde vom Mitarbeiter abgebrochen.",
                "signature_canceled_by_lift": "Die Unterzeichnung wurde von Lift abgebrochen.",
                "processing_your_signature": "Ihre Unterschrift wird derzeit verarbeitet.",
                "job_description": "Beschreibung",
                "legal_employer": "Rechtlicher Arbeitgeber",
                "client": "Arbeitgeber",
                "mission_employer": "Arbeitgeber",
                "awaiting_self_client_signature": "Warten auf die Unterschrift von {{clientName}} ({{clientUserName}})",
                "awaiting_lift_signature_long": "Die Unterschrift von Lift wird innerhalb der nächsten 24 Arbeitsstunden erwartet.",
                "discover_contract_steps": "Die verschiedenen Schritte des Vertrags kennenlernen",
                "pending_termination": "Kündigungsanfrage in Bearbeitung",
                "amendment_awaiting_your_signature": "Zusatzvereinbarung wartet auf Ihre Unterschrift",
                "amendment_awaiting_worker_signature": "Zusatzvereinbarung wartet auf die Unterschrift des Mitarbeiters",
                "awaiting": "Ausstehend",
                "signed": "Unterzeichnet",
                "canceled": "Storniert",
                "awaiting_self_client_company_signature": "Warten auf die Unterschrift von {{clientName}}",
                "handwitten_in_progress": "Handschriftliche Unterschrift ausstehend"
            },
            "resend_verification_email": {
                "title": "Überprüfung",
                "text": "Leider wurde Ihre E-Mail-Adresse noch nicht bestätigt.\nFalls Sie die E-Mail nicht erhalten haben, klicken Sie bitte auf die Schaltfläche unten, um eine neue Bestätigungs-E-Mail zu erhalten.",
                "button_text": "E-Mail erneut senden",
                "error_text": "Beim Versand der Bestätigungs-E-Mail ist ein Fehler aufgetreten. Können Sie es bitte erneut versuchen?",
                "sent_text": "Eine Bestätigungs-E-Mail wurde an {{email}} gesendet. Bitte überprüfen Sie Ihren Posteingang."
            },
            "create_mission_hotellerieRestaurationFees": {
                "title": "Mit dem GAV verbundene Kosten",
                "description": "Wenn Sie die Reinigung und das Bügeln der folgenden Ausrüstung nicht übernehmen, geben Sie dies bitte an. Entsprechende Pauschalen für die entstandenen Kosten werden zum Lohn des Mitarbeiters hinzugefügt.",
                "yes_no_fees": "Ja, vom Betrieb bereitgestellt",
                "no": "Nein, nicht nötig",
                "yes_with_fees": "Ja, vom Mitarbeiter bereitgestellt",
                "selectFeesDescription": "Das Unternehmen übernimmt:"
            },
            "create_mission_deductions": {
                "title": "Abzüge",
                "info": "Falls vorhanden, geben Sie die Naturalleistungen (Mahlzeiten, Unterkunft, Fahrzeug usw.) an, von denen der Mitarbeiter profitiert und die Sie von seinem Lohn abziehen möchten.",
                "description_field": "Beschreibung",
                "next_title": "Weiter",
                "add_deduction": "Abzug hinzufügen",
                "remove_deduction": "Abzug löschen",
                "remove_title": "Abzug löschen",
                "remove_info": "Sind Sie sicher, dass Sie diesen Abzug löschen möchten?",
                "do_remove": "Ja, löschen"
            },
            "create_mission_time_sheet": {
                "title": "Stundenerfassung",
                "info": "Wählen Sie das System zur Stundenerfassung, das Sie verwenden möchten. Die Stundenerfassung dient zur Berechnung der Vergütung des Mitarbeiters.",
                "payroll_source_manual_client_title": "Externe Stundenerfassung",
                "payroll_source_manual_client_description": "Sie erstellen selbst eine monatliche Abrechnung der Arbeitsstunden Ihres Mitarbeiters und reichen diese anschließend bei Lift ein.",
                "payroll_source_manual_client_tag": "Sie können auf den Vertrag zugreifen und die monatliche Abrechnung ausfüllen.",
                "payroll_source_lift_title": "Lift-Stundenerfassung",
                "payroll_source_lift_description": "Der Mitarbeiter erfasst seine Stunden jede Woche in der App und reicht sie Ihnen zur Validierung ein. Anschließend übermitteln Sie die monatliche Abrechnung auf Lift."
            },
            "help": {
                "ask_assistance": "Supportanfrage",
                "see_all_articles": "Alle Artikel anzeigen"
            },
            "todos": {
                "title": "Meine Aufgaben",
                "no_activity": "Die von Ihnen zu erledigenden Aktionen werden hier angezeigt.",
                "cannot_load_todos": "Entschuldigung, beim Laden ist ein Fehler aufgetreten.",
                "filters": {
                    "breakdown": "Abrechnungen",
                    "invoice": "Rechnungen",
                    "contract": "Verträge",
                    "other": "Sonstiges",
                    "account": "Konto",
                    "timesheet": "Stundenerfassungen",
                    "all": "Alle Aufgaben"
                }
            },
            "activity_log": {
                "title": "Mein Journal",
                "no_activity": "Ihr Aktivitätsverlauf wird hier angezeigt."
            },
            "create_mission_salary_daily": {
                "title": "Tageslohn",
                "requested_salary_label": "Tageslohn",
                "min_salary_info": "Der minimale Bruttotageslohn beträgt {{amount}}.",
                "counting_details": "[Detaillierte Tagesabrechnung](SalaryCountingDetails)",
                "min_salary_info_plus": "Der minimale Tageslohn {{salaryType}} beträgt {{amount}}."
            },
            "my_invoices": {
                "title": "Meine Rechnungen",
                "no_invoices": "Alle Ihre Rechnungen werden hier angezeigt."
            },
            "create_mission_ijm": {
                "title": "KTG"
            },
            "create_mission_ijm_info": {
                "title": "Bitte wählen Sie Ihren KTG-Plan",
                "info_1": "Bevor Sie einen Arbeitsvertrag erstellen, müssen Sie einen Plan für Krankentaggeld auswählen.",
                "info_2": "Diese Versicherung bei der Groupe Mutuel, die für alle Arbeitsverträge Ihres Unternehmens gilt, gewährleistet die Auszahlung von 80% des Bruttolohns an die betroffenen Mitarbeiter, und zwar ab dem 3., 15. oder 31. Krankheitstag.",
                "in_collaboration_with": "In Zusammenarbeit mit"
            },
            "create_mission_salary_package": {
                "title": "Lohn",
                "requested_salary_title": "Definieren Sie den Gesamtbetrag",
                "requested_hours_title": "Geben Sie die Anzahl der Arbeitsstunden an",
                "requested_salary_label": "Lohn",
                "min_salary_info": "Der minimale Bruttolohn beträgt {{amount}} für {{hours}} Arbeitsstunden.",
                "counting_details": "[Detaillierte Tagesabrechnung](SalaryCountingDetails)",
                "min_salary_info_plus": "Der minimale Lohn {{salaryType}} beträgt {{amount}} für {{hours}} Arbeitsstunden.",
                "start_date": "Beginn",
                "end_date": "Ende",
                "max_hours": "Die Arbeitszeit darf insgesamt {{hours}} Stunden nicht überschreiten."
            },
            "my_colleagues": {
                "title": "Kollegen",
                "joined_at": "Seit dem {{joinedAt}}",
                "can_sign": "Ist berechtigt, Verträge zu unterzeichnen",
                "invite_colleague": "Kollegen einladen",
                "you": "{{name}} (Sie)"
            },
            "timesheets": {
                "cannot_load_timesheets": "Entschuldigung, beim Laden ist ein Fehler aufgetreten."
            },
            "create_mission_test_worker": {
                "title": "Testmitarbeiter konfigurieren",
                "description": "Passen Sie die Angaben des Testmitarbeiters an, um eine genaue Lohnberechnung zu erhalten."
            },
            "create_mission_simulation_summary": {
                "title": "Simulation abgeschlossen",
                "congratulations": "Herzlichen Glückwunsch!",
                "simulation_complete": "Sie haben Ihre Simulation eines Arbeitsvertrags erfolgreich abgeschlossen.",
                "salary_summary": "Zusammenfassung des simulierten Lohns",
                "email_results": "Ergebnisse per E-Mail senden",
                "email_description": "Erhalten Sie eine detaillierte Zusammenfassung dieser Simulation direkt in Ihrem Posteingang.",
                "email_placeholder": "ihre.email@beispiel.com",
                "send_email": "Per E-Mail senden",
                "send_email_success": "Simulation wurde versendet",
                "finish_without_email": "Ohne Versand beenden",
                "include_pdf_details": "Lohndetails als PDF",
                "include_contract_examples": "Musterverträge"
            },
            "colleague_details": {
                "colleague": "Kollege",
                "no_contracts": "Kein laufender Vertrag",
                "contracts": "Laufende Verträge"
            }
        },
        "client_profile_edit": {
            "title": "Mein Arbeitgeberprofil bearbeiten",
            "edit_email": "Geschäftliche E-Mail-Adresse ändern"
        },
        "worker_profile_edit": {
            "title": "Mein Profil bearbeiten"
        },
        "client_edit": {
            "title": "Unternehmen",
            "name_error": "Der Name des Unternehmens ist erforderlich.",
            "address_error": "Die Adresse ist erforderlich.",
            "save_error": "Beim Speichern Ihrer Informationen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
        },
        "account_edit": {
            "title": "Mein Konto bearbeiten"
        },
        "bank_account_edit": {
            "title": "Bankdaten"
        },
        "work_permit_edit": {
            "title": "Arbeitsbewilligung",
            "no_work_permit_error": "Sie müssen eine Arbeitsbewilligung auswählen."
        },
        "configure_lpp": {
            "title": "Vorsorge",
            "submit_request": "Anfrage senden",
            "intro": "Wir werden Sie dem Vorsorgefonds (FIP) des Centre Patronal anschließen.",
            "see_plan": "Details des Plans ansehen",
            "please_confirm": "Bitte bestätigen Sie die folgenden Punkte:",
            "has_full_working_capacity": "Ich bin voll arbeitsfähig.",
            "has_no_3_months_incapacity_in_last_12_months": "Ich habe in den letzten 12 Monaten keine Arbeitsunfähigkeit (teilweise oder vollständig) von mehr als drei Wochen gehabt.",
            "has_no_incapacity_now": "Ich bin voll arbeitsfähig und leide weder an einer Behinderung, noch an einer Krankheit oder an den Folgen eines Unfalls.",
            "has_received_disability_pension_in_last_3_years": "Ich habe in den letzten drei Jahren keine IV-Rente bezogen.",
            "has_accepted_all": "Ich bestätige, dass ich nach bestem Wissen geantwortet habe und dass die oben gemachten Angaben korrekt und vollständig sind. Ich akzeptiere die obenstehenden Bedingungen.",
            "pension_level": "Rentenstufe",
            "disability_level": "Invaliditätsgrad",
            "25percentPension": "1/4 Rente",
            "50percentPension": "2/4 Rente",
            "75percentPension": "3/4 Rente",
            "100percentPension": "4/4 Rente",
            "percentOfDisability": "{{percent}}% Invalidität"
        },
        "confirmation": {
            "done_thanks": "Das war's, vielen Dank!"
        },
        "invitations": {
            "titles": {
                "client": "Meine Einladungen",
                "worker": "Ausstehende Einladungen"
            },
            "empty": {
                "client": "Sie haben keine Einladungen.",
                "worker": "Sie haben keine ausstehenden Einladungen."
            },
            "send": "Neue Einladung senden"
        },
        "termination": {
            "actions": {
                "terminated": "Vertrag kündigen",
                "cancelled": "Vertrag stornieren",
                "ended": "Den Arbeitsvertrag beenden",
                "request": "Kündigung beantragen",
                "support": "Support"
            },
            "action_errors": {
                "terminated": "Die Kündigung des Arbeitsvertrags konnte nicht durchgeführt werden.",
                "cancelled": "Die Kündigung des Arbeitsvertrags ist fehlgeschlagen.",
                "ended": "Es war nicht möglich, diesen Arbeitsvertrag zu beenden."
            },
            "get_errors": "Die Informationen zum Arbeitsvertrag konnten nicht abgerufen werden.",
            "get_info_errors": "Die für die Kündigung des Arbeitsvertrags benötigten Informationen konnten nicht geladen werden.",
            "labels": {
                "terminated": {
                    "reason": "Grund der Kündigung",
                    "termination_date": "Datum der Kündigung",
                    "ended": "Da dieser Arbeitsvertrag beendet ist, können Sie ihn ohne Konsequenzen beenden."
                },
                "cancelled": {
                    "reason": "Grund der Stornierung",
                    "termination_date": "Datum der Stornierung",
                    "ended": "Da dieser Arbeitsvertrag beendet ist, können Sie ihn ohne Konsequenzen beenden."
                },
                "description": "Beschreibung"
            },
            "callouts": {
                "worker": {
                    "cancelled": "Der Vertrag wird storniert und Ihr Arbeitgeber wird darüber informiert.",
                    "terminated": "#### Bitte überprüfen Sie die folgenden Punkte:\n\n- Vertragsende: **%{termDate}**\n- Diese Aktion kann nicht rückgängig gemacht werden.\n- Der Saldo der bestätigten Stunden wird Ihnen am Monatsende ausbezahlt.\n- Ihr Arbeitgeber wird informiert.",
                    "ended": "Da dieser Arbeitsvertrag beendet ist, können Sie ihn ohne Konsequenzen beenden.",
                    "request": "Wenn Sie den Vertrag kündigen möchten, geben Sie bitte den Grund an. Unser Support-Team wird Sie schnell kontaktieren, um Sie zu begleiten und Ihre Fragen zu beantworten."
                },
                "client": {
                    "cancelled": "Der Vertrag wird annulliert und der Mitarbeiter informiert.",
                    "terminated": "Vergessen Sie nicht, den Mitarbeiter über Ihre Absicht zu informieren, den Vertrag zu kündigen.\n•\tVertragsende: %{termDate}\n•\tDie Kündigung des Arbeitsvertrags ist endgültig.\n•\tDer Saldo, der die Kündigungsfrist umfasst, wird Ihnen in Rechnung gestellt.\n•\tDer Mitarbeiter wird informiert.",
                    "ended": "Da dieser Arbeitsvertrag beendet ist, können Sie ihn ohne Konsequenzen beenden.",
                    "request": "Wenn Sie den Vertrag kündigen möchten, geben Sie bitte den Grund an. Unser Support-Team wird Sie schnell kontaktieren, um Sie zu begleiten und Ihre Fragen zu beantworten."
                },
                "too_early": "Das Kündigungsdatum liegt nicht innerhalb der gesetzlichen Kündigungsfrist. Bitte wählen Sie ein Datum, das frühestens am %{minimalEndDate} liegt.",
                "already_requested": {
                    "self": "Ihr Kündigungsantrag wurde bereits eingereicht. Unser Support-Team wird Sie in Kürze kontaktieren.\n\nVielen Dank für Ihre Geduld. Bei weiteren Fragen stehen wir Ihnen gerne zur Verfügung.",
                    "other": "Ein Kündigungsantrag wurde bereits eingereicht. Bei Fragen oder für weitere Klärungen wenden Sie sich bitte an den Support."
                }
            },
            "success_info": {
                "delete": "Der Arbeitsvertrag wurde gelöscht.",
                "terminate": "Der Arbeitsvertrag wurde storniert.",
                "request": "Ihre Anfrage wurde erfolgreich gesendet. Sie wird derzeit bearbeitet, und wir werden Sie so bald wie möglich informieren."
            },
            "reason": {
                "relational_problem": "Beziehungsproblem",
                "not_signed_in_time": "Der Vertrag wurde nicht rechtzeitig unterzeichnet",
                "inadequate_working_conditions": "Unzureichende Arbeitsbedingungen",
                "overqualified_labor": "Überqualifikation der Arbeitskräfte",
                "under_qualified_labor": "Unterqualifikation der Arbeitskräfte",
                "solvency_problem": "Solvenzproblem des Unternehmens",
                "weather_condition_suitability": "Ungeeignete Wetterbedingungen",
                "worker_profile_missmatch": "Der Mitarbeiter passt nicht zum Profil.",
                "signing_rejected": "Die Vertragsunterzeichnung wurde abgelehnt.",
                "busy_on_proposed_dates": "Zu den vorgeschlagenen Daten nicht verfügbar",
                "company_culture": "Unternehmenskultur",
                "distance": "Entfernung",
                "insufficient_compensation": "Unzureichende Vergütung",
                "lack_of_professional_advancement": "Fehlende Karriereperspektiven",
                "other": "Sonstiges",
                "salary_too_high": "Zu hoher Lohn",
                "skills_tasks_mismatch": "Die Aufgaben entsprechen nicht den Fähigkeiten des Mitarbeiters.",
                "unjustified_absences": "Ungerechtfertigte Abwesenheiten",
                "person_didnt_signed_in_time": "Der Vertrag wurde nicht rechtzeitig von {{personName}} unterzeichnet",
                "you_didnt_signed_in_time": "Sie haben den Vertrag nicht rechtzeitig unterzeichnet",
                "lift_didnt_signed_in_time": "Lift hat den Vertrag nicht rechtzeitig unterzeichnet",
                "lse_didnt_signed_in_time": "Lift hat den Vertrag nicht rechtzeitig unterzeichnet",
                "client_didnt_signed_in_time": "Der Arbeitgeber hat den Vertrag nicht rechtzeitig unterzeichnet",
                "worker_didnt_signed_in_time": "Der Mitarbeiter  hat den Vertrag nicht rechtzeitig unterzeichnet",
                "other_description": "Nachricht:",
                "termination_date_by": "Kündigung zum {{terminationDate}} durch {{terminatedBy}}",
                "cancelation_date_by": "Stornierung am {{terminationDate}} durch {{terminatedBy}}"
            },
            "other_reason": "Anderer Grund",
            "missing_other_reason": "Bitte geben Sie den Grund an.",
            "reason_label": "Grund",
            "header_label": {
                "cancelled_by_self": "Sie haben den Arbeitsvertrag storniert",
                "cancelled_by_person": "Der Arbeitsvertrag wurde von {{personName}} storniert",
                "cancelled_by_lse": "Der Arbeitsvertrag wurde von Lift storniert"
            },
            "select_termination_date": "Zu welchem Datum möchten Sie den Vertrag beenden?",
            "select_date": "Datum auswählen",
            "missing_date": "Gewünschtes Datum erforderlich",
            "termination_date_wish": "Gewünschtes Kündigungsdatum:",
            "termination_reason": "Grund für die Kündigungsanfrage:"
        },
        "mission_created": {
            "title": "Herzlichen Glückwunsch!",
            "description": "Der Vorschlag wurde an %{workerName} gesendet.",
            "description_2": "Sobald der Mitarbeiter den Arbeitsvertrag angenommen hat, senden wir Ihnen den Personalverleihvertrag zur Unterzeichnung und Rücksendung über die App zu.",
            "description_3": "Abschließend validiert Lift die Verträge beider Parteien.",
            "worker_contract": "Arbeitsvertrag",
            "client_contract": "Personalverleihvertrag",
            "worker_contract_description": "Zwischen Lift und %{workerName}",
            "client_contract_description": "Zwischen %{clientName} und Lift",
            "button": "Meine Arbeitsverträge"
        },
        "worker_missions": {
            "no_mission": "Dieser Mitarbeiter hat keine Arbeitsverträge."
        },
        "error_screen": {
            "not_found_title": "Die Seite wurde nicht gefunden.",
            "error_title": "Unerwarteter Fehler",
            "not_found_description": "Der Inhalt ist nicht mehr verfügbar. Dies kann verschiedene Gründe haben:\n<br>\n- der Inhalt ist veraltet;\n- der Link ist nicht mehr aktuell;\n- ein Meteorit stört das Erdmagnetfeld!\n\nUnser Team wurde informiert und tut alles, um so schnell wie möglich eine Lösung zu finden.\n\nSollte das Problem weiterhin bestehen, zögern Sie nicht, uns zu kontaktieren.",
            "error_description": "Ein vorübergehender Fehler ist aufgetreten. Dies kann folgende Ursachen haben:\n<br>\n- eine Unterbrechung der Internetverbindung;\n- ein technisches Problem;\n- ein Meteorit, der das Erdmagnetfeld stört!\n\nUnser Team wurde informiert und tut alles, um so schnell wie möglich eine Lösung zu finden.\n\nSollte das Problem weiterhin bestehen, zögern Sie nicht, uns zu kontaktieren."
        },
        "maintenance_screen": {
            "title": "Lift macht eine kleine Pause",
            "description": "Wir führen Wartungsarbeiten durch, um die App zu verbessern. **Ihre Daten sind sicher.**\n\nLift ist in wenigen Augenblicken wieder für Sie da.",
            "auto_retry": "Automatische Wiederverbindung…"
        },
        "cct_details": {
            "title": "GAV-Details"
        },
        "pre_sign": {
            "error": "Beim Abrufen der Vertragsinformationen ist ein Fehler aufgetreten.",
            "valid_info": "Sie können nun Ihren Vertrag unterzeichnen.",
            "invalid_info": "Der Vertrag wurde bereits unterzeichnet oder ist abgelaufen.",
            "other_sign_info": "{{contractType}} muss von der anderen Partei unterzeichnet werden, bevor Sie ihn unterzeichnen können.",
            "label_ready": "Voilà! {{contractType}} ist bereit zum Lesen und Unterzeichnen.",
            "label_waiting": "{{contractType}} wird vorbereitet...",
            "timeout": "Das Laden des Vertrags hat zu lange gedauert. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
            "timeout_retry": "Erneut versuchen",
            "timeout_contact": "Support kontaktieren",
            "read_and_sign_contract": "Überprüfen und unterschreiben",
            "postpone_signing": "Später unterschreiben",
            "contract": "Der Vertrag",
            "amendment": "Die Zusatzvereinbarung",
            "other_sign_contract": "Unterzeichner auswählen",
            "handwritten_title": "Sie erhalten Ihren Vertrag in Kürze per Post.",
            "handwritten_info": "Bitte unterzeichnen Sie den Vertrag und senden Sie ihn so bald wie möglich an uns zurück. Anschliessend wird er im entsprechenden Bereich in Lift hinzugefügt."
        },
        "profile_editor": {
            "title": "Profil",
            "please_complete": "bitte vervollständigen",
            "children_number": {
                "zero": "Nein",
                "one": "{{count}} Kind",
                "other": "{{count}} Kinder"
            },
            "close_warning_title": "Sind Sie sicher, dass Sie diese Seite verlassen möchten?",
            "close_warning_description": "Nicht gespeicherte Informationen gehen verloren.",
            "quit": "Verlassen",
            "continue": "Fortfahren",
            "finalize_my_signup": "Abschließen",
            "civil_state": {
                "title": "AHV/Zivilstand",
                "partner_first_name": "Vorname des Ehepartners",
                "partner_last_name": "Nachname des Ehepartners",
                "partner_avs": "AHV-Nummer des Ehepartners",
                "partner_has_revenue": "Hat Ihr Ehepartner ein Einkommen?",
                "partner_revenue": "Monatlicher Bruttolohn Ihres Ehepartners",
                "partner_revenue_description": "Ohne Angaben zum Einkommen wird der Steuersatz der höchsten Tarifstufe angewendet.",
                "has_other_activity": "Üben Sie neben Lift eine weitere Tätigkeit aus?",
                "errors": {
                    "update_avatar_error": "Beim Speichern der Daten ist ein Fehler aufgetreten.",
                    "not_unique_own_avs": "Ihre AHV-Nummer darf nicht mit der Ihres Ehepartners identisch sein.",
                    "not_unique_partner_avs": "Die AHV-Nummer Ihres Ehepartners darf nicht mit Ihrer identisch sein.",
                    "update_worker_profile_error": "Beim Speichern der Daten ist ein Fehler aufgetreten.",
                    "partner_revenue_cannot_be_0": "Das Einkommen Ihres Ehepartners darf nicht 0 sein"
                },
                "civil_state": "Zivilstand",
                "work_rate_percentage": "Beschäftigungsgrad in Prozent",
                "work_rate_percentage_description": "Diese Angaben sind erforderlich, um den Quellensteuertarif zu bestimmen.",
                "default_work_rate_percentage": "100 % (Standard)",
                "no_avs_number": "Ich habe keine AHV-Nummer",
                "partner_nationality": "Staatsangehörigkeit des Ehepartners",
                "partner_permit": "Arbeitsbewilligung des Ehepartners",
                "search_country": "Land suchen",
                "church_member": "Sind Sie Mitglied einer von Ihrem Kanton anerkannten Kirche (zum Beispiel der reformierten, römisch-katholischen oder christkatholischen Kirche)?",
                "sleeps_in_switzerland": "Übernachten Sie unter der Woche in der Schweiz und kehren am Wochenende nach Hause zurück?",
                "weekly_residence_canton": "In welchem Kanton?"
            },
            "fiscal_attestation": {
                "title": "Steuerbescheinigung",
                "has_fiscal_attestation": "Sind Sie im Besitz einer Steuerbescheinigung?",
                "import_fiscal_attestation": "Steuerbescheinigung importieren",
                "has_fiscal_attestation_description": "Die offizielle Bescheinigung des Wohnsitzlandes muss von der zuständigen Institution unterzeichnet sein. Ist das Dokument ungültig, unterliegen Sie der Quellensteuer.",
                "has_no_fiscal_attestation_description": "Sie unterliegen der Quellensteuer.",
                "upload_fiscal_attestation_error": "Beim Hochladen der Bescheinigung ist ein Fehler aufgetreten."
            },
            "children": {
                "title": "Unterhaltsberechtigte(s) Kind(er)",
                "do_you_have_children": "Haben Sie unterhaltsberechtigte Kinder?",
                "children_first_name": "Vorname des Kindes",
                "children_last_name": "Nachname des Kindes",
                "children_birth_date": "Geburtsdatum des Kindes",
                "children_gender": "Geschlecht des Kindes",
                "children_avs": "AHV-Nummer des Kindes",
                "add_children": "Ein Kind hinzufügen",
                "remove_children": "Das Kind entfernen",
                "errors": {
                    "not_unique_avs": "Diese AHV-Nummer wurde bereits verwendet."
                },
                "in_first_education": "Befindet sich %{name} noch in der Erstausbildung (Lehre, Schule, erstes Hochschulstudium) und tragen Sie den Grossteil der Lebenshaltungskosten?"
            },
            "bank_account": {
                "title": "Lohnkonto"
            },
            "diploma_and_training": {
                "title": "Diplome und Ausbildungen"
            },
            "new_profile": "Neues Profil",
            "home_address": {
                "title": "Wohnadresse"
            },
            "title_client": "Arbeitgeberprofil Unternehmen",
            "title_private_client": "Private Arbeitgeberprofil",
            "title_worker": "Mitarbeiterprofil",
            "administrative_data": "Administrative Informationen",
            "experiences": {
                "title": "Qualifikationen",
                "has_education": "Haben Sie eine Ausbildung absolviert oder Erfahrung in einem bestimmten Beruf gesammelt?",
                "fill_in_data": "Fügen Sie Ihren Lebenslauf hinzu, um einen Lohn zu erhalten, der Ihren Qualifikationen entspricht.",
                "import_cv": "Lebenslauf importieren (PDF, LinkedIn)",
                "import_pdf": "PDF importieren",
                "import_linkedin": "LinkedIn-URL einfügen",
                "paste_linkedin_url": "Geben Sie die URL Ihres LinkedIn-Profils ein",
                "invalid_linkedin_link": "Ungültige LinkedIn-URL",
                "clear": {
                    "linkedin_link": {
                        "title": "LinkedIn-Link entfernen",
                        "description": "Möchten Sie diese URL wirklich entfernen?"
                    },
                    "other": {
                        "title": "Lebenslauf löschen",
                        "description": "Möchten Sie Ihren Lebenslauf wirklich löschen? Sie können ihn jederzeit erneut hochladen."
                    }
                },
                "clear_data": "Lebenslauf löschen",
                "create_cv": "Lebenslauf manuell erstellen",
                "trainings": "Ausbildungen",
                "experiences": "Berufserfahrungen",
                "education_level": "Ausbildungsniveau",
                "training_name": "Name der Ausbildung",
                "profession_name": "Stellenbezeichnung",
                "years_of_experience": "Berufserfahrung in Jahren",
                "add_training": "Ausbildung hinzufügen",
                "add_experience": "Erfahrung hinzufügen",
                "pdf_cv": "Lebenslauf (PDF)",
                "clear_data_description": "Möchten Sie dieses Dokument wirklich löschen?",
                "my_cv": "Mein Lebenslauf",
                "view_link": "Link öffnen",
                "view_document": "Dokument anzeigen"
            },
            "curriculum_vitae_pdf": "Lebenslauf (PDF)",
            "without_qualifications": "Ohne Qualifikationen",
            "kyc": {
                "title": "Identitätsprüfung"
            },
            "private_email": {
                "title": "Private E-Mail"
            },
            "email": {
                "title": "E-Mail-Adresse",
                "title_business": "Geschäftliche E-Mail-Adresse",
                "verify": "Überprüfen Sie Ihre E-Mail-Adresse",
                "verified_badge": "Verifiziert",
                "not_verified_description": "Wir haben Ihnen eine E-Mail gesendet. Klicken Sie auf die Schaltfläche, um Ihre E-Mail-Adresse zu bestätigen. Ohne diese Bestätigung können wir Ihnen keine E-Mails und keine wichtigen Dokumente senden.",
                "verified_description": "Ihre E-Mail-Adresse wurde erfolgreich verifiziert. Sie können sie bei Bedarf hier ändern.",
                "verified_description_postonboarding": "Ihre E-Mail-Adresse wurde erfolgreich verifiziert. Sie können sie bei Bedarf auf Ihrer Profilseite ändern.",
                "resend": "Bestätigungs-E-Mail erneut senden",
                "resend_sent": "Eine Bestätigungs-E-Mail wurde an {{email}} gesendet. Bitte überprüfen Sie Ihren Posteingang.",
                "private_email_required_description": "Geben Sie eine E-Mail-Adresse für Ihr Arbeitnehmerprofil ein. Anschliessend erhalten Sie eine E-Mail mit einem Link, über den Sie Ihre neue E-Mail-Adresse bestätigen können."
            }
        },
        "payroll_breakdown_list": {
            "title": "Abrechnungen",
            "cannot_load": "Die Abrechnungen können nicht geladen werden",
            "submit_breakdown": "Abrechnung prüfen und bestätigen",
            "no_breakdowns": "Keine Abrechnung",
            "complete_timesheets": "Stundenerfassung ausfüllen",
            "check_submit_breakdown": "Abrechnung prüfen und bestätigen",
            "fill_submit_breakdown": "Abrechnung ausfüllen",
            "fix_timesheets": "Stundenerfassung korrigieren"
        },
        "payroll_breakdown": {
            "title": "Abrechnung",
            "cannot_load": "Die Abrechnung kann nicht geladen werden",
            "show_timesheets_action": "Stundenerfassung",
            "timesheets": "Stundenerfassung",
            "info_text": {
                "client": {
                    "submitted": "Die Abrechnung wurde am %{date} eingereicht.",
                    "external_ts": "Bitte füllen Sie die Abrechnung aus.",
                    "lift_ts_completed": "Bitte validieren Sie Ihre Abrechnung.\n\nDie unten stehenden Daten wurden aus den vom Mitarbeiter eingereichten Stundenerfassungen berechnet.",
                    "lift_ts_open": "Bitte validieren Sie die Abrechnung, sobald der Mitarbeiter Ihnen seine Stundenerfassung für diesen Zeitraum übermittelt hat.",
                    "empty_period": "Diese monatliche Abrechnung umfasst nur Wochen, die vor dem 20. des Monats enden. Da die Tätigkeit nach diesem Datum begonnen hat, sind keine Wochen in dieser Abrechnung enthalten.",
                    "auto_submitted": "Die Abrechnung wurde am %{date} automatisch von Lift bestätigt."
                },
                "worker": {
                    "submitted": "Abrechnung am %{date} von %{clientName} eingereicht.",
                    "external_ts": "Die Abrechnung wird sichtbar sein, sobald sie vom Arbeitgeber übermittelt wurde.",
                    "lift_ts_completed": "Die Abrechnung wartet auf Bestätigung.",
                    "lift_ts_open": "Bitte reichen Sie Ihre Stundenerfassung für diesen Zeitraum ein, damit der Arbeitgeber die Abrechnung bestätigen kann.",
                    "empty_period": "Diese monatliche Abrechnung umfasst nur Wochen, die vor dem 20. des Monats enden. Da die Tätigkeit nach diesem Datum begonnen hat, sind keine Wochen in dieser Abrechnung enthalten.",
                    "auto_submitted": "Die Abrechnung wurde am %{date} automatisch von Lift bestätigt."
                }
            },
            "info_text_client": "Die Abrechnung von %{workerName} wurde am %{date} eingereicht.",
            "info_text_worker": "Abrechnung eingereicht am %{date} von %{clientName}.",
            "final_settlement": "Schlussabrechnung",
            "tracking_dates": "Zeitraum: %{period}",
            "is_extra_month": "Diese Abrechnung betrifft nur Überstunden, verbleibende Ferien, Spesen und noch nicht berücksichtigte Abzüge; der Monatslohn ist nicht enthalten.",
            "to_review": "Zu prüfen",
            "timesheets_empty": "Für diesen Zeitraum wurden keine Arbeitszeitblätter erfasst.",
            "additions": {
                "title": "Weitere Elemente der Abrechnung",
                "count_line": "{{title}}: {{count}} × {{unitPrice}}",
                "overtime_paid": "Ausbezahlte Überstunden",
                "overtime_paid_at": "{{hours}} ausbezahlt zu {{percent}} %"
            }
        },
        "payroll_breakdown_editor": {
            "title": "Abrechnung (bearbeiten)",
            "cannot_load": "Die Abrechnung kann nicht geladen werden",
            "snackbar_submitted": "Abrechnung erfolgreich eingereicht",
            "info_text": "Bitte füllen Sie die Abrechnung aus.",
            "incomplete_timesheets": "Unvollständig",
            "preview": "Zusammenfassung",
            "no_data": "Vervollständigen Sie die obigen Informationen, um die Zusammenfassung zu sehen",
            "invoice": "Rechnung (ohne MwSt.)",
            "error_getting_summary": "Fehler bei der Berechnung der Zusammenfassung",
            "product_keys": {
                "dynamic_fee": "Pauschalspesen",
                "deduction": "Abzüge",
                "salary": "Lohn",
                "bonus": "Bonus",
                "salary_monthly_full": "In Rechnung gestellter Lohn",
                "salary_monthly_partial": "Teilweise in Rechnung gestellter Lohn",
                "salary_daily": "Tageslohn",
                "salary_hourly": {
                    "zero": "",
                    "one": "{{count}} Stunde zu 100%",
                    "other": "{{count}} Stunden zu 100%"
                },
                "salary_package": "Pauschale",
                "salary_overtime_0": {
                    "zero": "",
                    "one": "{{count}} zusätzliche Arbeitsstunde",
                    "other": "{{count}} zusätzliche Arbeitsstunden"
                },
                "salary_overtime_25": {
                    "zero": "",
                    "one": "davon Zuschlag von 25% für {{count}} Stunde",
                    "other": "davon Zuschlag von 25% für {{count}} Stunden"
                },
                "salary_overtime_50": {
                    "zero": "",
                    "one": "davon Zuschlag von 50% für {{count}} Stunde",
                    "other": "davon Zuschlag von 50% für {{count}} Stunden"
                },
                "salary_bonus": "Bonus: {{description}}",
                "effective_fee": "Effektive Spesen: {{description}}",
                "variable_fee": "Variable Spesen",
                "fee_public_transport": "{{repetition}} zu {{unitPrice}} (ÖV-Kosten)",
                "fee_private_transport": "{{repetition}} zu {{unitPrice}} (Privattransportkosten)",
                "fee_food": "{{repetition}} zu {{unitPrice}} (Verpflegungskosten)",
                "fee_phone": "{{repetition}} zu {{unitPrice}} (Telefonkosten)",
                "fee_remote_work": "{{repetition}} zu {{unitPrice}} (Kosten für Homeoffice)",
                "fee_other": "{{repetition}} zu {{unitPrice}} ({{description}})",
                "lift_deduction": "{{repetition}} zu {{unitPrice}} ({{description}})",
                "with_charges": "Sozialabgaben inbegriffen",
                "salary_overtime_0_from_balance": {
                    "zero": "",
                    "one": "{{count}} Stunde zu {{percent}}% mit dem Saldo kompensiert",
                    "other": "{{count}} Stunden zu {{percent}}% mit dem Saldo kompensiert"
                },
                "absence": "Abwesenheit",
                "salary_overtime_100": {
                    "zero": "",
                    "one": "davon Zuschlag von 100% für {{count}} Stunde",
                    "other": "davon Zuschlag von 100% für {{count}} Stunden"
                },
                "nb_days": {
                    "zero": "",
                    "one": "{{count}} Tag",
                    "other": "{{count}} Tage"
                },
                "nb_hours": {
                    "zero": "",
                    "one": "{{count}} Stunde",
                    "other": "{{count}} Stunden"
                },
                "paid_vacation": "Auszahlung der nicht bezogenen Ferien",
                "vacation_compensation": "Ferienentschädigung",
                "salary_overtime_15": {
                    "zero": "",
                    "one": "inkl. 15% Überstundenzuschlag für {{count}} Stunde",
                    "other": "inkl. 15% Überstundenzuschlag für {{count}} Stunden"
                }
            },
            "product_categories": {
                "vacation_compensation": "Ferienentschädigung",
                "salary": "Entgelt",
                "bonus": "Bonus",
                "deduction": "Pauschale Abzüge",
                "dynamic_fee": "Tägliche Pauschalspesen",
                "effective_fee": "Effektive Spesen",
                "variable_fee": "Sonstige Pauschalspesen",
                "absence": "Abwesenheit",
                "auxiliary_salary": "Nebentätigkeiten"
            },
            "error_saving": "Fehler beim Speichern der Abrechnung",
            "preview_need_compute": "Lohn und Gesamtbetrag vorbehaltlich der Bestätigung der Abwesenheiten.",
            "agree_breakdown_is_correct": "Mit der Bestätigung versichern Sie, dass die Abrechnung korrekt ist und die Zuschlagsstunden überprüft wurden.",
            "repetitions": {
                "worked_day": {
                    "zero": "",
                    "one": "{{count}} Tag",
                    "other": "{{count}} Tage"
                },
                "worked_month": {
                    "zero": "",
                    "one": "{{count}} Monat",
                    "other": "{{count}} Monate"
                },
                "count": {
                    "zero": "",
                    "one": "{{count}} Mal",
                    "other": "{{count}} Mal"
                }
            },
            "contact_us": "Kontaktieren Sie uns, wenn Sie Fragen haben",
            "review_timesheets": "Die Stundenerfassung überprüfen",
            "review_timesheets_description": "Öffnen Sie die Seite mit den zu dieser Abrechnung gehörenden Stundenerfassungen und wählen Sie anschließend diejenige aus, die korrigiert werden soll. Der Mitarbeiter wird automatisch informiert und übermittelt Ihnen anschließend die überarbeitete Version.",
            "with_gross_amount": "{{title}} ({{amount}} brutto)"
        },
        "phone_number_edit": {
            "title": "Telefonnummer",
            "phone_number": "Telefonnummer"
        },
        "invite_client": {
            "title": "Einen Arbeitgeber einladen",
            "invite": "Einladen",
            "copy_text": "Text kopieren",
            "copied": "Kopiert",
            "description": "Denken Sie daran, weitere Unternehmen einzuladen, sich Ihnen auf Lift anzuschließen und Sie direkt über die Plattform anzustellen!\nDies verschafft Ihnen einen klaren Überblick über Ihre Einnahmen und stärkt Ihren sozialen Schutz durch zentralisierte Beiträge bei einer einzigen Pensionskasse.\n\nAuch für Arbeitgeber ist dies ein echter Vorteil: Lift übernimmt die administrative Personalverwaltung und reduziert Risiken im Zusammenhang mit arbeitsrechtlicher und sozialversicherungsrechtlicher Nichtkonformität.\n\nEine einfache, effiziente und sichere Lösung für alle Beteiligten.",
            "shared_title": "Lift App – Ihr professioneller Partner",
            "shared_message": "Guten Tag,\n\nIch möchte Sie als Arbeitgeber auf Lift einladen, um anschließend einen Arbeitsvertrag zu erstellen.\n\nMelden Sie sich an, um Ihre Vorteile zu entdecken. Laden Sie die App herunter: https://app.liftapp.ch/invite/ oder besuchen Sie unsere Website: https://webapp.liftapp.ch",
            "dismissed_action": "Freigabe abgebrochen"
        },
        "fees_and_deductions": {
            "title": "Kosten und Abzüge",
            "employeer_fees": "Kosten des Arbeitgebers",
            "talent_fees": "Kosten zu Lasten des Mitarbeiters",
            "cct_fees": "Kosten gemäss GAV",
            "fees_description": "%{amount} %{repetition}, Sozialabgaben abgezogen"
        },
        "private_client_edit": {
            "title": "Privater Arbeitgeber"
        },
        "contract_preview": {
            "error": "Fehler beim Laden des Vertrags",
            "loading_document": "Vertrag wird geladen...",
            "sign_contract": "Vertrag unterzeichnen",
            "other_sign_contract": "Anderen Unterzeichner wählen",
            "postpone_signing": "Später unterzeichnen",
            "valid_info": "Sie können nun Ihren Vertrag unterzeichnen.",
            "invalid_info": "Der Vertrag wurde bereits unterzeichnet oder ist abgelaufen.",
            "other_sign_info": "Der Vertrag muss zuerst von der anderen Partei unterzeichnet werden, bevor Sie ihn unterzeichnen können.",
            "title": "Vertragsvorschau",
            "cancel_amendment": "Zusatzvereinbarung stornieren",
            "delete_amendment": "Zusatzvereinbarung löschen",
            "refuse_amendment": "Zusatzvereinbarung ablehnen",
            "cancel_amendment_description": "Sind Sie sicher, dass Sie diese Zusatzvereinbarung stornieren möchten?",
            "cancel_amendment_success": "Die Zusatzvereinbarung wurde erfolgreich storniert",
            "sign_error": "Beim Unterzeichnen des Vertrags ist ein Fehler aufgetreten.",
            "sign_success": "Vertrag erfolgreich unterzeichnet"
        },
        "mission_select_signer": {
            "description": "Wählen Sie eine zeichnungsberechtigte Person aus",
            "error": "Fehler beim Laden der Unterzeichner",
            "contract_sent": "Unterzeichner erfolgreich ausgewählt",
            "contract_send_error": "Fehler beim Versenden des Vertrags",
            "no_other_signers": "Um einen neuen unterzeichnungsberechtigten Kollegen einzuladen, klicken Sie auf „Später unterzeichnen“ und gehen Sie zu Profil → Kollegen → + Kollegen einladen.",
            "send_contract": "Vertrag senden",
            "postpone_signing": "Später unterzeichnen",
            "how_to_invite": "Wie können Sie Ihre Kollegen als Unterzeichner hinzufügen?",
            "title": "Unterzeichner auswählen",
            "invite_colleague": "Unterzeichnenden Kollegen einladen",
            "you": "{{name}} (Sie)"
        },
        "invitation": {
            "title": "Einladung",
            "descriptions": {
                "client": "**{{clientName}}**\n**{{senderName}}** möchte Sie in sein Team einladen.\n<br>\nWenn Sie Ihrem Kollegen beitreten, können Sie Verträge erstellen und Mitarbeiter im Namen Ihres Unternehmens einstellen.\n<br>\nZögern Sie nicht, den [Support zu kontaktieren](intercom://), wenn Sie Fragen haben.",
                "worker": "**{{clientName}}**\n**{{senderName}}** möchte mit Ihnen zusammenarbeiten.\n<br>\nDurch Ihre Zustimmung erlauben Sie {{senderName}}, auf Ihr Profil (Lebenslauf, Diplome, Ausbildungsnachweise) zuzugreifen und Ihnen Arbeitsverträge anzubieten.\n<br>\nZögern Sie nicht, den [Support zu kontaktieren](intercom://), wenn Sie Fragen haben."
            },
            "alerts": {
                "client": {
                    "title": "Das Arbeitgeberprofil für {{clientName}} erstellen",
                    "description": "Um die Einladung anzunehmen, müssen Sie ein Arbeitgeberprofil für das Unternehmen erstellen.",
                    "confirm": "Arbeitgeberprofil erstellen"
                },
                "worker": {
                    "title": "Mitarbeiterprofil erstellen",
                    "description": "Um die Einladung anzunehmen, müssen Sie ein Mitarbeiterprofil erstellen.",
                    "confirm": "Mitarbeiterprofil erstellen"
                }
            },
            "reject": "Ablehnen",
            "accept": "Akzeptieren",
            "ignore": "Ignorieren"
        },
        "mission_annexes": {
            "title": "Anhänge",
            "intro": "Diese vom Arbeitgeber hinzugefügten Dokumente liegen in der alleinigen Verantwortung ihrer Verfasser. Wir prüfen weder ihre Rechtmässigkeit noch ihre Konformität. Bei Widersprüchen hat der mit {{legalEmployerName}}  abgeschlossene Vertrag Vorrang."
        },
        "reject_amendment": {
            "title": "Zusatzvereinbarung ablehnen",
            "description": "Wenn Sie die Zusatzvereinbarung ablehnen möchten, geben Sie bitte den Grund an.",
            "missing_other_reason": "Bitte geben Sie den Grund an.",
            "request_reason": "Grund für den Stornierungsantrag:",
            "reason_label": "Grund",
            "submit": "Zusatzvereinbarung ablehnen",
            "success": "Die Zusatzvereinbarung wurde erfolgreich abgelehnt"
        },
        "cancel_amendment": {
            "title": "Grund angeben",
            "description": "Wenn Sie die Zusatzvereinbarung löschen möchten, geben Sie bitte den Grund an.",
            "missing_other_reason": "Bitte geben Sie den Grund an.",
            "reason_label": "Grund",
            "submit": "Zusatzvereinbarung stornieren",
            "success": "Die Zusatzvereinbarung wurde erfolgreich storniert"
        },
        "client_framework_select_signer": {
            "description": "Wählen Sie eine zeichnungsberechtigte Person",
            "contract_sent": "Unterzeichner erfolgreich ausgewählt",
            "contract_send_error": "Beim Versenden des Vertrags ist ein Fehler aufgetreten.",
            "no_other_signers": "Um einen neuen Kollegen als Unterzeichner einzuladen, klicken Sie auf „Später unterzeichnen“ und gehen Sie dann zu Profil → Kollegen → + Kollegen einladen.",
            "send_contract": "Einfachen Gesellschaftsvertrag zur Unterzeichnung senden",
            "postpone_signing": "Später unterzeichnen",
            "title": "Den Unterzeichner auswählen",
            "error": "Beim Abrufen der Unterzeichner ist ein Fehler aufgetreten.",
            "how_to_invite": "Wie können Sie Ihre Kollegen als Unterzeichner hinzufügen?",
            "invite_colleague": "Einen Kollegen als Unterzeichner einladen",
            "you": "{{name}} (Sie)"
        },
        "client_contact_edit": {
            "title": "Kontaktdaten",
            "description": "Diese Kontaktdaten sind mit Ihrem Unternehmen verknüpft."
        }
    },
    "activities": {
        "actions": {
            "VerifyEmail": "Bestätigungs-E-Mail erneut senden",
            "MissionOnboardingRequired": "Informationen zur Tätigkeit angeben",
            "InvitationNeedResponse": "Auf die Einladung antworten",
            "ContractWorkerNeedSign": "Den Vertrag überprüfen und unterzeichnen",
            "ContractClientNeedSign": "Den Vertrag überprüfen und unterzeichnen",
            "ContractContinueSigning": "Die Vertragsunterzeichnung fortsetzen",
            "WorkerNeedCompletion": "Mein Profil vervollständigen",
            "TimeSheetNeedCompletion": "Meine Stunden erfassen",
            "TimeSheetNeedChanges": "Meine Stunden korrigieren",
            "TimeSheetNeedReview": "Stunden prüfen und bestätigen",
            "PayrollBreakdownNeedCompletion": "Abrechnung ausfüllen",
            "VerifyBusinessEmail": "Die Bestätigungs-E-Mail erneut senden",
            "NeedKyc": "Identität überprüfen",
            "AmendmentWorkerNeedSign": "Prüfen und unterzeichnen",
            "AmendmentClientNeedSign": "Prüfen und unterzeichnen",
            "ClientContractNeedSign": "Vertrag prüfen und unterzeichnen"
        }
    },
    "salary_projection": {
        "gross_salary": "Bruttolohn",
        "net_salary": "Nettolohn",
        "total_invoiced": "Total fakturiert (ohne MwSt.)",
        "info": "Die untenstehenden Beträge sind indikativ berechnet.",
        "footer_variable_fees_not_included": "ohne variable Kosten",
        "worker_payroll_taxes": "Davon Sozialabgaben",
        "client_payroll_taxes": "Inklusive Arbeitgeberbeiträge",
        "client_deduction": "Inklusive Abzüge",
        "worker_deduction": "Davon Abzüge",
        "worker_fees": "Inklusive Pauschalspesen",
        "client_fees": "Inklusive Pauschalspesen"
    },
    "calendar": {
        "mission_title": "Lift-Vertrag %{title}",
        "mission_notes": "Arbeitsvertrag zwischen '%{client}' und '%{worker}' als '%{title}'",
        "mission_added": "Tätigkeit zu Ihrem Kalender hinzugefügt",
        "error_adding": "Fehler beim Hinzufügen der Tätigkeit zu Ihrem Kalender"
    },
    "nationalities": {
        "AL": "Albaner|Albanerin",
        "AD": "Andorraner|Andorranerin",
        "AT": "Österreicher|Österreicherin",
        "BY": "Weißrusse|Weißrussin",
        "BE": "Belgier|Belgierin",
        "BA": "Bosnier|Bosnierin",
        "BG": "Bulgare|Bulgarin",
        "HR": "Kroate|Kroatin",
        "CY": "Zypriot|Zypriotin",
        "CZ": "Tscheche|Tschechin",
        "DK": "Däne|Dänin",
        "EE": "Este|Estin",
        "FI": "Finne|Finnin",
        "FR": "Franzose|Französin",
        "DE": "Deutscher|Deutsche",
        "GR": "Grieche|Griechin",
        "HU": "Ungar|Ungarin",
        "IS": "Isländer|Isländerin",
        "IE": "Ire|Irin",
        "IT": "Italiener|Italienerin",
        "XK": "Kosovare|Kosovarin",
        "LV": "Lette|Lettin",
        "LI": "Liechtensteiner|Liechtensteinerin",
        "LT": "Litauer|Litauerin",
        "LU": "Luxemburger|Luxemburgerin",
        "MK": "Mazedonier|Mazedonierin",
        "MT": "Malteser|Malteserin",
        "MD": "Moldauer|Moldauerin",
        "MC": "Monegasse|Monegassin",
        "ME": "Montenegriner|Montenegrinerin",
        "NL": "Niederländer|Niederländerin",
        "NO": "Norweger|Norwegerin",
        "PL": "Pole|Polin",
        "PT": "Portugiese|Portugiesin",
        "RO": "Rumäne|Rumänin",
        "RU": "Russe|Russin",
        "SM": "San-Marinese|San-Marinesin",
        "RS": "Serbe|Serbin",
        "SK": "Slowake|Slowakin",
        "SI": "Slowene|Slowenin",
        "ES": "Spanier|Spanierin",
        "SE": "Schwede|Schwedin",
        "CH": "Schweizer|Schweizerin",
        "UA": "Ukrainer|Ukrainerin",
        "GB": "Brite|Britin"
    },
    "your_location": "Ihr Standort",
    "image_chooser": {
        "error": "Beim Abrufen der Bilder ist ein Fehler aufgetreten.",
        "invalid_image": "Das ausgewählte Bild konnte nicht hochgeladen werden."
    },
    "webImage": "Bild aus dem Web",
    "confirm": "Bestätigen?",
    "submit": "Einreichen",
    "go_home": "Zurück zur Startseite",
    "iAgree": "Ich akzeptiere",
    "fill_all_fields": "Bitte füllen Sie alle Felder aus.",
    "back": "Zurück",
    "see_more": "Mehr ansehen",
    "permission_denied": "Berechtigung verweigert. Öffnen Sie die Einstellungen Ihres Geräts.",
    "import": "Importieren",
    "work_permit_short": {
        "permit_b": "Aufenthaltsbewilligung B",
        "permit_c": "Niederlassungsbewilligung C",
        "permit_g": "Grenzgängerbewilligung G",
        "permit_l": "Kurzaufenthaltsbewilligung L",
        "permit_n": "Ausweis N",
        "permit_s": "Ausweis S",
        "permit_other": "Andere Bewilligung",
        "in_process": "In Bearbeitung"
    },
    "deduction": {
        "title": "Abzug \"%{description}\""
    },
    "payrollSource": {
        "type": {
            "lift": "Lift-Stundenerfassung",
            "manual_client": "Externe Stundenerfassung",
            "gekos": "Gek'os-Stundenerfassung"
        }
    },
    "payroll_breakdown": {
        "open_info": "Die monatliche Abrechnung wird hier sichtbar, sobald der Mitarbeiter seine Arbeitszeitblätter für diesen Zeitraum ausgefüllt hat.",
        "submitted_info": "Validiert am %{date} • %{name}",
        "waiting_submit": "Wartet auf Bestätigung",
        "error_not_a_number": "Die Eingabe ist inkorrekt",
        "error_not_set": "Bitte geben Sie einen Wert ein",
        "delta_work_info": "Geben Sie an, ob die insgesamt geleisteten Arbeitsstunden unter oder über der im Arbeitsvertrag festgelegten Arbeitszeit liegen.",
        "delta_work_info_action": "Vertragsdetails anzeigen",
        "field_total_vacation_days_title": "Geben Sie an, ob der Mitarbeiter in diesem Zeitraum Ferien bezogen hat.",
        "field_total_vacation_days": "Bezogene Ferientage",
        "field_total_work_days_title": "Geben Sie die Anzahl der gearbeiteten Tage an",
        "field_total_work_days_info": "Diese Anzahl dient zur Berechnung sämtlicher Abzüge und pauschaler Tageskosten. Ferien- oder Abwesenheitstage werden nicht berücksichtigt.",
        "field_total_work_days": "Anzahl der gearbeiteten Tage",
        "field_delta_work": "Geben Sie an, ob der Mitarbeiter Mehr- oder Minderstunden ohne Zuschlag geleistet hat.",
        "field_delta_work_mode_plus": "Auszugleichende Stunden",
        "field_delta_work_mode_minus": "Minderstunden",
        "field_delta_work_mode_zero": "Keine Mehr- oder Minderstunden",
        "field_total_work_title": "Anzahl der in diesem Zeitraum geleisteten Stunden",
        "button_submit": "Abrechnung bestätigen",
        "absence_days_title": "Abwesenheiten",
        "timesheets": "Stundenerfassung",
        "rejected_info": "Abgelehnt am %{date} • %{name}",
        "waiting_fill": "Vom Arbeitgeber auszufüllen",
        "used_vacation_days_info": {
            "zero": "Feriensaldo zum %{date}: 0 Tag",
            "one": "Feriensaldo zum %{date}: %{count} Tag",
            "other": "Feriensaldo zum %{date}: %{count} Tage"
        },
        "used_vacation_hours_info": {
            "zero": "Saldo zum %{date}: 0 Stunde",
            "one": "Saldo zum %{date}: %{count} Stunde",
            "other": "Saldo zum %{date}: %{count} Stunden"
        },
        "vacancy_by_days": "Tage",
        "vacancy_by_hours": "Stunden",
        "field_total_vacation_hours": "Ferienstunden",
        "nav_title": "Monatliche Abrechnung",
        "nav_title_no_repetition": "Abrechnung",
        "fees_and_deductions": "Details zu Kosten und/oder Abzügen",
        "field_variable_fee_count": "Geben Sie die Anzahl der \"{{feeName}}\" an, die berücksichtigt werden sollen",
        "field_variable_fee_count_info": "{{feeCount}} brutto pro Vorkommen, d.h. {{withTaxes}} inkl. Abgaben",
        "delta_work_hours_info": "Stundensaldo: **{{symbol}} {{deltaWorkHours}}h ({{overtimeAmount}})**",
        "overtime_paid_125_150": {
            "title": "Geben Sie an, ob der Mitarbeiter Überstunden mit Zuschlag geleistet hat.",
            "description": "Ab einem bestimmten Schwellenwert müssen Überstunden zu einem erhöhten Satz vergütet werden. [Regeln für die Bezahlung von Überstunden](intercom://10485414)",
            "link": "Regeln zur Kompensation gemäss GAV"
        },
        "overtime_125": "Überstunden zu 125%",
        "overtime_150": "Überstunden zu 150%",
        "worked_hours": {
            "title": "Geleistete Arbeitsstunden",
            "description": "Die Abrechnung muss Überstunden berücksichtigen. Diese können zu einem Zuschlag von 25 % bis 50 % führen.",
            "link": "Ausgleichsregeln gemäss GAV"
        },
        "edit": "Bearbeiten",
        "overtime_plus_25": "Überstundenzuschlag +25%",
        "overtime_plus_50": "Überstundenzuschlag +50%",
        "used_vacation_days_overflow": "Die bezogenen Ferientage dürfen das verfügbare Guthaben von {{count}} Tagen nicht überschreiten.",
        "used_vacation_hours_overflow": "Die bezogenen Ferienstunden dürfen das verfügbare Guthaben von {{count}} Stunden nicht überschreiten.",
        "next_to_validate_info": "Die Abrechnung kann ausgefüllt werden, sobald der Mitarbeiter seine Arbeitsstunden für diesen Zeitraum geleistet hat.",
        "overtime_paid_too_high": "Sie können nicht mehr Stunden abrechnen als die aktuell vorhandenen Überstunden ({{deltaWorkHours}}h)",
        "field_total_work_days_error": "Die Anzahl der geleisteten Tage ist ungültig",
        "field_totalWork100Hours": "Stunden zu 100%",
        "field_totalWork125Hours": "Stunden zu 125%",
        "field_totalWork150Hours": "Stunden zu 150%",
        "error": {
            "max_vacation_days": "Die Anzahl bezogener Ferientage darf {{maxWorkDays}} nicht überschreiten.",
            "total_work_days": "Die Anzahl Arbeitstage darf {{maxWorkDays}} nicht überschreiten.",
            "min_total_work_days": "Die Anzahl Arbeitstage darf nicht unter {{minWorkDays}} liegen."
        },
        "field_totalWork200": "Stunden zu 200%",
        "dynamic_fees": "Pauschalspesen",
        "field_delta_work_description": "Überstunden ohne Zuschlag (100 %) werden dem Ferienguthaben gutgeschrieben. Dieses kann ganz oder teilweise an den Mitarbeiter ausbezahlt und dem Arbeitgeber in Rechnung gestellt werden.",
        "field_total_work_days_description": "Diese Anzahl bildet die Grundlage für die Berechnung der Abzüge und der täglichen Pauschalspesen, ausgenommen Ferien- und Abwesenheitstage.",
        "extras": "Zusatzleistungen",
        "enter_absence": "Abwesenheit erfassen",
        "refund_or_pay": "Erstatten / bezahlen",
        "pay_bonus": "Bonus auszahlen",
        "refund_effective_fees": "Effektive Spesen erstatten",
        "refund_effective_fees_description": "Diese Kosten betreffen einzelne Spesen, die im betreffenden Zeitraum erfasst wurden.",
        "pay_overtime_work": "Überstunden bezahlen (+{{overtimeDeltaHours}})",
        "monthly": {
            "delta_work": {
                "title": "Geben Sie an, ob der Mitarbeiter mehr oder weniger Stunden (ohne Zuschlag) gearbeitet hat.",
                "description": "Eine gewisse Flexibilität ist möglich: Es kann in einer Woche mehr und in der nächsten weniger gearbeitet werden, solange der Monatsdurchschnitt dem Vertrag entspricht."
            },
            "overtime_paid": {
                "title": "Geben Sie an, ob der Mitarbeiter Überstunden mit Zuschlag geleistet hat.",
                "description": "Ab einem bestimmten Schwellenwert müssen Überstunden mit einem Zuschlag vergütet werden. Regeln zur Vergütung von Überstunden."
            },
            "vacations": {
                "title": "Geben Sie an, ob der Mitarbeiter in diesem Zeitraum Ferien bezogen hat."
            },
            "worked_days": {
                "description": "Diese Anzahl dient als Grundlage für die Berechnung der Abzüge und der täglichen Pauschalspesen, ausgenommen Ferien- und Abwesenheitstage."
            }
        },
        "hourly": {
            "delta_work": {
                "title": "Geben Sie an, ob der Mitarbeiter mehr (ohne Zuschlag) oder weniger Stunden geleistet hat.",
                "description": "Eine gewisse Flexibilität ist möglich: Es kann in einer Woche mehr und in der nächsten weniger gearbeitet werden, solange der Monatsdurchschnitt dem Vertrag entspricht."
            },
            "overtime_paid": {
                "title": "Geben Sie die Anzahl der geleisteten Stunden an: Bürozeiten (100 %) oder Überstunden mit Zuschlag (125 %, 150 %).",
                "description": "Jede Arbeitsstunde ausserhalb der üblichen Bürozeiten wird mit einem Zuschlag von 125 % oder 150 % vergütet. Regeln gemäss GAV"
            },
            "vacations": {
                "title": "Geben Sie an, ob der Mitarbeiter in diesem Zeitraum Ferien bezogen hat."
            },
            "worked_days": {
                "description": "Diese Zahl dient zur Berechnung der Abzüge und Pauschalspesen. Ferien- oder Abwesenheitstage werden nicht berücksichtigt."
            }
        },
        "overtime_200": "Überstunden zu 200%",
        "field_totalWork200Hours": "Stunden zu 200%",
        "overtime_plus_100": "Überstunden Zuschlag +100%",
        "overtime_plus_15": "Überstundenzuschlag +15%",
        "nav_title_final_settlement": "Schlussabrechnung",
        "field_totalWork115Hours": "Stunden 115%",
        "overtime_115": "Überstunden 115%",
        "pending_amendment_warning": {
            "title": "Zusatzvereinbarung wartet auf Validierung",
            "awaiting_client": "Die Zusatzvereinbarung wartet derzeit auf Ihre Unterschrift, wodurch der Versand der Abrechnung blockiert ist.",
            "awaiting_worker": "Die Zusatzvereinbarung wartet derzeit auf die Unterschrift des Mitarbeiters, wodurch der Versand der Abrechnung blockiert ist. Zögern Sie nicht, den Mitarbeiter zu kontaktieren, um die Situation zu klären.",
            "awaiting_basquiat": "Die Zusatzvereinbarung wartet derzeit auf die Unterschrift unseres Teams. Diese wird in Kürze erfolgen, sodass die Abrechnung schnellstmöglich versendet werden kann."
        },
        "used_vacation_minutes_info": {
            "zero": "Saldo zum %{date}: 0 Minute",
            "one": "Saldo zum %{date}: %{count} Minute",
            "other": "Saldo zum %{date}: %{count} Minuten"
        },
        "vacancy_by_minutes": "Minuten",
        "used_vacation_minutes_overflow": "Die bezogenen Ferienstunden dürfen das verfügbare Guthaben von {{count}} Minuten nicht überschreiten.",
        "vacation_by_days": "Tage",
        "vacation_by_hours": "Stunden",
        "vacation_by_minutes": "Minuten",
        "field_variable_fee_count_with_unit": "Geben Sie die Anzahl der {{perUnit}} für \"{{feeName}}\" an, die berücksichtigt werden sollen",
        "pay_auxiliary_salary": "Eine Nebentätigkeit bezahlen",
        "pay_auxiliary_salary_description": "Pauschalbetrag für eine Nebentätigkeit (Empfang, Öffnen des Studios usw.), inklusive aller Entschädigungen."
    },
    "absence": {
        "add_title": "Abwesenheit erfassen",
        "remove_title": "Abwesenheit löschen",
        "remove_info": "Sind Sie sicher, dass Sie diese Abwesenheit löschen möchten?",
        "remove_action": "Ja, löschen",
        "field_type": "Grund der Abwesenheit",
        "field_start": "Startdatum",
        "field_end": "Enddatum",
        "field_description": "Kommentar",
        "error_end_before_start": "Das Enddatum muss nach dem Startdatum liegen.",
        "type": {
            "military": "Militärdienst",
            "sickness": "Krankheit",
            "accident": "Unfall",
            "maternity": "Mutterschaft/Vaterschaft",
            "training": "Ausbildung",
            "sickness_close_relative": "Krankheit eines Angehörigen",
            "death_close_relative": "Todesfall eines Angehörigen",
            "marriage": "Heirat",
            "moving": "Umzug",
            "other": "Sonstiges"
        },
        "title": "Abwesenheit",
        "timeFromTo": "{{from}} bis {{to}}"
    },
    "assistance": "Support",
    "pendingVerification": {
        "soon": "Wir freuen uns, Sie bei Lift begrüßen zu dürfen!",
        "change_profile": "Profil wechseln"
    },
    "webImageDownloadError": "Fehler beim Herunterladen des Bildes",
    "optional": "Optional",
    "profile_switch": {
        "on_change": {
            "client": "Arbeitgeberprofil {{name}} aktiviert",
            "private_client": "Privatarbeitgeberprofil aktiviert",
            "worker": "Mitarbeiterprofil aktiviert"
        },
        "not_found": "Das zugehörige Profil wurde nicht gefunden"
    },
    "login": "Anmelden",
    "ijm": {
        "top_text": "Die Versicherung der Groupe Mutuel deckt 80% des Bruttolohns in Form von Taggeldern im Krankheitsfall, nach Ablauf der Wartefrist.",
        "ijm_group": {
            "title": "Wählen Sie die Wartefrist",
            "info": "Je kürzer die Wartefrist, desto höher der Beitrag.",
            "place_holder": "Wählen Sie die Wartefrist"
        },
        "ijm_plan_title": "Planeinstellungen",
        "ijm_pay_first_days": {
            "info": "Möchten Sie den Lohn während der ersten 2 Krankheitstage übernehmen?",
            "in_list": {
                "yes": "Erste 2 Tage bezahlt",
                "no": "Erste 2 Tage nicht bezahlt"
            },
            "select": {
                "yes": "Ja, ich übernehme die ersten 2 Tage",
                "no": "Nein, ich übernehme diese nicht",
                "place_holder": "Deckungswahl"
            }
        },
        "ijm_pay_remaining_percents": {
            "info": "Nach Ablauf der Wartefrist übernimmt die Versicherung 80% des Bruttolohns. Möchten Sie einen Teil des restlichen Lohns übernehmen?",
            "place_holder": "Wählen Sie den Prozentsatz",
            "chooser": {
                "0": "80% (0% vom Arbeitgeber bezahlt)",
                "10": "90% (+10% vom Arbeitgeber bezahlt)",
                "20": "100% (+20% vom Arbeitgeber bezahlt)"
            },
            "in_list": {
                "0": "Taggelder: 80%",
                "10": "Taggelder: 90% (+10%)",
                "20": "Taggelder: 100% (+20%)"
            },
            "select": {
                "0": "Nein, die Versicherung deckt 80 % des Lohns.",
                "10": "Ja, ich ergänze auf 90 % (zusätzliche 10 %)",
                "20": "Ja, ich ergänze auf 100 % (restliche 20 %)",
                "place_holder": "Zusatzdeckung wählen"
            }
        },
        "profile": {
            "title": "Krankentaggeld (KTG)-Plan",
            "to_complete": "Zu vervollständigen",
            "missing_group": "Kein Plan ausgewählt"
        },
        "mission": {
            "title": "Krankentaggeld (KTG)-Plan"
        },
        "contact_support_text": "Für Änderungen wenden Sie sich bitte an den Support.",
        "contact_support_action": "Support",
        "screen_title": "KTG",
        "save_success": "Die Planeinstellungen wurden gespeichert",
        "editor": {
            "root": {
                "title": "Wählen Sie die passende Krankentaggelddeckung für Ihren Mitarbeiter.",
                "text_1": "In der Schweiz ist der Arbeitgeber verpflichtet, bei krankheitsbedingter Arbeitsunfähigkeit den Lohn weiterzuzahlen.\n\nIm Personalverleih umfasst dies den Abschluss einer Krankentaggeldversicherung (KTG), die bei längerer Krankheit den Lohn übernimmt.",
                "title_2": "Bitte wählen Sie die passende Deckung",
                "collaboration": "In Zusammenarbeit mit",
                "wantIjm": "Möchten Sie für Ihren Mitarbeiter eine Krankentaggeldversicherung (KTG) abschliessen?",
                "text_lse": "In der Schweiz ist der Arbeitgeber verpflichtet, den Lohn bei krankheitsbedingter Arbeitsunfähigkeit weiterzuzahlen.\n\nIm Rahmen des Personalverleihs umfasst diese Pflicht den Abschluss einer Krankentaggeldversicherung (KTG), die den Lohn bei längerer Krankheit übernimmt.",
                "text_is_mandatory": "In der Schweiz ist der Arbeitgeber verpflichtet, den Lohn bei krankheitsbedingter Arbeitsunfähigkeit weiterzuzahlen.\n\nIm Rahmen des GAV {{cctName}} umfasst diese Pflicht den Abschluss einer Krankentaggeldversicherung (KTG), die den Lohn bei längerer Krankheit übernimmt.",
                "text_not_mandatory": "In der Schweiz ist der Arbeitgeber verpflichtet, den Lohn bei krankheitsbedingter Arbeitsunfähigkeit weiterzuzahlen.\n\nSie haben die Möglichkeit, eine Krankentaggeldversicherung (KTG) abzuschliessen, die den Lohn bei längerer Krankheit übernimmt.",
                "no_lse_comment": "Achtung: Die Lohnfortzahlung während der Wartefrist sowie der notwendige Zuschlag zur Erreichung des gesetzlichen oder vertraglichen Minimums bleiben zu Ihren Lasten, auch wenn Sie sich entscheiden, keinen Zusatz über die 80 % der KTG hinaus zu zahlen."
            },
            "group_select": {
                "title": "Wählen Sie die Wartefrist",
                "text_1": "Die KTG-Versicherung zahlt 80 % des Lohns nach einer Wartefrist. Während dieser Zeit zahlen Sie den Lohn Ihres Mitarbeiters weiter.\n\nBeispiel: Bei einer Wartefrist von 30 Tagen übernehmen Sie den Lohn während der ersten 30 Krankheitstage.",
                "title_2": "Wählen Sie eine der drei Optionen",
                "renew_text": "Die gewählte Option gilt für alle Ihre Mitarbeiter auf Lift. Sie können diese jeweils zu Jahresbeginn über den Support anpassen."
            },
            "waiting_select": {
                "title": "Möchten Sie die ersten 2 Krankheitstage übernehmen?",
                "text_1": "Die ersten 2 Krankheitstage (Karenztage) werden nicht durch die KTG-Versicherung gedeckt.\n\nSie können diese jedoch ganz oder teilweise selbst übernehmen, um Ihrem Mitarbeiter ein durchgehendes Einkommen zu sichern.",
                "title_2": "Wählen Sie eine Option"
            },
            "cover_select": {
                "title": "Möchten Sie die verbleibenden 20% des Lohns auszahlen?",
                "text_1": "Die KTG-Versicherung übernimmt im Krankheitsfall 80 % des Bruttolohns.\n\nSie haben die Möglichkeit, die verbleibenden 20 % ganz oder teilweise zu ergänzen, damit Ihr Mitarbeiter weiterhin bis zu 100 % seines üblichen Lohns erhält.",
                "title_2": "Wählen Sie eine der folgenden 3 Optionen"
            }
        },
        "data": {
            "descriptions": {
                "item_1": {
                    "zero": "",
                    "one": "",
                    "other": "Die Versicherung beginnt am {{count}}. Tag"
                },
                "item_2": "Lohnzahlung vom {{payFromDay}} bis {{payToDay}}",
                "item_3": "Prämie: {{percent}}% des Bruttolohns, d.h. {{amount}}",
                "item_3b": "Prämie: {{percent}}% des Bruttolohns",
                "item_2_nothing_to_pay": "Kein Lohn zu zahlen"
            }
        },
        "configuration_list": {
            "screen_title": "KTG-Pläne",
            "no_cct": "Ohne GAV",
            "all_workers": "Alle Mitarbeiter",
            "group": "Gruppe {{group}}",
            "no_plans": "Kein Plan konfiguriert",
            "no_plans_description": "Für Ihr Unternehmen wurde keine KTG-Konfiguration festgelegt.",
            "no_ijm": "Keine KTG",
            "no_cct_lse": "Personalverleih"
        },
        "no_ijm": "Keine KTG-Versicherung ausgewählt",
        "viewer": {
            "root": {
                "text_1": "Hier ist die aktuelle Konfiguration Ihres KTG-Plans. Kontaktieren Sie den Support bei Fragen oder Änderungen.",
                "collaboration": "In Zusammenarbeit mit",
                "no-ijm": "Für diese Gruppe \"{{cctLabel}}“ ist kein KTG-Plan angewendet."
            },
            "group_select": {
                "title": "Wartefrist"
            },
            "waiting_select": {
                "title": "Deckung der ersten 2 Krankheitstage?"
            },
            "cover_select": {
                "title": "Zahlung der verbleibenden 20% des Lohns?"
            }
        }
    },
    "type_to_search": "Geben Sie die ersten drei Buchstaben ein, um die Suche zu starten.",
    "no_result": "Leider entspricht kein Ergebnis Ihrer Suche.",
    "add": "Hinzufügen",
    "seeMore": "Mehr anzeigen",
    "seeLess": "Weniger anzeigen",
    "bonus": {
        "title": "Bonus",
        "add_title": "Einen Bonus für den Mitarbeiter hinzufügen",
        "amount_title": "Bitte geben Sie den Bonusbetrag an",
        "amount_subtitle": "Boni unterliegen den Sozialabgaben, jedoch nicht der BVG.",
        "amount_with_social_charges": "{{amount}} inkl. Abgaben",
        "remove_title": "Bonus löschen",
        "remove_info": "Sind Sie sicher, dass Sie den Bonus löschen möchten?",
        "remove_action": "Ja, löschen",
        "field_description": "Beschreibung des Bonus"
    },
    "effective_fee": {
        "title": "Effektive Spesen",
        "add_title": "Effektive Spesen hinzufügen",
        "amount_title": "Bitte geben Sie den zu erstattenden Betrag an",
        "remove_title": "Diese Spesen löschen",
        "remove_info": "Sind Sie sicher, dass Sie diese Spese löschen möchten?",
        "remove_action": "Ja, löschen",
        "field_description": "Beschreibung"
    },
    "veriff": {
        "generic_error": "Keine Veriff-Sitzungs-URL, bitte setzen Sie Ihr KYC zurück",
        "title": "Identitätsprüfung"
    },
    "dateTimeAt": "{{date}} bis {{time}}",
    "overtimePaid": {
        "title": "Stundensaldo",
        "add_title": "Überstunden anzeigen",
        "amount_title": "Bitte geben Sie die Anzahl der Stunden an, die Sie kompensieren möchten.",
        "delta_work_hours_info": "Stundensaldo: **{{symbol}} {{deltaWorkHours}}h ({{overtimeAmount}})**",
        "hours_equivalent": "{{hours}}h entspricht {{amount}}",
        "pay_hours": {
            "zero": "",
            "one": "{{hours}} Überstunde auszahlen ({{amount}})",
            "other": "{{hours}} Überstunden auszahlen  ({{amount}})"
        },
        "remove_title": {
            "zero": "",
            "one": "Überstunde löschen",
            "other": "Überstunden löschen"
        },
        "remove_info": {
            "zero": "",
            "one": "Sind Sie sicher, dass Sie diese Überstunde löschen möchten?",
            "other": "Sind Sie sicher, dass Sie diese Überstunden löschen möchten?"
        },
        "remove_action": "Ja, löschen",
        "overtime_paid_too_high": "Maximale Stundenanzahl: {{deltaWorkHours}}h",
        "description_intro_by_cct": {
            "default": "Der untenstehende Saldo zeigt die Anzahl normaler Stunden (100 %), die seit Beginn der Tätigkeit mehr oder weniger geleistet wurden.",
            "paysagiste": "Der untenstehende Saldo zeigt die Anzahl Stunden mit 125 % Zuschlag (gemäss GAV Landschaftsbau VD), die seit Beginn der Tätigkeit mehr oder weniger geleistet wurden."
        },
        "description_end": "Dabei handelt es sich um normale Arbeitsstunden, die seit Beginn der Tätigkeit zusätzlich geleistet wurden. Diese können entweder ausbezahlt oder durch entsprechenden Freizeitausgleich kompensiert werden."
    },
    "clear": "Zurücksetzen",
    "delete": "Löschen",
    "done": "Abgeschlossen",
    "browser_recommendation": "Um eine reibungslose Nutzung zu gewährleisten, empfehlen wir Ihnen, die Browser Safari oder Chrome zu verwenden.\nSo können Sie alle Funktionen unserer Plattform optimal nutzen.",
    "version_informations": "Informationen zu dieser Version",
    "ok": "OK",
    "prevent_going_back": {
        "go_back": "Seite verlassen?",
        "quit": "Verlassen",
        "informations_might_not_be_saved": "Die eingegebenen Daten werden möglicherweise nicht gespeichert.“"
    },
    "confirm_question": "Bestätigen?",
    "timePeriod": {
        "monthly": "{{amount}} / Monat",
        "hourly": "{{amount}} / Stunde",
        "daily": "{{amount}} / Tag",
        "package": "{{amount}} / Vertrag"
    },
    "custom_name": "Benutzerdefinierter Name",
    "cct_labels": {
        "no_cct_lse": "Personalverleih",
        "no_cct": "Ohne GAV"
    },
    "alerts": {
        "mission_needs_signature": {
            "title": "Unterschrift erforderlich",
            "description": "Der Vertrag ist in Kraft getreten. Es fehlt nur noch Ihre Unterschrift, um Ihre Situation zu formalisieren.",
            "sign_contract": "Vertrag unterzeichnen",
            "view_contract": "Vertrag anzeigen"
        }
    },
    "language": {
        "change": "Sprache ändern",
        "service_changed": "Der Service ist jetzt auf Deutsch.",
        "update_error": "Die Sprache konnte nicht geändert werden.",
        "name": {
            "fr": "Französisch",
            "de": "Deutsch"
        }
    },
    "auxiliary_salary": {
        "title": "Nebentätigkeit",
        "field_description": "Beschreibung der Nebentätigkeit",
        "hours_title": "Bitte geben Sie die Anzahl der durch diese Pauschale abgedeckten Stunden an",
        "amount_title": "Bitte geben Sie den Bruttobetrag der Pauschale an",
        "amount_subtitle": "Alles inbegriffen: Ferien- und Feiertagsentschädigungen sind enthalten."
    }
}
